import {TranslationTree} from '../types';

const es: TranslationTree = {
    premiumRoyalties: {
        "accrued": "Acumulado este mes",
        "accruedNote": "Estimación antes de límites y revisión; no disponible para retirar.",
        "held": "Pendiente de revisión",
        "heldNote": "Incluye meses anteriores. Los importes retenidos requieren aprobación.",
        "adjustments": "Ajustes del mes",
        "adjustmentsNote": "Reducciones por límites y cambios en la financiación.",
        "settlementNote": "Las regalías se abonan al cierre del mes y tras su aprobación; se liberan después del plazo de liquidación configurado.",
        "pending": "Regalías pendientes",
        "externalNotice": "Solo la visualización dentro de VocalCentric puede generar regalías. Abrir o descargar este archivo no cuenta.",
        "offlineNotice": "Las regalías requieren conexión. La reproducción sin conexión no cuenta.",
        "internalNote": "Las regalías de canciones internas siguen el proceso de pago a artistas y socios.",
        "available": "Saldo disponible"
},
    live: {
        "director": "Director",
        "directorControls": "Controles del director",
        "directorHint": "Estos controles silencian los micrófonos para todos y detienen su grabación. Cada cantante puede volver a activar su micrófono.",
        "muteSection": "Silenciar sección",
        "muteForEveryone": "Silenciar para todos",
        "endForEveryone": "Finalizar para todos",
        "endConfirm": "¿Finalizar este ensayo para todos? Se detendrá la toma activa y todos saldrán de la llamada.",
        "notifyPending": "Estás conectado. Las notificaciones a los miembros están pendientes; volveremos a intentarlo automáticamente.",
        "liveNow": "En vivo ahora",
        "liveNowJoin": "En vivo · Unirse",

        "openRoom": "Abrir ensayo en vivo",
        "viewRoom": "Ver llamada",
        "beforeJoin": "Antes de unirte",
        "you": "Tú",
        "muted": "Micrófono apagado",
        "closePreview": "Cerrar vista previa",
        "mixer": "Tu mezcla",
        "joining": "Uniéndose…",
        "ended": "Este ensayo ha finalizado.",
        "noOtherParticipants": "Los demás cantantes aparecerán aquí cuando se unan.",
        "noTakes": "Aún no hay grabaciones.",
        "captureUnavailable": "La grabación no está disponible. Puedes seguir ensayando en directo.",
        "armed": "Captura preparada",
        "timing": "Estimación del reloj (± ms)",
        "timingHint": "La alineación de la grabación es aproximada. Revisa cada toma antes de publicarla; aún hay que calibrar la latencia del dispositivo y del audio.",
        "publishHint": "La publicación actualiza las voces seleccionadas de esta sección de la canción.",
        "quality": "Conexión de audio",
        "excellent": "Excelente",
        "good": "Buena",
        "poor": "Deficiente",
        "lost": "Perdida",
        "unknown": "Midiendo",
        "title": "Ensayo en directo",
        "start": "Iniciar ensayo en directo",
        "join": "Unirse al ensayo",
        "headphones": "Estoy usando auriculares con cable.",
        "headphonesWarning": "Los auriculares con cable ofrecen la mejor sincronización. Los altavoces pueden causar eco o acoples, y Bluetooth puede añadir retraso. Baja el volumen de los altavoces y silencia el micrófono cuando no cantes.",
        "consent": "Permitir grabar mi micrófono para la Armonía personalizada. Apagar el micrófono detiene la grabación.",
        "waiting": "Esperando a que el director inicie el ensayo.",
        "reopen": "Reabrir ensayo",
        "connected": "Conectado",
        "recording": "Grabando micrófono",
        "monitorHint": "Estos controles solo cambian lo que escuchas. No afectan a los demás ni a las grabaciones.",
        "volume": "Volumen",
        "mute": "Silenciar",
        "solo": "Solo",
        "soprano": "Soprano",
        "alto": "Contralto",
        "tenor": "Tenor",
        "bass": "Bajo",
        "unassigned": "Sin asignar",
        "micOff": "Apagar micrófono",
        "micOn": "Encender micrófono",
        "retryUploads": "Reintentar subidas guardadas",
        "leave": "Salir del ensayo",
        "song": "Canción",
        "section": "Sección de la canción",
        "record": "Grabar toma",
        "stop": "Detener toma",
        "end": "Finalizar ensayo",
        "refreshTakes": "Actualizar tomas",
        "takes": "Tomas grabadas",
        "selectTake": "Seleccionar toma",
        "publish": "Crear Armonía personalizada",
        "joinFailed": "No se pudo conectar. Revisa el permiso del micrófono e inténtalo de nuevo.",
        "commandFailed": "El ensayo cambió o falló la acción. Actualiza e inténtalo de nuevo.",
        "connectionLost": "Conexión interrumpida. La grabación puede continuar localmente mientras la aplicación esté activa.",
        "captureFailed": "No se pudo continuar grabando. Se conserva el audio guardado. Vuelve a unirte para la siguiente toma.",
        "uploadPending": "El audio está guardado en este dispositivo. Reintenta la subida al conectarte.",
        "published": "Armonía personalizada creada. Abre el reproductor de Armonía de la canción para practicar.",
        "publishFailed": "Selecciona una grabación lista por voz de la misma toma e inténtalo de nuevo."
},
    common: {
        login: 'Iniciar sesión',
        register: 'Registrarse',
        signUp: 'Crear cuenta',
        proceed: 'Continuar',
        confirm: 'Confirmar',
        verify: 'Verificar',
        forgotPassword: 'Olvidé mi contraseña',
        settings: 'Configuración',
        logout: 'Cerrar sesión',
        profile: 'Perfil',
        myApplications: 'Mis solicitudes',
        myInvites: 'Mis invitaciones',
        operationSuccessful: 'Operación exitosa',
        yourEmail: 'tu correo',
        resendOtp: 'Reenviar OTP',
        resendOtpIn: 'Reenviar OTP en {{time}}',
        preferences: 'Preferencias',
        preferredCurrency: 'Moneda preferida',
        preferredLanguage: 'Idioma preferido',
        saveCurrency: 'Guardar moneda',
        saveLanguage: 'Guardar idioma',
        save: 'Guardar',
        tryAgain: 'Intentar de nuevo',
        share: 'Compartir',
        cancel: 'Cancelar',
        close: 'Cancelar',
        delete: 'Eliminar',
        loading: 'Cargando...',
    },
    auth: {
        welcomeBack: '¡Bienvenido de nuevo!',
        loginSubtitle: 'Ingresa tus datos para acceder a tu panel',
        email: 'Correo electrónico',
        password: 'Contraseña',
        enterYourEmail: 'Ingresa tu correo',
        enterYourPassword: 'Ingresa tu contraseña',
        noAccount: '¿No tienes una cuenta?',
        haveAccount: '¿Ya tienes una cuenta?',
        alreadyHaveAccount: '¿Ya tienes una cuenta?',
        forgotPasswordPrompt: 'Ingresa tu correo electrónico',
        welcomeToVocalcentric: '¡Bienvenido a VocalCentric!',
        registerSubtitle: 'Ingresa tus datos para crear una cuenta',
        registerSubtitleMinimal: 'Crea tu cuenta en segundos',
        selectPart: 'Selecciona parte',
        firstName: 'Nombre',
        lastName: 'Apellido',
        username: 'Nombre de usuario',
        phoneNumber: 'Número de teléfono',
        firstNamePlaceholder: 'Nombre',
        lastNamePlaceholder: 'Apellido',
        usernamePlaceholder: 'Nombre de usuario',
        phonePlaceholder: 'Teléfono',
        confirmPassword: 'Confirmar contraseña',
        confirmPasswordPlaceholder: 'Confirma tu contraseña',
        referral: 'Referencia',
        confirmOtp: 'Confirmar OTP',
        otpPrompt: 'Ingresa el OTP enviado a {{email}}',
        forgotPasswordTitle: 'Olvidé mi contraseña',
        newPassword: 'Nueva contraseña',
        newPasswordSubtitle: 'Ingresa tu nueva contraseña',
    },
    modals: {
        mobileAppRequired: {
            afterInstall: 'Después de instalar, vuelve a abrir este enlace y toca «Abrir app» para continuar donde lo dejaste.',
            title: 'Continúa en la app',
            description: 'Para la mejor experiencia móvil, abre la app.',
            openApp: 'Abrir app',
            playStore: 'Google Play',
            appStore: 'App Store',
            continueWeb: 'Continuar en la web',
            close: 'Cerrar aviso de app móvil',
        },
        manageServiceTypes: {
            title: 'Gestionar tipos de servicio',
            description: 'Crea, actualiza o elimina los tipos de servicio personalizados que este coro usa para programar.',
            loading: 'Cargando tipos de servicio...',
            noDescription: 'Sin descripción',
            empty: 'Aún no se han agregado tipos de servicio personalizados para este coro.',
            emptyHint: 'Usa el formulario de la derecha para agregar el primero.',
            edit: 'Editar',
            delete: 'Eliminar',
            editServiceType: 'Editar tipo de servicio',
            createServiceType: 'Crear tipo de servicio',
            editHint: 'Actualiza los detalles del tipo de servicio abajo.',
            createHint: 'Agrega un nuevo tipo de servicio personalizado para este coro.',
            name: 'Nombre',
            namePlaceholder: 'p. ej. Servicio del domingo',
            descriptionLabel: 'Descripción',
            descriptionPlaceholder: 'Nota opcional sobre para qué es este tipo de servicio.',
            recurrence: 'Recurrencia',
            weekday: 'Día de la semana',
            firstServiceDate: 'Primera fecha de servicio',
            monthlyPattern: 'Patrón mensual',
            dayOfMonth: 'Día del mes',
            weekOfMonth: 'Semana del mes',
            month: 'Mes',
            day: 'Día',
            serviceDate: 'Fecha del servicio',
            recurrencePreview: 'Vista previa de recurrencia',
            monthlyModesHint: 'Usa “N.º día de semana del mes” para horarios como 1er jueves, 2do jueves o 5to jueves.',
            saving: 'Guardando...',
            creating: 'Creando...',
            saveChanges: 'Guardar cambios',
            confirmDeleteDescription: 'Eliminar este tipo de servicio también quitará las asignaciones de días que lo usan. ¿Deseas continuar?',
            updateAction: 'actualizar',
            createAction: 'crear',
            weekdays: {sunday: 'Domingo', monday: 'Lunes', tuesday: 'Martes', wednesday: 'Miércoles', thursday: 'Jueves', friday: 'Viernes', saturday: 'Sábado'},
            months: {january: 'Enero', february: 'Febrero', march: 'Marzo', april: 'Abril', may: 'Mayo', june: 'Junio', july: 'Julio', august: 'Agosto', september: 'Septiembre', october: 'Octubre', november: 'Noviembre', december: 'Diciembre'},
            weekOrdinals: {first: '1.ª', second: '2.ª', third: '3.ª', fourth: '4.ª', fifth: '5.ª'},
            recurrenceTypes: {weekly: 'Semanal', biweekly: 'Quincenal', monthly: 'Mensual', annual: 'Anual', oneTime: 'Una vez'},
            monthlyModes: {dayOfMonth: 'Día fijo del mes', nthWeekday: 'N.º día de semana del mes'},
            summary: {
                weeklyOn: 'Semanal los {{weekday}}',
                biweeklyOn: 'Quincenal los {{weekday}}',
                biweeklyFrom: 'Quincenal los {{weekday}}{{suffix}}',
                fromDate: ' desde {{date}}',
                monthlyNthWeekday: 'Mensual el {{ordinal}} {{weekday}}',
                monthlyDay: 'Mensual el día {{day}}',
                annualOn: 'Anual el {{day}} de {{month}}',
                oneTimeOn: 'Una vez el {{date}}',
                oneTimeNotSet: 'Fecha única de servicio no establecida',
                noRecurrence: 'Sin recurrencia configurada',
            },
            validation: {
                enterName: 'Ingresa un nombre para el tipo de servicio',
                chooseWeekday: 'Elige un día de la semana',
                chooseFirstServiceDate: 'Elige la primera fecha de servicio',
                chooseDayOfMonth: 'Elige el día del mes',
                chooseWeekOfMonth: 'Elige la semana del mes',
                chooseMonthAndDay: 'Elige el mes y el día',
                chooseServiceDate: 'Elige la fecha del servicio',
            },
            toast: {
                loadFailed: 'No se pudieron cargar los tipos de servicio',
                updated: 'Tipo de servicio actualizado',
                created: 'Tipo de servicio creado',
                saveFailed: 'No se pudo {{action}} el tipo de servicio',
                deleted: 'Tipo de servicio eliminado',
                deleteFailed: 'No se pudo eliminar el tipo de servicio',
            },
        },
        whitelist: {
            status: {
                approvedTitle: 'Solicitud aprobada',
                pendingTitle: 'Solicitud pendiente',
                rejectedTitle: 'Solicitud rechazada',
                applyTitle: 'Solicitar whitelist',
                reapplyTitle: 'Volver a solicitar whitelist',
                approvedMessage: 'Tu solicitud de whitelist fue aprobada. Ahora puedes acceder a las herramientas de perfil profesional.',
                pendingMessage: 'Tu solicitud está pendiente. Un administrador la revisará en las próximas 48 horas.',
                rejectedMessage: 'Tu solicitud anterior no fue aprobada. Puedes actualizar tus datos y volver a solicitar.',
            },
            applicationStatus: 'Estado de solicitud',
            fillToApply: 'Completa correctamente para aplicar.',
            closeAria: 'Cerrar modal de solicitud de whitelist',
            loadingStatus: 'Cargando estado de la solicitud...',
            uploadHint: 'Sube un video mostrando tus habilidades y nivel de competencia.',
            socialPlaceholder: 'Ingresa perfil de red social *',
            socialLabel: 'Perfil de red social',
            reasonPlaceholder: '¿Por qué quieres estar en whitelist? *',
            reasonLabel: 'Motivo',
            websitePlaceholder: 'Enlace del sitio web',
            websiteLabel: 'Enlace del sitio web (opcional)',
            submitting: 'Enviando...',
            apply: 'Aplicar',
            reapply: 'Volver a aplicar',
            unknownState: 'No se pudo determinar el estado actual de la solicitud de whitelist.',
            toast: {submitted: 'Solicitud de whitelist enviada correctamente', submitFailed: 'No se pudo enviar la solicitud de whitelist'},
        },
        director: {
            status: {
                approvedTitle: 'Solicitud aprobada',
                pendingTitle: 'Solicitud pendiente',
                rejectedTitle: 'Solicitud rechazada',
                applyTitle: 'Solicitar rol de director',
                reapplyTitle: 'Volver a solicitar rol de director',
                approvedMessage: 'Tu solicitud de director fue aprobada. Ahora puedes crear y administrar coros.',
                pendingMessage: 'Tu solicitud está pendiente. Un administrador la revisará en las próximas 48 horas.',
                rejectedMessage: 'Tu solicitud anterior no fue aprobada. Puedes actualizar tus datos y volver a solicitar.',
            },
            applicationStatus: 'Estado de solicitud',
            fillToApply: 'Completa correctamente para aplicar.',
            closeAria: 'Cerrar modal de solicitud de director',
            loadingStatus: 'Cargando estado de la solicitud...',
            uploadHint: 'Sube un video mostrando tu liderazgo y habilidades de dirección musical.',
            socialPlaceholder: 'Ingresa perfil de red social *',
            socialLabel: 'Perfil de red social',
            reasonPlaceholder: '¿Por qué quieres ser director? *',
            reasonLabel: 'Motivo',
            websitePlaceholder: 'Enlace del sitio web',
            websiteLabel: 'Enlace del sitio web (opcional)',
            apply: 'Aplicar',
            reapply: 'Volver a aplicar',
            unknownState: 'No se pudo determinar el estado actual de la solicitud de director.',
            toast: {submitted: 'Solicitud de director enviada correctamente', submitFailed: 'No se pudo enviar la solicitud de director'},
        },
        shareSetlist: {
            title: 'Compartir "{{name}}"',
            description: 'Administra visibilidad, canciones seleccionadas y copia un enlace público para esta setlist.',
            visibility: 'Visibilidad',
            makePublic: 'Hacer pública la setlist',
            renameLabel: 'Nombre de la setlist',
            renamePlaceholder: 'Escribe el nombre de la setlist',
            saveName: 'Guardar nombre',
            savingName: 'Guardando...',
            nameRequired: 'Escribe un nombre para la setlist',
            nameLength: 'El nombre debe tener entre 2 y 100 caracteres',
            publishTitle: 'Confirma el nombre público',
            publishDescription: 'Este nombre se mostrará donde la setlist se comparta públicamente.',
            confirmPublish: 'Hacer pública',
            cancelPublish: 'Cancelar',
            publishing: 'Publicando...',
            selectedSongs: 'Canciones seleccionadas',
            remove: 'Quitar',
            moveSongUp: 'Mover canción arriba',
            moveSongDown: 'Mover canción abajo',
            emptySongs: 'Esta setlist no tiene canciones.',
            addMode: 'Modo de añadido',
            manualEntry: 'Manual',
            importFromText: 'Importar desde texto',
            importTextLabel: 'Texto de setlist de WhatsApp',
            importTextPlaceholder: 'Pega aquí un mensaje de setlist estilo WhatsApp...',
            songSource: 'Fuente de canción',
            search: 'Buscar',
            manualYoutube: 'Manual (YouTube)',
            publicDomain: 'Dominio público',
            searchPlaceholder: 'Buscar canciones...',
            selectLabelPlaceholder: 'Selecciona una etiqueta para la canción',
            addSongWithLabel: 'Agregar canción con etiqueta',
            addExternalSong: 'Agregar canción externa',
            addPublicDomainSong: 'Agregar canción de dominio público',
            previewImport: 'Previsualizar importación',
            previewingImport: 'Previsualizando...',
            importPreview: 'Vista previa de importación',
            importPreviewSummary: '{{count}} canciones listas para importar',
            importToSetlist: 'Importar a setlist',
            importingSetlist: 'Importando...',
            showAddSongs: 'Mostrar agregar canciones',
            hideAddSongs: 'Ocultar agregar canciones',
            shareLink: 'Enlace para compartir',
            copyLink: 'Copiar enlace',
            public: 'Pública',
            private: 'Privada',
            toast: {
                linkCopied: '¡Enlace copiado al portapapeles!',
                visibilityUpdated: 'La setlist ahora es {{visibility}}',
                updateVisibilityFailed: 'No se pudo actualizar la visibilidad',
                renameSuccess: 'Nombre de setlist actualizado',
                renameFailed: 'No se pudo actualizar el nombre de la setlist',
                noSongSelected: 'No se seleccionó canción',
                songAlreadyExists: 'La canción ya existe en la setlist',
                selectLabel: 'Selecciona una etiqueta para la canción',
                songAdded: 'Canción agregada a la setlist',
                errorOccurred: 'Ocurrió un error',
                songRemoved: 'Canción eliminada de la setlist',
                removeSongFailed: 'No se pudo eliminar la canción',
                reorderSongFailed: 'No se pudieron reordenar las canciones',
                enterImportText: 'Pega el texto del setlist antes de previsualizar',
                importPreviewReady: 'La vista previa de importación está lista',
                importPreviewFailed: 'No se pudo previsualizar la setlist importada',
                nothingNewToImport: 'Todas las canciones detectadas ya están en esta setlist',
                importSuccess: '{{count}} canciones importadas a la setlist',
                importFailed: 'No se pudieron importar canciones a la setlist',
            },
        },
        addSongToRehearsal: {
            title: 'Agregar canción al ensayo',
            description: 'Elige una fuente de canción o importa desde texto sin formato y agrégala a este ensayo.',
            songSource: 'Fuente de canción',
            search: 'Buscar',
            manualYoutube: 'Manual (YouTube)',
            publicDomain: 'Dominio público',
            searchPlaceholder: 'Buscar canciones...',
            cancel: 'Cancelar',
            adding: 'Agregando...',
            importing: 'Importando...',
            addToRehearsal: 'Agregar al ensayo',
            fallbackArtist: 'Artista desconocido',
            fallbackGenre: 'Desconocido',
            destination: 'Sección del ensayo',
            additionalSongs: 'Canciones adicionales',
            untitledSetlist: 'Lista sin título',
            toast: {
                selectSongFirst: 'Primero selecciona una canción',
                songAdded: 'Canción agregada al ensayo',
                addFailed: 'No se pudo agregar la canción al ensayo',
                enterImportText: 'Pega el texto del setlist antes de previsualizar',
                importPreviewReady: 'La vista previa de la importación está lista',
                importPreviewFailed: 'No se pudieron previsualizar las canciones importadas',
                importSuccess: '{{count}} canciones agregadas al ensayo',
                importFailed: 'No se pudieron agregar las canciones importadas al ensayo',
            },
        },
        shareSetlistWithChoir: {
            title: 'Compartir "{{name}}"',
            description: 'Elige un coro y, opcionalmente, cambia el nombre compartido o la programación.',
            chooseChoir: 'Elige un coro',
            loadingChoirs: 'Cargando tus coros...',
            searchPlaceholder: 'Buscar por nombre, ID o UUID',
            loading: 'Cargando...',
            noMatches: 'Sin coincidencias',
            nameOptional: 'Nombre (opcional)',
            defaultNamePlaceholder: 'Servicio dominical',
            scheduledForOptional: 'Programado para (opcional)',
            cancel: 'Cancelar',
            sharing: 'Compartiendo...',
            shareToChoir: 'Compartir con coro',
            toast: {
                loadChoirsFailed: 'No se pudieron cargar tus coros',
                sharedToChoir: 'Compartido con {{name}}',
                shareFailed: 'No se pudo compartir la setlist',
            },
        },
        confirmation: {
            title: 'Confirmación',
            description: '¿Deseas continuar?',
            confirm: 'Confirmar',
            cancel: 'Cancelar',
        },
        addChoirSeats: {
            title: 'Agregar cupos al coro',
            description: 'Elige cuántos cupos adicionales deseas agregar a este coro.',
            seats: 'Cupos',
            seatsOption: '{{count}} cupos',
            cancel: 'Cancelar',
            adding: 'Agregando...',
            addSeats: 'Agregar cupos',
            toast: {
                chooseSeats: 'Selecciona la cantidad de cupos',
                completePaymentInNewTab: 'Completa el pago en la nueva pestaña',
                addFailed: 'No se pudieron agregar más cupos al coro',
            },
        },
        manageChoirEntitlements: {
            title: 'Compartir cupos Premium',
            sourceDescription: 'Asigna cupos de la suscripción Premium de este coro o crea un código seguro.',
            recipientDescription: 'Canjea un código seguro proporcionado por el coro que comparte los cupos Premium.',
            directTitle: 'Asignar a un coro',
            recipientChoir: 'ID del coro destinatario',
            recipientChoirPlaceholder: 'UUID del coro',
            seats: 'Cupos',
            allocate: 'Asignar cupos',
            codeTitle: 'Crear código de canje',
            codeDescription: 'El código reserva los cupos inmediatamente y un solo coro puede canjearlo.',
            generateCode: 'Crear código',
            generatedCode: 'Comparte este código de forma segura',
            allocations: 'Asignaciones de cupos',
            noAllocations: 'Aún no hay asignaciones de cupos.',
            unredeemedCode: 'Código sin canjear',
            additionalSeats: 'Cupos adicionales',
            increase: 'Aumentar',
            code: 'Código de canje',
            codePlaceholder: 'VC-...',
            redeemCode: 'Canjear código',
            toast: {
                loadFailed: 'No se pudieron cargar las asignaciones de cupos',
                actionFailed: 'No se pudo actualizar el uso compartido de cupos Premium',
                allocated: 'Cupos Premium asignados',
                codeGenerated: 'Código de cupos Premium creado',
                increased: 'Asignación de cupos Premium aumentada',
                redeemed: 'Código de cupos Premium canjeado',
            },
        },
        createSchedule: {
            title: 'Crear nuevo horario',
            description: 'Crea una ventana de horario y configura las opciones de asignación para este coro.',
            scheduleLabel: 'Etiqueta del horario',
            scheduleLabelPlaceholder: 'Horario de julio',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de fin',
            autoAssignMembers: 'Asignar miembros automáticamente',
            perPartCount: 'Cantidad por parte',
            cancel: 'Cancelar',
            creating: 'Creando...',
            createSchedule: 'Crear horario',
            toast: {
                fillAllFields: 'Completa todos los campos',
                created: '¡Horario creado!',
                createFailed: 'No se pudo crear el horario',
            },
        },
        inviteChoirMember: {
            title: 'Invitar miembro al coro',
            description: 'Envía una invitación y asigna una parte predeterminada para el nuevo miembro.',
            email: 'Correo electrónico',
            emailPlaceholder: 'usuario@ejemplo.com',
            assignPart: 'Asignar parte',
            addCustomPart: '+ Agregar parte personalizada',
            cancel: 'Cancelar',
            sendInvitation: 'Enviar invitación',
            linkDescription: 'Copia un enlace de invitación al coro y envíalo a varias personas.',
            copyInvitationLink: 'Copiar enlace de invitación',
            copyingLink: 'Copiando...',
            toast: {
                provideEmailAndPart: 'Proporciona correo y parte',
                invitationSent: 'Invitación enviada',
                sendFailed: 'No se pudo enviar la invitación',
                linkCopied: 'Enlace de invitación copiado',
                linkFailed: 'No se pudo copiar el enlace de invitación',
            },
        },
        generateShareLink: {
            title: 'Generar enlace para compartir',
            description: 'Elige cuánto tiempo debe permanecer activo el enlace público de armonía antes de copiarlo.',
            expiration: 'Vencimiento',
            cancel: 'Cancelar',
            generating: 'Generando...',
            generateLink: 'Generar enlace',
            options: {
                oneDay: { label: '1 día', hint: 'Vence después de 24 horas' },
                sevenDays: { label: '7 días', hint: 'Ideal para ciclos de revisión cortos' },
                thirtyDays: { label: '30 días', hint: 'Recomendado para compartir ensayos' },
                ninetyDays: { label: '90 días', hint: 'Acceso a ensayos por más tiempo' },
                never: { label: 'Nunca', hint: 'El enlace no vencerá' },
            },
        },
        renameHarmonyPart: {
            title: 'Renombrar parte de armonía',
            description: 'Renombra o reasigna esta parte transpuesta sin cambiar su grabación de origen.',
            partName: 'Nombre de la parte',
            save: 'Guardar nombre',
            saving: 'Guardando...',
        },
        serviceDays: {
            title: 'Configurar días de servicio',
            description: 'Asigna un tipo de servicio o marca sin servicio para cada día de la semana.',
            empty: 'Aún no hay tipos de servicio disponibles, por lo que no hay nada que asignar por día.',
            emptyHint: 'Primero crea un tipo de servicio semanal no recurrente y luego vuelve para configurar los días de servicio.',
            createServiceType: 'Crear tipo de servicio',
            noServiceOption: '-- Sin servicio --',
            cancel: 'Cancelar',
            saving: 'Guardando...',
            saveChanges: 'Guardar cambios',
            weekdays: {
                sunday: 'Domingo',
                monday: 'Lunes',
                tuesday: 'Martes',
                wednesday: 'Miércoles',
                thursday: 'Jueves',
                friday: 'Viernes',
                saturday: 'Sábado',
            },
            toast: {
                loadServiceTypesFailed: 'No se pudieron cargar los tipos de servicio',
                loadExistingDaysFailed: 'No se pudieron cargar los días de servicio existentes',
                updated: 'Días de servicio actualizados',
                errorOccurred: 'Ocurrió un error',
            },
        },
        shareHarmonyLink: {
            title: 'Generar enlace para compartir',
            description: 'Elige cuánto tiempo debe permanecer activo el enlace para compartir armonía.',
            closeAria: 'Cerrar configuración de enlace compartido',
            expiration: 'Vencimiento',
            linkExpiry: 'Vencimiento del enlace:',
            cancel: 'Cancelar',
            generating: 'Generando...',
            generateLink: 'Generar enlace',
            options: {
                oneDay: '1 día',
                sevenDays: '7 días',
                thirtyDays: '30 días',
                ninetyDays: '90 días',
                never: 'Nunca',
            },
        },
        reportContribution: {
            title: 'Reportar contribución',
            description: 'Elige el motivo que mejor describa por qué esta contribución debe revisarse.',
            cancel: 'Cancelar',
            submitReport: 'Enviar reporte',
            reasons: {
                wrongPart: 'Parte incorrecta',
                wrongSection: 'Sección incorrecta',
                lowQualityAudio: 'Audio de baja calidad',
                poorPerformance: 'Rendimiento deficiente',
                spamOrIrrelevant: 'Spam o irrelevante',
                offensiveContent: 'Contenido ofensivo',
            },
        },
        reportMarketplaceSong: {
            title: 'Reportar canción del marketplace',
            description: 'Elige el motivo que mejor explique por qué esta canción debe revisarse.',
            detailsPlaceholder: 'Agrega contexto opcional',
            cancel: 'Cancelar',
            submitReport: 'Enviar reporte',
            reasons: {
                plagiarizedSong: 'Canción plagiada',
                copyrightIssue: 'Problema de derechos de autor',
                misleadingMetadata: 'Metadatos engañosos',
                poorAudioQuality: 'Audio de baja calidad',
                offensiveContent: 'Contenido ofensivo',
                spamOrIrrelevant: 'Spam o irrelevante',
                other: 'Otro',
            },
        },
        requestContribution: {
            title: 'Solicitar una contribución',
            selectedSong: 'Seleccionado: {{title}} - {{artist}}',
            noSongSelected: 'No hay canción seleccionada. Busca una canción primero.',
            searchPlaceholder: 'Busca una canción (interna o externa)',
            selectPart: 'Selecciona parte',
            section: 'Sección',
            songKeyOptional: 'Tonalidad (opcional)',
            bountyXpOptional: 'XP de recompensa (opcional)',
            additionalNotesOptional: 'Notas adicionales (opcional)',
            cancel: 'Cancelar',
            submitting: 'Enviando...',
            submitRequest: 'Enviar solicitud',
            toast: {
                selectSongAndPartType: 'Selecciona canción y tipo de parte',
                submitted: 'Solicitud de contribución enviada',
                submitFailed: 'No se pudo enviar la solicitud',
            },
        },
        submitContribution: {
            title: 'Enviar una contribución',
            selectedSong: 'Seleccionado: {{title}} - {{artist}}',
            noSongSelected: 'No hay canción seleccionada. Busca una canción primero.',
            searchPlaceholder: 'Busca una canción (interna o externa)',
            selectPart: 'Selecciona parte',
            sectionPlaceholder: 'Sección (ej. Coro, Puente)',
            uploadMode: 'Modo de carga:',
            file: 'Archivo',
            record: 'Grabar',
            uploadYourAudio: 'Sube tu audio',
            cancel: 'Cancelar',
            submitting: 'Enviando...',
            submitContribution: 'Enviar contribución',
            toast: {
                recordingUploadFailed: 'Falló la carga de la grabación',
                completeAllFields: 'Completa todos los campos antes de enviar.',
                submittedSuccessfully: '¡Tu contribución se envió correctamente!',
                submissionFailed: 'El envío falló',
            },
        },
        submitChallengeEntry: {
            title: 'Enviar participación',
            description: 'Sube tu actuación del reto y envíala a la tabla de clasificación.',
            uploadVideo: 'Subir video de participación',
            captionPlaceholder: 'Cuéntale a la gente sobre tu participación',
            cancel: 'Cancelar',
            submitting: 'Enviando...',
            submitEntry: 'Enviar participación',
        },
        updateDefaultPart: {
            title: '¡Elige tu parte y nombre de usuario por defecto!',
            description: '¿Qué parte te gustaría cantar o tocar? Se usará como tu parte por defecto.',
            selectDefaultPart: 'Selecciona parte por defecto',
            chooseUsername: 'Elige un nombre de usuario',
            usernameValidation: 'El nombre de usuario debe tener entre 3 y 15 caracteres y solo puede contener letras, números y guiones bajos.',
            chooseDifferentUsername: 'Elige un nombre de usuario diferente para continuar.',
            usernameTaken: 'Este nombre de usuario ya está en uso.',
            loading: '...Cargando',
            setDefaultPart: 'Establecer parte por defecto',
            toast: {
                profileUpdated: 'Perfil actualizado correctamente',
            },
        },
        challengeVote: {
            title: 'Votar',
            description: 'Ingresa tu reseña',
            commentPlaceholder: 'Comentario',
            score: 'Puntaje {{score}}%',
            disqualify: 'Descalificar',
            cancel: 'Cancelar',
            submitting: 'Enviando...',
            submitVote: 'Enviar voto',
        },
        deleteHarmonyConfirm: {
            cancel: 'Cancelar',
            delete: 'Eliminar',
            deleting: 'Eliminando...',
        },
        shareSchedule: {
            title: 'Compartir horario',
            description: 'Genera un enlace público del horario para compartir o descarga el horario actual como PDF.',
            closeAria: 'Cerrar modal para compartir horario',
            publicScheduleLink: 'Enlace público del horario',
            publicScheduleHint: 'Elige cuánto tiempo debe permanecer activo el enlace público antes de generarlo.',
            linkExpiry: 'Vencimiento del enlace',
            generating: 'Generando...',
            generateLink: 'Generar enlace',
            regenerateLink: 'Regenerar enlace',
            generatedLink: 'Enlace generado',
            readyToShare: 'Listo para compartir',
            copyLink: 'Copiar enlace',
            openLink: 'Abrir enlace',
            generateToReveal: 'Genera un enlace para mostrar aquí la URL pública del horario.',
            pdfDownload: 'Descarga en PDF',
            pdfDescription: 'Descarga el horario actual como un PDF imprimible.',
            pdfHint: 'Úsalo cuando el director necesite una copia fija para imprimir en lugar de una página pública en vivo.',
            preparingPdf: 'Preparando PDF...',
            downloadPdf: 'Descargar PDF',
            options: {
                oneDay: '1 día',
                sevenDays: '7 días',
                thirtyDays: '30 días',
                ninetyDays: '90 días',
                never: 'Nunca',
            },
            toast: {
                linkCopied: 'Enlace copiado al portapapeles',
            },
        },
        fullScreen: {
            confirmationIllustrationAlt: 'ilustración de confirmación',
            passwordResetSuccess: 'Felicidades, tu contraseña ha sido restablecida.',
            login: 'Iniciar sesión',
        },
        postSignupOnboarding: {
            welcomeToVocalcentric: 'Bienvenido a VocalCentric',
            skipForNow: 'Omitir por ahora',
            back: 'Atrás',
            continue: 'Continuar',
            steps: {
                welcome: {
                    title: 'Te configuramos rápidamente',
                    description: 'VocalCentric te ayuda a practicar tu parte, ensayar mejor con tu coro, descubrir canciones y pistas, y crecer participando en la comunidad.',
                    items: {
                        practiceWithStems: 'Practica con pistas y partes aisladas',
                        prepareRehearsals: 'Prepara ensayos y organiza setlists',
                        collaborate: 'Colabora en coros, proyectos y comunidades',
                        buildConsistency: 'Construye constancia con flujos musicales estructurados',
                    },
                },
                interests: {
                    title: '¿Qué te trae por aquí?',
                    description: 'Elige una o más opciones para personalizar tu inicio.',
                },
                role: {
                    title: '¿Cómo usas VocalCentric?',
                    description: 'Es opcional, pero nos ayuda a guiarte mejor.',
                },
                recommendation: {
                    title: 'Punto de inicio recomendado',
                    description: 'Según tus selecciones, este es el mejor primer lugar para comenzar.',
                    recommendedLabel: 'Recomendado',
                    exploreEverythingInstead: 'Explorar todo en su lugar',
                },
            },
            toast: {
                saveFailed: 'No se pudieron guardar las preferencias de onboarding',
            },
        },
        personalizedOnboarding: {
            title: 'Configuración personalizada',
            skipForNow: 'Omitir por ahora',
            back: 'Atrás',
            continue: 'Continuar',
            finish: 'Finalizar configuración',
            saveFailed: 'No se pudo guardar el progreso de onboarding',
            intentTitle: '¿Qué te trae por aquí?',
            intentDescription: 'Elige una o más opciones para personalizar tu inicio.',
            roleTitle: '¿Cómo usas VocalCentric?',
            roleDescription: 'Es opcional, pero nos ayuda a guiarte mejor.',
            profileTitle: 'Configura tu ruta inicial',
            profileDescription: 'Estas decisiones rápidas personalizan tu siguiente paso.',
            usernameStepTitle: 'Elige tu nombre de usuario',
            usernameStepDescription: 'Esto ayuda a que otros te encuentren y mantiene tu perfil consistente.',
            partStepTitle: 'Elige tu rol',
            partStepDescription: 'Elige tu rol principal (tenor, alto, pianista y más) para una mejor guía.',
            nameStepTitle: 'Añade tu nombre',
            nameStepDescription: 'Usa tu nombre y apellido reales para que otros miembros te reconozcan.',
            recommendationTitle: 'Tu mejor siguiente acción',
            recommendationDescription: 'Empieza aquí para llegar rápido a tu primera acción de valor.',
            recommendedLabel: 'Recomendado',
            exploreInstead: 'Explorar inicio en su lugar',
            selectPart: 'Seleccionar rol',
            usernameLabel: 'Nombre de usuario',
            usernamePlaceholder: 'Elige un nombre de usuario',
            usernameRequired: 'El nombre de usuario es obligatorio',
            usernameValidation: 'Debe tener 3-30 caracteres y usar letras, números o guiones bajos.',
            usernameTaken: 'Este nombre de usuario ya está en uso.',
            usernameValidationUnavailable: 'No se puede validar el nombre de usuario ahora mismo.',
            firstNameLabel: 'Nombre',
            lastNameLabel: 'Apellido',
            firstNamePlaceholder: 'Nombre',
            lastNamePlaceholder: 'Apellido',
            firstNameRequired: 'El nombre es obligatorio.',
            lastNameRequired: 'El apellido es obligatorio.',
            defaultNameValidation: 'Reemplaza el nombre predeterminado New User.',
            roleOptions: {
                choir_member: {
                    label: 'Miembro de coro',
                    description: 'Principalmente ensayo y actúo como participante de coro.',
                },
                vocalist: {
                    label: 'Vocalista / Artista solista',
                    description: 'Quiero herramientas para fortalecer mi flujo de rendimiento personal.',
                },
                choir_director: {
                    label: 'Director/Administrador de coro',
                    description: 'Quiero organizar ensayos, personas y flujo del coro.',
                },
                vocal_coach: {
                    label: 'Coach vocal / Profesor',
                    description: 'Quiero enseñar y organizar cursos, cohortes y tareas.',
                },
                producer: {
                    label: 'Productor',
                    description: 'Contribuyo canciones y stems al marketplace.',
                },
                project_owner: {
                    label: 'Propietario de proyecto',
                    description: 'Creo proyectos e invito a otros a colaborar.',
                },
                collaborator: {
                    label: 'Colaborador',
                    description: 'Exploro gigs/proyectos y mantengo mi perfil listo para oportunidades.',
                },
                exploring: {
                    label: 'Solo explorando',
                    description: 'Quiero la ruta guiada más rápida y ajustar después.',
                },
            },
            intentOptions: {
                practice_part: {label: 'Practicar mi parte', description: 'Usa stems y reproducción enfocada para afinar tu sección.'},
                join_manage_choir: {label: 'Unirme o gestionar un coro', description: 'Trabaja con miembros, partes y actividades del coro en un solo lugar.'},
                prepare_rehearsals: {label: 'Preparar ensayos', description: 'Llega listo al ensayo con setlists, horarios y organización de canciones.'},
                discover_songs_stems: {label: 'Descubrir canciones y stems', description: 'Explora canciones, artistas y recursos musicales para ensayar.'},
                improve_vocal_skills: {label: 'Mejorar mis habilidades vocales', description: 'Construye consistencia con práctica estructurada y foco en desempeño.'},
                teach_students: {label: 'Enseñar a estudiantes', description: 'Organiza un plan, asigna ejercicios y sigue el progreso.'},
                explore_community_challenges: {label: 'Explorar comunidad y retos', description: 'Únete a contribuciones, reels y dinámicas de retos.'},
                work_on_projects: {label: 'Trabajar en proyectos', description: 'Encuentra oportunidades de colaboración y gestiona flujos de proyecto.'},
                just_explore: {label: 'Solo explorar', description: 'Quiero mirar y descubrir qué me encaja mejor.'},
                contribute_stems: {label: 'Contribuir canciones y stems', description: 'Sube contenido para el marketplace y mantén tu catálogo.'},
                recruit_collaborators: {label: 'Reclutar colaboradores', description: 'Invita contribuidores calificados a oportunidades activas.'},
            },
            recommendations: {
                director_first_choir: {title: 'Crea tu primer coro', description: 'Empieza con un espacio de coro y luego arma ensayos dentro de él.', ctaLabel: 'Crear coro'},
                coach_first_workspace: {title: 'Crea tu espacio de enseñanza', description: 'Empieza con un espacio independiente y añade cursos y cohortes de estudiantes.', ctaLabel: 'Empezar a enseñar'},
                producer_upload_song: {title: 'Sube tu primera canción', description: 'La carga está disponible para cuentas en lista blanca. Continúa a subidas de cuenta para empezar.', ctaLabel: 'Abrir subidas'},
                project_owner_first_project: {title: 'Crea tu primer proyecto', description: 'Crea un proyecto y luego invita colaboradores para iniciar trabajo activo.', ctaLabel: 'Crear proyecto'},
                collaborator_discover_projects: {title: 'Explora proyectos activos', description: 'Descubre gigs y oportunidades de colaboración que encajen con tu perfil.', ctaLabel: 'Abrir proyectos'},
                projects_first_step: {title: 'Inicia tu primer flujo de proyecto', description: 'Abre proyectos para descubrir oportunidades activas rápidamente.', ctaLabel: 'Abrir proyectos'},
                community_first_step: {title: 'Explora retos de la comunidad', description: 'Únete a un reto para ver cómo VocalCentric impulsa el compromiso.', ctaLabel: 'Abrir retos'},
                practice_general: {title: 'Escucha tu parte en aislamiento', description: 'Empieza con tu parte seleccionada para una guía de práctica más precisa.', ctaLabel: 'Reproducir mi parte'},
                explore_first_practice: {title: 'Empieza a explorar VocalCentric', description: 'Recorre módulos clave y haz una acción para descubrir tu mejor camino.', ctaLabel: 'Explorar ahora'},
            },
        },
        upgrade: {
            takeYourChoralExperience: 'Lleva tu experiencia coral',
            toNextLevel: 'al siguiente nivel',
            premiumDescription: 'Actualizar a premium desbloquea un mundo de funciones exclusivas diseñadas para potenciar tu entrenamiento vocal y habilidades de liderazgo.',
            advancedRehearsalTools: 'Herramientas avanzadas de ensayo:',
            advancedRehearsalDescription: 'Toma el control de tus ensayos con funciones premium como calentamientos personalizables, pistas por sección (soprano, alto, tenor, bajo) y control de tempo variable para dominar pasajes difíciles.',
            directorsToolkit: 'Kit del director:',
            directorsToolkitDescription: 'Conviértete en líder coral con herramientas exclusivas como anotaciones en partituras, notas de desempeño para miembros del coro y analíticas avanzadas para seguir el progreso individual y grupal.',
            seats: 'Cupos:',
            seatsDescription: 'Agrega o elimina cupos para los miembros de tu coro.',
            notDirector: 'No eres el director de este coro, por lo tanto no puedes actualizar.',
            choirBillingAdminTitle: 'Contacta al administrador de tu coro',
            contactChoirAdmin: 'La suscripción de este coro necesita atención. Contacta al administrador del coro o al miembro de facturación para actualizar el plan o el pago antes de usar esta función.',
            upgrade: 'Actualizar',
            toast: {
                planNotFound: 'Plan no encontrado',
            },
        },
        upload: {
            clickToUploadDocument: 'Haz clic para subir documento',
            supportedFormats: 'Pdf, txt, ppt, docx (máx. 20MB)',
            upload: 'Subir',
            cancel: 'Cancelar',
        },
        setRehearsalSongKey: {
            title: 'Establecer tono de la canción',
            description: 'Elige una tonalidad predeterminada para esta canción. Puedes usar la transposición automática para ajustar las voces según sea necesario.',
            note: 'Nota: esto no cambiará la tonalidad original de la canción, solo la predeterminada para este ensayo.',
            songKey: 'Tono de la canción',
            placeholder: 'Selecciona tono para este ensayo',
            setKey: 'Establecer tono',
            toast: {
                selectSongKey: 'Selecciona un tono de canción',
            },
        },
        addCustomSection: {
            title: 'Agregar sección personalizada',
            description: 'Ingresa el nombre de la sección que deseas agregar, como Intro, Puente o Tag.',
            sectionName: 'Nombre de la sección',
            placeholder: 'ej., Puente',
            addSection: 'Agregar sección',
        },
        addCustomPart: {
            title: 'Agregar voz personalizada',
            description: 'Elige la voz armónica que quieres agregar a esta sección.',
            partName: 'Nombre de la voz',
            placeholder: 'Selecciona voz predeterminada',
            addPart: 'Agregar voz',
        },
        duplicateMidiPart: {
            title: 'Duplicar pista MIDI',
            description: 'Elige la voz en la que se convertirá este duplicado MIDI. Luego podrás editar la parte duplicada en el editor MIDI.',
            targetPart: 'Voz de destino',
            selectPart: 'Seleccionar voz',
            destinationInterval: 'Intervalo de destino',
            duplicate: 'Duplicar',
            intervals: {
                '0': 'Misma melodía',
                '4': '3ª arriba',
                '-4': '3ª abajo',
                '7': '5ª arriba',
                '-7': '5ª abajo',
            },
        },
        addSongToSetlist: {
            title: 'Agregar canción a la setlist',
            description: 'Selecciona o crea setlists para incluir esta canción.',
            createNewSetlist: '+ Crear nueva setlist',
            songSource: 'Fuente de la canción',
            backToExisting: '← Volver a las existentes',
            source: {
                search: 'Buscar',
                manualYoutube: 'Manual (YouTube)',
                publicDomain: 'Dominio público',
            },
            selectLabelPlaceholder: 'Selecciona una etiqueta para esta canción...',
            setlistNamePlaceholder: 'Nombre de la nueva setlist',
            searchSongsPlaceholder: 'Buscar canciones...',
            noSongs: 'Sin canciones',
            songCount: '{{count}} canción(es)',
            createAndAdd: 'Crear y agregar',
            addToSetlists: 'Agregar a setlists',
            toast: {
                setlistUpdatedSuccessfully: 'Setlist actualizada correctamente',
                noChangesMade: 'No se realizaron cambios',
                failedToUpdateSetlists: 'No se pudieron actualizar las setlists',
                selectLabelForSong: 'Selecciona una etiqueta para esta canción',
                completeRequiredFields: 'Completa los campos obligatorios',
                newSetlistCreatedAndSongAdded: 'Nueva setlist creada y canción agregada',
                failedToCreateSetlist: 'No se pudo crear la setlist',
            },
        },
    },
    components: {
        autoCompleteSearch: {
            fromSpotify: 'Desde Spotify',
            fromLibrary: 'Desde la biblioteca',
            nothingFound: 'No se encontró nada.',
        },
        manualSongInput: {
            unlabeled: 'Sin etiqueta',
            youtubeLink: 'Enlace de YouTube',
            songTitle: 'Título de la canción',
            artistName: 'Nombre del artista',
            invalidYoutubeLink: 'Enlace de YouTube inválido.',
            youtubeThumbnailAlt: 'Miniatura de YouTube',
            selectLabelForSong: 'Selecciona una etiqueta para la canción',
        },
        publicSongInput: {
            unlabeled: 'Sin etiqueta',
            songTitle: 'Título de la canción',
            composerOrSource: 'Compositor o fuente',
            selectLabelForSong: 'Selecciona una etiqueta para la canción',
        },
        searchInput: {
            searchAlt: 'buscar',
            clearAlt: 'limpiar búsqueda',
            defaultPlaceholder: 'Buscar canción, artista, partitura, álbum',
        },
        songSearchInput: {
            searchForSongs: 'Buscar canciones...',
            selectedSong: 'Seleccionado: {{title}} – {{artist}}',
        },
        songArt: {
            userAlt: 'usuario',
        },
        passwordInput: {
            updatePassword: 'Actualizar contraseña',
        },
        planCard: {
            currentPlan: 'Plan actual',
            payment: 'Pago',
            nextBillPrefix: 'Tu próxima factura es de ',
            on: ' el ',
            perMonth: 'Por mes',
            processing: 'Procesando...',
            active: 'Activo',
            upgrade: 'Actualizar',
            downgrade: 'Cambiar a plan inferior',
        },
        floatingSupport: {
            openSupportMenuAria: 'Abrir menú de soporte',
            support: 'Soporte',
            needHelp: '¿Necesitas ayuda?',
            weAreHereForYou: 'Estamos aquí para ayudarte.',
            closeSupportMenuAria: 'Cerrar menú de soporte',
            contactSupport: 'Contactar soporte',
            sendUsAMessageFromTheApp: 'Envíanos un mensaje desde la app',
            emailUs: 'Escríbenos',
            accountDeletion: 'Eliminación de cuenta',
            googleAccountDeletionSteps: 'Pasos para eliminar la cuenta de Google',
            tipPrefix: 'Consejo: Presiona',
            escKey: 'Esc',
            tipSuffix: 'para cerrar.',
        },
        switchInput: {
            useSetting: 'Usar ajuste',
        },
        mobileSidebar: {
            search: 'Buscar',
        },
        customPopover: {
            menuAlt: 'menú',
            select: 'Seleccionar',
            searchPlaceholder: 'Buscar...',
            nothingFound: 'No se encontró nada',
        },
        partSelectDropdown: {
            selectPart: 'Seleccionar parte',
            fromLibrary: 'De la biblioteca',
            noPartsFound: 'No se encontraron partes.',
        },
        keySelectDropdown: {
            selectSongKey: 'Seleccionar tonalidad',
            fromLibrary: 'De la biblioteca',
            noKeysFound: 'No se encontraron tonalidades.',
        },
        creditCard: {
            cardNumberLabel: 'Número de tarjeta',
            cardNumberPlaceholder: 'Ingresa tu número de tarjeta',
            cardTypeIconAlt: 'Ícono de {{name}}',
            cvvLabel: 'CVV',
            cvvPlaceholder: 'CVV',
            expiryDateLabel: 'Fecha de expiración',
            expiryDatePlaceholder: 'MM/AA',
        },
        practiseCards: {
            allSectionsSubmitted: 'Se enviaron todas las secciones. ¡Buen trabajo!',
            progress: 'Progreso: {{submittedCount}} de {{totalSections}} secciones enviadas',
            nothingHereYet: 'Aún no hay nada aquí',
        },
        upgrade: {
            previewOnlyMessage: 'Solo puedes previsualizar las pistas originales. Actualiza a nuestro plan premium para ver todas las pistas.',
            upgradeToSeeAllTracks: 'Actualizar para ver todas las pistas',
        },
        toast: {
            musicAlt: 'Música',
        },
        choirCard: {
            leaveChoir: 'Salir del coro',
            choirAlt: 'Coro',
            choirAvatarAlt: 'Avatar del coro',
            members: '{{count}} miembros',
            noMembers: 'Sin miembros',
            created: 'Creado:',
            toast: {
                choirDeleted: 'Coro eliminado correctamente',
            },
        },
        audioPlayer: {
            vocalPlaying: 'Reproducción vocal',
            expandToFullView: 'Expandir a vista completa',
            fullscreenAlt: 'pantalla completa',
            playbackSpeed: 'velocidad+',
            speed: {
                slow: 'Lento',
                normal: 'Normal',
                faster: 'Más rápido',
                fastest: 'Muy rápido',
            },
        },
        audioController: {
            repeatAlt: 'repetir',
            pauseAlt: 'pausar',
            playAlt: 'reproducir',
            micAlt: 'micrófono',
            speakerAlt: 'altavoz',
            initialTime: '00:00',
        },
        multiTrackWaveform: {
            mute: 'Silenciar',
            solo: 'Solo',
            pause: 'Pausar',
            play: 'Reproducir',
            sync: 'Sincronizar',
        },
        header: {
            userAvatarAlt: 'avatar de usuario',
            premium: 'Premium',
            moduleHelp: {
                openHelpAria: 'Abrir video de ayuda para {{module}}',
                firstVisit: '¿Primera vez en {{module}}? Mira la guía',
                watchGuide: '¿Necesitas ayuda? Mira la guía',
                watchGuideShort: 'Ayuda',
                videoTitle: 'Guía de {{module}}',
                primaryAction: 'Ir a {{module}}',
                openInNewTab: 'Abrir en nueva pestaña',
                close: 'Cerrar',
                unavailable: 'Este video de ayuda aún no está configurado. Define la URL del video del módulo para habilitarlo.',
                guidance: {
                    community_challenges: 'Abre un reto, revisa la consigna y luego participa o comparte cuando estés listo.',
                    community_reels: 'Explora reels para ver la actividad de la comunidad y crea o interactúa cuando tengas algo que compartir.',
                    community_contributions: 'Explora contribuciones de la comunidad y abre una para escuchar, comentar o contribuir.',
                    community_requests: 'Revisa solicitudes abiertas y contribuye la parte o stem que coincida con tu habilidad.',
                    choirs_overview: 'Primero crea tu coro y luego avanza por ensayos, setlists, agenda, miembros e integraciones.',
                    choir_rehearsals: 'Después de ensayos, pasa a setlists para definir el flujo de canciones.',
                    choir_setlists: 'Con setlists listos, actualiza la agenda para alinear ensayos y servicios.',
                    choir_schedule: 'La agenda está lista. Siguiente paso: asignar miembros por parte.',
                    choir_members: 'Miembros configurados. Continúa a integraciones para preparar la sincronización externa.',
                    choir_integrations: 'Finaliza integraciones y vuelve a ensayos para el ciclo completo.',
                    choir_rehearsal_runthrough: 'Completa esta práctica y luego revisa envíos para dar feedback.',
                    projects_discover: 'Comienza creando un proyecto para centralizar roles, presupuesto y colaboración.',
                    projects_create: 'Proyecto creado. Continúa a Mis proyectos para gestionarlo.',
                    projects_mine: 'Desde Mis proyectos, revisa invitaciones y aplicaciones.',
                    projects_invites: 'Gestiona invitaciones y luego revisa aplicaciones.',
                    projects_applications: 'Después de aplicaciones, entra al flujo detallado del proyecto.',
                    project_overview: 'Revisa el resumen y luego abre aplicaciones.',
                    project_applications: 'Selecciona colaboradores y continúa a Miembros.',
                    project_members: 'Equipo listo. Continúa a Presupuesto.',
                    project_budget: 'Presupuesto listo. Continúa a Acuerdos.',
                    project_agreements: 'Sigue el estado de acuerdos y luego pasa a Invitaciones.',
                    project_invites: 'Finaliza invitaciones pendientes y vuelve al resumen.',
                    uploads: 'Carga la información de la canción y al menos un stem útil, luego envíalo para marketplace o comunidad.',
                },
                whatToDoNext: {
                    title: 'Qué hacer después',
                    steps: {
                        choirs_overview: 'Resumen del coro',
                        choir_rehearsals: 'Ensayos',
                        choir_setlists: 'Setlists',
                        choir_schedule: 'Agenda',
                        choir_members: 'Miembros',
                        choir_integrations: 'Integraciones',
                        choir_rehearsal_runthrough: 'Práctica',
                        choir_rehearsal_review: 'Revisión de envíos',
                    },
                    copy: {
                        choirs_overview: 'Primero crea el coro y luego abre ensayos para iniciar el flujo semanal.',
                        choir_rehearsals: 'Define objetivos y enfoque de canciones en ensayos, luego continúa a setlists.',
                        choir_setlists: 'Cierra las canciones por ensayo o servicio y después organiza la agenda.',
                        choir_schedule: 'Confirma fechas y horarios, luego asigna miembros por parte.',
                        choir_members: 'Asigna voces y responsabilidades, luego conecta integraciones.',
                        choir_integrations: 'Completa las integraciones externas y vuelve a ensayos para el siguiente ciclo.',
                        choir_rehearsal_runthrough: 'Termina esta práctica y continúa a revisión para feedback y aprobación.',
                    },
                    cta: {
                        choirs_overview: 'Ir a Crear coro',
                        choir_rehearsals: 'Ir a Setlists',
                        choir_setlists: 'Ir a Agenda',
                        choir_schedule: 'Ir a Miembros',
                        choir_members: 'Ir a Integraciones',
                        choir_integrations: 'Ir a Ensayos',
                        choir_rehearsal_runthrough: 'Ir a Revisión',
                    },
                },
            },
            quickStart: {
                label: 'Inicio rápido',
                eyebrow: 'Adopción guiada',
                title: 'Tus próximas victorias en el producto',
                progress: '{{completed}} de {{total}} completados',
                primaryBadge: 'Siguiente recomendado',
                cta: 'Abrir paso',
                header: {
                    early: {
                        badge: 'Primeros pasos',
                        title: 'Guía de configuración para {{role}}',
                        description: 'Completa lo esencial primero para que VocalCentric ajuste el flujo correcto para ti.',
                    },
                    mid: {
                        badge: 'En progreso',
                        title: 'Guía de adopción para {{role}}',
                        description: 'La base ya está lista. Completa la siguiente acción recomendada y luego amplía tu uso del producto.',
                    },
                    mature: {
                        badge: 'Configuración completa',
                        title: 'Guía de crecimiento para {{role}}',
                        description: 'La configuración principal ya está hecha. Usa estos siguientes pasos para profundizar cómo trabajas en VocalCentric.',
                    },
                },
                phaseLabels: {
                    early: 'Etapa inicial',
                    mid: 'En expansión',
                    mature: 'Establecido',
                },
                groups: {
                    completeSetup: 'Completa tu configuración',
                    recommendedNext: 'Siguiente recomendado',
                    exploreMore: 'Explora más',
                    completed: 'Completado',
                },
                roles: {
                    choirDirector: 'Director de coro',
                    choirMember: 'Miembro del coro',
                    vocalist: 'Vocalista',
                    producer: 'Productor',
                    projectOwner: 'Propietario del proyecto',
                    collaborator: 'Colaborador',
                    explorer: 'Explorador',
                },
                categories: {
                    profile: 'Perfil',
                    practice: 'Práctica',
                    choirs: 'Coros',
                    projects: 'Proyectos',
                    community: 'Comunidad',
                    uploads: 'Subidas',
                },
                items: {
                    chooseRole: {
                        title: 'Elige cómo usas VocalCentric',
                        description: 'Define tu rol primero para priorizar los flujos correctos.',
                    },
                    choosePart: {
                        title: 'Define tu parte o instrumento principal',
                        description: 'Tu parte por defecto personaliza práctica, stems y guía de coro.',
                    },
                    confirmUsername: {
                        title: 'Confirma tu nombre de usuario',
                        description: 'Haz que tu perfil sea fácil de encontrar antes de colaborar.',
                    },
                    hearPart: {
                        title: 'Escucha tu parte en aislamiento',
                        description: 'Abre la biblioteca y cambia a tu stem para que la primera escucha sea útil.',
                    },
                    submitPractice: {
                        title: 'Envía tu primera práctica',
                        description: 'Completa un flujo de práctica para convertir el progreso en trabajo real.',
                    },
                    tryGames: {
                        title: 'Prueba juegos rápidos',
                        description: 'Entra en juegos cortos de oído, afinación y teoría musical.',
                    },
                    joinChoir: {
                        title: 'Únete a un coro',
                        description: 'Explora coros disponibles y envía una solicitud para entrar en un flujo activo.',
                    },
                    createChoir: {
                        title: 'Crea tu primer coro',
                        description: 'Inicia un espacio de coro para ensayos, miembros y setlists.',
                    },
                    createRehearsal: {
                        title: 'Crea un ensayo',
                        description: 'Pasa de la configuración del coro a un ensayo real que tu equipo pueda usar.',
                    },
                    createSetlist: {
                        title: 'Crea un setlist',
                        description: 'Agrupa canciones en un plan real antes de programar al equipo.',
                    },
                    inviteMember: {
                        title: 'Invita a tu primer miembro',
                        description: 'Incorpora a una persona para que la colaboración empiece de inmediato.',
                    },
                    uploadFirstSong: {
                        title: 'Sube tu primera canción o stem',
                        description: 'Abre la subida para aportar contenido al flujo del marketplace.',
                    },
                    createProject: {
                        title: 'Crea tu primer proyecto',
                        description: 'Inicia un proyecto para dar lugar claro a roles y entregables.',
                    },
                    applyToProject: {
                        title: 'Aplica a un proyecto',
                        description: 'Explora oportunidades activas y envía una solicitud acorde a tu perfil.',
                    },
                    inviteProjectCollaborator: {
                        title: 'Invita a un colaborador',
                        description: 'Cubre un rol del proyecto para pasar de la preparación a la ejecución.',
                    },
                    joinChallenge: {
                        title: 'Únete a un reto de la comunidad',
                        description: 'Haz una acción en comunidad para abrir más valor fuera de tu ruta principal.',
                    },
                },
            },
        },
        breadcrumb: {
            home: 'Inicio',
            community: 'Comunidad',
            marketplace: 'Marketplace',
            choirs: 'Coros',
            teaching: 'Escuelas',
            projects: 'Proyectos',
            rehearsals: 'Ensayos',
            accountInformation: 'Información de la cuenta',
            vocalContributions: 'Contribuciones vocales',
            uploads: 'Subidas',
            requestSongs: 'Solicitar canciones',
            requestRole: 'Solicitar rol',
            notifications: 'Notificaciones',
            transactionHistory: 'Historial de transacciones',
            search: 'Buscar',
        },
        routeItems: {
            songLibrary: 'Biblioteca de canciones',
            community: 'Comunidad',
            marketplace: 'Marketplace',
            rehearsals: 'Ensayos',
            exercises: 'Ejercicios',
            choirs: 'Coros',
            projects: 'Proyectos',
            requestSongs: 'Solicitar canciones',
            personal: 'Personal',
            vocalContributions: 'Contribuciones vocales',
            setlists: 'Setlists',
            settings: 'Configuración',
            accountInformation: 'Información de la cuenta',
            requestRole: 'Solicitar rol',
            transactionHistory: 'Historial de transacciones',
            notifications: 'Notificaciones',
        },
        memberTableItem: {
            userAlt: 'usuario',
            menu: {
                makeModerator: 'Hacer moderador',
                markWorshipLeadCandidate: 'Marcar como líder automático',
                removeWorshipLeadCandidate: 'Quitar líder automático',
                removeMember: 'Eliminar miembro',
            },
            confirmation: {
                grantModeratorPrivileges: 'Esta persona podrá crear y ajustar ensayos programados, además de gestionar altas y bajas de miembros. ¿Quieres continuar y otorgar privilegios de moderador?',
                markWorshipLeadCandidate: '¿Marcar a este miembro como elegible para asignaciones automáticas de líder?',
                removeWorshipLeadCandidate: '¿Quitar a este miembro de las asignaciones automáticas de líder?',
                approveRequest: '¿Deseas aprobar esta solicitud?',
                rejectRequest: '¿Deseas rechazar esta solicitud?',
            },
            toast: {
                songAddedToRehearsals: 'Canción agregada a ensayos',
                memberMadeModeratorSuccessfully: 'Miembro convertido en moderador correctamente',
                userSuspendedSuccessfully: 'Usuario suspendido correctamente',
                userBlockedSuccessfully: 'Usuario bloqueado correctamente',
                userRemovedSuccessfully: 'Usuario eliminado correctamente',
                memberMarkedWorshipLeadSuccessfully: 'Miembro marcado como candidato a líder automático',
                memberRemovedWorshipLeadSuccessfully: 'Miembro eliminado de candidatos a líder automático',
                memberLeadCandidateUpdateFailed: 'No se pudo actualizar el candidato a líder automático',
                requestApprovedSuccessfully: 'Solicitud aprobada correctamente',
                requestRejectedSuccessfully: 'Solicitud rechazada correctamente',
                upgradeSeatsToApproveRequest: 'No hay asientos disponibles. Actualiza los asientos para aprobar esta solicitud.',
            },
        },
        memberTable: {
            name: 'Nombre',
            email: 'Correo',
            part: 'Voz',
            dateJoined: 'Fecha de ingreso',
        },
        communityCard: {
            upvoteFailed: 'No se pudo votar positivamente',
            songTitle: 'Título de la canción',
            expandToFullView: 'Expandir a vista completa',
            fullscreenAlt: 'pantalla completa',
            songArtAlt: 'Arte de la canción',
            missingPartAlt: 'Voz faltante',
            partNeeded: 'Voz necesaria',
            topContributors: 'Principales contribuidores',
            contributorFallback: 'Contribuidor',
            contributorAvatarAlt: 'avatar del contribuidor',
            seeAllContributions: 'Ver todas las contribuciones',
        },
        communityCards: {
            loadFailed: 'No se pudieron cargar las contribuciones de la comunidad',
            errorGeneric: 'Ocurrió un error al cargar las contribuciones de la comunidad.',
            searchBySongTitle: 'Buscar por título de canción',
            all: 'Todos',
            errorAlt: 'Error',
            emptyAlt: 'Sin contribuciones',
            emptyDescription: 'No se encontraron contribuciones de la comunidad para tu búsqueda.',
            emptyPrompt: '¿Quieres obtener ayuda de la comunidad?',
            requestContribution: 'Solicitar una contribución',
            loadMore: 'Cargar más',
        },
        requestCards: {
            loadFailed: 'No se pudieron cargar las solicitudes',
            searchBySongTitle: 'Buscar por título de canción',
            all: 'Todos',
            emptyAlt: 'Sin contribuciones',
            emptyDescription: 'No se encontraron contribuciones de la comunidad para tu búsqueda.',
            emptyPrompt: '¿Quieres obtener ayuda de la comunidad?',
            requestContribution: 'Solicitar una contribución',
            loadMore: 'Cargar más',
        },
    },
    account: {
        currencyUpdated: 'Moneda preferida actualizada.',
        languageUpdated: 'Idioma preferido actualizado.',
        unableToUpdateCurrency: 'No se pudo actualizar la moneda preferida.',
        unableToUpdateLanguage: 'No se pudo actualizar el idioma preferido.',
    },
    accountInfo: {
        breadcrumbBase: 'Información de la cuenta',
        actions: {
            editProfile: 'Editar perfil',
            updateCard: 'Actualizar tarjeta',
        },
        sections: {
            subscription: 'Suscripción',
            payments: 'Pagos',
            marketplace: 'Marketplace',
            community: 'Comunidad',
            privacy: 'Privacidad',
            help: 'Ayuda',
        },
        links: {
            availablePlans: 'Planes disponibles',
            managePlans: 'Gestionar planes',
            orderHistory: 'Historial de pedidos',
            savedPaymentCard: 'Tarjeta de pago guardada',
            myPurchases: 'Mis compras',
            myOrders: 'Mis pedidos',
            uploadSong: 'Subir canción',
            myListings: 'Mis publicaciones',
            earnings: 'Ganancias',
            myChallenges: 'Mis retos',
            notifications: 'Notificaciones',
            support: 'Soporte VocalCentric',
        },
        languages: {
            en: 'Inglés',
            es: 'Español',
            fr: 'Francés',
            zh: 'Chino',
        },
        activePlan: {
            title: 'Plan activo',
            yourPlan: 'Tu plan',
            freePlan: 'Plan gratuito',
            referralCopied: 'Enlace de referido copiado al portapapeles',
            nextBill: 'Tu próxima factura es de {{price}} el {{date}}',
            currentlyFree: 'Actualmente estás en un plan gratuito,',
            upgradeToPremium: 'actualiza a premium',
        },
        editProfile: {
            updated: 'Perfil actualizado correctamente',
            selectDefaultPart: 'Selecciona la voz predeterminada',
            enterCountry: 'Ingresa país',
            country: 'País',
            update: 'Actualizar',
        },
        payment: {
            title: 'Tarjeta de pago guardada',
            subtitle: 'Gestiona tus métodos de pago para compras únicas. Para pagos de suscripción mensual, ve al resumen de cuenta.',
        },
        changePassword: {
            title: 'Cambiar contraseña',
            step1Subtitle: 'Para configurar una nueva contraseña de VocalCentric, debes volver a ingresar tu contraseña anterior.',
            enterOldPassword: 'Ingresa tu contraseña anterior',
            step2Subtitle: 'Ingresa el OTP enviado a tu correo.',
            step3Subtitle: 'Define tu contraseña preferida',
            success: 'Felicidades, cambiaste tu contraseña correctamente.',
        },
        challenges: {
            subtitle: 'Gestiona el historial de tus retos y completa la financiación para retos con premios en efectivo.',
            create: 'Crear reto',
            empty: 'Aún no has creado ningún reto.',
            explore: 'Explorar comunidad',
            entries: 'entradas',
            interests: 'intereses',
            created: 'Creado',
            fundingRequired: 'Financiación requerida',
            view: 'Ver',
            funding: 'Financiando...',
            fundNow: 'Financiar ahora',
            updating: 'Actualizando...',
            moveToUpcoming: 'Mover a próximos',
            filters: {
                all: 'Todos',
                active: 'En vivo',
                upcoming: 'Próximos',
                closed: 'Pasados',
                draft: 'Borrador',
            },
            sort: {
                highestReward: 'Mayor premio',
                latest: 'Más reciente',
                mostEntries: 'Más entradas',
            },
            table: {
                title: 'Título',
                status: 'Estado',
                entries: 'Entradas',
                reward: 'Premio',
                dates: 'Fechas',
                action: 'Acción',
            },
            status: {
                active: 'En vivo',
                upcoming: 'Próximos',
                closed: 'Pasados',
                draft: 'Borrador',
                pendingWinner: 'Ganador pendiente',
            },
            toast: {
                fundingWindowOpened: 'Se abrió la ventana de financiación. Completa el pago para pasar el reto a estado en vivo.',
                fundingInitialized: 'Financiación iniciada correctamente.',
                alreadyFunded: 'El reto ya está financiado. Se actualizó el estado.',
                fundingFailed: 'No se pudo iniciar la financiación del reto.',
                movedToUpcoming: 'El reto se movió a próximos correctamente.',
                moveToUpcomingFailed: 'No se pudo mover el reto a próximos.',
            },
        },
    },
    dashboard: {
        new: 'Nuevas',
        newDescription: 'Últimas canciones añadidas',
        popular: 'Populares',
        popularDescription: 'Canciones más populares',
        albums: 'Álbumes',
        albumsDescription: 'Todos los álbumes',
        artists: 'Artistas',
        artistsDescription: 'Todos los artistas',
        genres: 'Géneros',
        genresDescription: 'Todos los géneros',
        addSongToRehearsalPrompt: '¿Seguro que quieres agregar esta canción al ensayo?',
        gettingStarted: {
            label: 'Primeros pasos',
            progress: '{{completed}} de {{total}} completado',
            primaryCta: 'Abrir módulo sugerido',
            resumeCta: 'Reanudar onboarding',
            nextActions: {
                selectRole: 'Elige tu rol para personalizar tu espacio.',
                selectPart: 'Elige tu parte vocal para activar prácticas enfocadas.',
                confirmUsername: 'Confirma tu nombre de usuario para que colaboradores puedan encontrarte.',
                takeFirstAction: 'Completa tu primera acción guiada para terminar el onboarding.',
                completed: 'Todo listo.',
            },
        },
        songGuide: {
            eyebrow: 'Guía de biblioteca de canciones',
            notNow: 'Ahora no',
            resume: 'Reanudar',
            progress: 'Paso {{completed}} de {{total}}',
            hint: 'Completa la acción resaltada para desbloquear el siguiente paso',
            empty: {
                eyebrow: 'Empieza aquí',
                title: 'Aún no hay canciones cargadas',
                body: 'Cuando haya canciones disponibles, te guiaremos aquí en tus primeras acciones de escucha y ensayo.',
            },
            steps: {
                open_song: {
                    title: 'Reproduce una canción de la lista',
                    body: 'Haz clic en cualquier fila para abrir la reproducción y comenzar tu primer flujo de escucha.',
                },
                switch_stem: {
                    title: 'Cambia a un stem aislado',
                    body: 'Elige tu parte en el reproductor para practicar con el stem correcto.',
                },
                open_multitrack: {
                    title: 'Abre la vista multitrack completa',
                    body: 'Expande la vista multitrack para enfocarte en cada stem y ensayar con más control.',
                },
                close_multitrack: {
                    title: 'Cierra la vista multitrack completa',
                    body: 'Sal de la vista completa para volver a la lista y continuar la guía.',
                },
                add_to_rehearsal: {
                    title: 'Agrega una canción al ensayo',
                    body: 'Pon una canción en ensayo para conectar este módulo con tu flujo real.',
                },
                view_in_rehearsal: {
                    title: 'Abre la canción en ensayo',
                    body: 'Entra en ensayo para completar el flujo de canción de extremo a extremo.',
                },
            },
        },
        search: {
            noResultForKeyword: 'No hay resultados para la palabra clave {{keyword}}',
        },
        albumDetail: {
            fetchFailed: 'No se pudo cargar el álbum:',
            breadcrumb: 'Álbumes > {{title}}',
            breadcrumbLoading: 'Álbumes > Cargando...',
            notFound: 'Álbum no encontrado ...',
            bannerAlt: 'portada del álbum',
            albumLabel: 'Álbum',
            byLabel: 'Por: ',
            releasedYearLabel: 'Año de lanzamiento: ',
            songNumberLabel: 'Número de canciones: ',
            albumDurationLabel: 'Duración del álbum: ',
        },
        artistDetail: {
            breadcrumbNamed: 'Artista > {{name}}',
            breadcrumbLoading: 'Artista > Cargando...',
            empty: 'Artista no encontrado ...',
            label: 'Artista',
            bioLabel: 'Bio:',
            tags: {
                popular: {
                    title: 'Popular',
                    description: 'Canciones más populares',
                },
                albums: {
                    title: 'Álbumes',
                    description: 'Todos los álbumes',
                },
            },
        },
        cards: {
            songArtworkAlt: 'portada de {{title}}',
            albumArtAlt: 'arte del álbum',
            albumLabel: 'Álbum',
            artistLabel: 'Artista',
        },
        songTable: {
            title: 'Título',
            album: 'Álbum',
            genre: 'Género',
            votes: 'Votos',
            duration: 'Duración',
            action: 'Acción',
            single: 'Sencillo',
            viewInRehearsal: 'Ver en ensayo',
            addToRehearsal: 'Agregar al ensayo',
            addToSetlist: 'Agregar a setlist',
            viewCommunityReels: 'Ver reels de la comunidad',
            likeOrVote: 'Me gusta o votar',
            toast: {
                songAddedToRehearsals: 'Canción agregada a ensayos',
                songAlreadyInRehearsals: 'La canción ya está en ensayos',
            },
        },
        topHits: {
            song: 'Canción',
            votes: 'Votos',
            duration: 'Duración',
            actions: 'Acciones',
            rehearsed: 'Ensayada',
            addToRehearsal: 'Agregar al ensayo',
            iconAlt: 'icono',
        },
        topResult: {
            title: 'Resultado principal',
            artist: 'Artista',
            albumWithTitle: 'Álbum · {{title}}',
            songWithTitle: 'Canción · {{title}}',
            choirWithBio: 'Coro · {{bio}}',
            choirFallback: 'Coro',
        },
        searchGroup: {
            artists: 'Artistas',
            albums: 'Álbumes',
            contributionRequests: 'Solicitudes de contribución',
            communityContributions: 'Contribuciones de la comunidad',
            choirs: 'Coros',
        },
    },
    projects: {
        breadcrumbBase: 'Proyectos',
        discover: 'Descubrir',
        discoverDescription: 'Explora proyectos abiertos',
        myProjects: 'Mis proyectos',
        myProjectsDescription: 'Proyectos que gestionas',
        myInvites: 'Mis invitaciones',
        myInvitesDescription: 'Roles a los que te invitaron',
        myApplications: 'Mis solicitudes',
        myApplicationsDescription: 'Roles a los que aplicaste',
        headerSubtitle: 'Forma equipos temporales, descubre oportunidades activas y mueve colaboradores aceptados a un espacio de trabajo cuando sea necesario.',
        createProject: 'Crear proyecto',
        discoverInner: 'Descubrir',
        searchPlaceholder: 'Buscar proyectos, artistas, trabajos, producciones',
        allModes: 'Todos los modos',
        remote: 'Remoto',
        physical: 'Presencial',
        hybrid: 'Híbrido',
        compensation: 'Compensación',
        paid: 'Pagado',
        unpaid: 'No pagado',
        allRoles: 'Todos los roles',
        allCountries: 'Todos los países',
        noOpenProjects: 'No se encontraron proyectos abiertos con esos filtros.',
        myProjectsEmpty: 'Aún no has creado ningún proyecto.',
        roleFallback: 'Rol',
        detailsUnavailable: 'Detalles del proyecto no disponibles',
        locationLabel: 'Ubicación:',
        unavailable: 'No disponible',
        components: {
            projectCard: {
                positionsRequested: '{{count}} posiciones solicitadas',
                requirementsOnDetailView: 'Los requisitos del proyecto están disponibles en la vista de detalle',
                more: 'más',
                projectAlt: 'Proyecto',
                paidOpportunity: 'Oportunidad pagada',
                unpaidCollaboration: 'Colaboración no pagada',
                projectOwnerAvatarAlt: 'Avatar del propietario del proyecto',
                byOwner: 'por {{owner}}',
                needsLabel: 'Necesita:',
                openSlots: '{{count}} vacantes abiertas',
            },
            userProfileHover: {
                userFollowed: 'Usuario seguido.',
                userUnfollowed: 'Usuario dejado de seguir.',
                unableToFollowUser: 'No se pudo seguir al usuario.',
                unableToUnfollowUser: 'No se pudo dejar de seguir al usuario.',
                vocalcentricMember: 'Miembro de VocalCentric',
                followersCount: 'Seguidores: {{count}}',
                followingCount: 'Siguiendo: {{count}}',
                viewProfile: 'Ver perfil',
                follow: 'Seguir',
                unfollow: 'Dejar de seguir',
            },
            applicantProfileCard: {
                applicant: 'Postulante',
                unknownApplicant: 'Postulante desconocido',
                noPublicProfileSnapshotAttached: 'No hay una captura de perfil público adjunta.',
                noHeadlineProvided: 'No se proporcionó titular.',
                featuredWork: 'Trabajo destacado',
                shortlistApplication: 'Preseleccionar solicitud',
                acceptApplication: 'Aceptar solicitud',
                rejectApplication: 'Rechazar solicitud',
                viewFullProfile: 'Ver perfil completo',
            },
        },
        table: {
            project: 'Proyecto',
            role: 'Rol',
            status: 'Estado',
            actions: 'Acciones',
        },
        actions: {
            viewProject: 'Ver proyecto',
            viewApplication: 'Ver solicitud',
        },
        invites: {
            empty: 'No hay roles de proyecto por invitación esperándote ahora mismo.',
            fallbackProjectTitle: 'Invitación de proyecto',
            invitedBy: 'Invitado por',
            invitedByLabel: 'Invitado por:',
            invitationStatus: 'Estado de invitación',
            projectStatus: 'Estado del proyecto',
            visibility: 'Visibilidad',
            sent: 'Enviado',
        },
        applications: {
            empty: 'Aún no has aplicado a ningún rol de proyecto.',
            fallbackProjectTitle: 'Solicitud de proyecto',
            ownedBy: 'Propiedad de',
            ownerLabel: 'Propietario:',
            applicationStatus: 'Estado de la solicitud',
            projectStatus: 'Estado del proyecto',
            visibility: 'Visibilidad',
            submitted: 'Enviado',
            message: 'Mensaje',
            noNote: 'Sin nota adjunta.',
        },
        createForm: {
            createProject: 'Crear proyecto',
            editProject: 'Editar proyecto',
            updateProject: 'Actualizar proyecto',
            saveProject: 'Guardar proyecto',
            create: 'crear',
            update: 'actualizar',
            projectNotFound: 'Proyecto no encontrado.',
            ownerOnlyEdit: 'Solo el propietario del proyecto puede editar este proyecto.',
            projectBrief: 'Resumen del proyecto',
            projectBriefDescription: 'Define los detalles centrales de la colaboración y cómo los creativos deben descubrirla.',
            editDescription: 'Actualiza el resumen del proyecto, la disponibilidad y las reglas de colaboración.',
            createDescription: 'Publica un brief de colaboración enfocado sin forzarlo a la estructura del coro.',
            projectTitle: 'Título del proyecto',
            projectTitlePlaceholder: 'Banda para sesión dominical, llamado de BGV en estudio, elenco para producción de Pascua',
            projectDescription: 'Descripción del proyecto',
            projectDescriptionPlaceholder: 'Describe el trabajo, el sonido, las expectativas de ensayo y lo que deben saber los postulantes.',
            projectType: 'Tipo de proyecto',
            selectProjectType: 'Selecciona tipo de proyecto',
            location: 'Ubicación',
            locationPlaceholder: 'Lagos, Abuja, Remoto, Londres',
            country: 'País',
            countryPlaceholder: 'Nigeria, Estados Unidos, Reino Unido',
            compensationDetails: 'Detalles de compensación',
            selectCompensationDetails: 'Selecciona detalles de compensación',
            projectSettings: 'Configuración del proyecto',
            projectSettingsDescription: 'Define cómo los creativos encuentran el proyecto y el compromiso esperado.',
            visibility: 'Visibilidad',
            visibilityDescription: 'Controla si este proyecto es público.',
            public: 'Público',
            private: 'Privado',
            engagementMode: 'Modo de participación',
            engagementModeDescription: 'Elige cómo participarán los colaboradores.',
            remote: 'Remoto',
            physical: 'Presencial',
            hybrid: 'Híbrido',
            compensation: 'Compensación',
            compensationDescription: 'Define si esta oportunidad es pagada o no.',
            paid: 'Pagado',
            unpaid: 'No pagado',
            projectBudget: 'Presupuesto del proyecto',
            projectBudgetDescription: 'Define un tope de presupuesto para roles pagados y seguir compromisos.',
            totalBudget: 'Presupuesto total',
            applicationAccess: 'Acceso a postulaciones',
            applicationAccessDescription: 'Elige si el proyecto acepta postulaciones abiertas o solo por invitación.',
            open: 'Abierto',
            inviteOnly: 'Solo invitación',
            projectStatus: 'Estado del proyecto',
            projectStatusDescription: 'Controla si inicia como borrador, abierto o en revisión.',
            rolesNeeded: 'Roles requeridos',
            rolesNeededDescription: 'Agrega las posiciones que necesitas cubrir y define cómo aplicar a cada una.',
            roleN: 'Rol {{index}}',
            done: 'Listo',
            remove: 'Quitar',
            pluralSuffix: 's',
            openApplication: 'Postulación abierta',
            edit: 'Editar',
            roleType: 'Tipo de rol',
            selectRole: 'Selecciona rol',
            quantity: 'Cantidad',
            category: 'Categoría',
            chooseRoleTypeHint: 'Elige un tipo de rol para derivar la categoría',
            openApplicationDescription: 'Decide si este rol es visible para todos o solo para creativos invitados.',
            roleBudget: 'Presupuesto del rol',
            roleBudgetDescription: 'Define el presupuesto de {{type}} para este rol.',
            payment: 'pago',
            revenueSharePercentage: 'Porcentaje de reparto de ingresos',
            minimumBudget: 'Presupuesto mínimo',
            budget: 'Presupuesto',
            maximumBudget: 'Presupuesto máximo',
            roleNotes: 'Notas del rol',
            roleNotesPlaceholder: 'Expectativas de audición, requisitos de estilo, equipo y disponibilidad.',
            addRole: 'Agregar rol',
            toast: {
                projectUpdated: 'Proyecto actualizado correctamente',
                projectCreated: 'Proyecto creado correctamente',
                saveFailed: 'No se pudo {{action}} el proyecto',
            },
        },
        projectDetail: {
            ownerOnlyBudget: 'Solo el propietario del proyecto puede gestionar el presupuesto.',
            ownerOnlyApplications: 'Solo el propietario del proyecto puede revisar solicitudes aquí.',
            ownerOnlyInvites: 'Solo el propietario del proyecto puede gestionar invitaciones aquí.',
            common: {
                collaborator: 'Colaborador',
                compensation: 'Compensación',
                updated: 'Actualizado',
                view: 'Ver',
                submitted: 'Enviado',
                reviewed: 'Revisado',
                message: 'Mensaje',
                noMessage: 'No se adjuntó mensaje.',
                portfolio: 'Portafolio',
                openPortfolio: 'Abrir portafolio',
                auditionMedia: 'Media de audición',
                openAuditionMedia: 'Abrir media de audición',
                socialMedia: 'Red social',
                openProfile: 'Abrir perfil',
                auditionPreview: 'Vista previa de audición',
                reviewNotes: 'Notas de revisión',
            },
            budget: {
                breadcrumbTitle: 'Presupuesto',
                onlyPaid: 'La gestión de presupuesto está disponible solo para proyectos pagados.',
                enterValidAmount: 'Ingresa un monto válido no negativo.',
                updated: 'Presupuesto del proyecto actualizado.',
                updateFailed: 'No se pudo actualizar el presupuesto del proyecto',
                settingsTitle: 'Configuración de presupuesto',
                settingsSubtitle: 'Configura el presupuesto del proyecto y monitorea compromisos de roles antes de agregar nuevos roles pagados.',
                projectBudget: 'Presupuesto del proyecto',
                enterTotalBudget: 'Ingresa el presupuesto total',
                currency: 'Moneda',
                saveBudget: 'Guardar presupuesto',
                snapshotTitle: 'Resumen de presupuesto',
                notSet: 'No definido',
                committed: 'Comprometido',
                remaining: 'Restante',
                overrun: 'Los compromisos superan el presupuesto por {{amount}}.',
            },
            agreements: {
                breadcrumbTitle: 'Acuerdos',
                title: 'Acuerdos',
                ownerSubtitle: 'Gestiona la financiación en un solo checkout para todos los acuerdos elegibles.',
                viewerSubtitle: 'Revisa tu compensación y progreso de pago para este proyecto.',
                noEligibleFunding: 'No hay acuerdos elegibles para financiar.',
                mixedCurrencies: 'Los acuerdos elegibles tienen monedas mixtas y no se pueden financiar en un solo checkout.',
                fundingInitialized: 'Financiación del proyecto iniciada.',
                fundingInitFailed: 'No se pudo iniciar la financiación del proyecto',
                onlyPaid: 'Este proyecto no está configurado para acuerdos de compensación pagada.',
                fundEligible: 'Financiar acuerdos elegibles',
                openMembers: 'Abrir miembros',
                confirmWithSummary: 'Esto iniciará un checkout para {{summary}}. ¿Continuar?',
                confirmDefault: 'Esto iniciará un checkout para todos los acuerdos elegibles. ¿Continuar?',
                continue: 'Continuar',
                noneAssigned: 'Aún no tienes un acuerdo de compensación asignado.',
                addPayoutPrompt: 'Agrega una cuenta de pago para recibir transferencias cuando se procese este acuerdo.',
                setupPayout: 'Configurar cuenta de pago',
                withdrawalLabel: 'Retiro:',
                withdrawalRequested: 'Solicitado',
                withdrawalPending: 'Solicitud pendiente',
                payoutSetupRequired: 'Se requiere configurar cuenta de pago',
            },
            agreementDetail: {
                breadcrumbTitle: 'Detalle de acuerdo',
                agreementTitle: 'Acuerdo #{{id}}',
                detailsLoadFailed: 'No se pudieron cargar los detalles del acuerdo.',
                payee: 'Beneficiario',
                compensation: 'Compensación',
                escrow: 'Depósito en garantía',
                payout: 'Pago',
                financialActivity: 'Actividad financiera',
                noFinancialEvents: 'Aún no hay eventos financieros registrados.',
                payoutSnapshot: 'Resumen del pago',
                gross: 'Bruto',
                platformFee: 'Comisión de plataforma',
                netPayout: 'Pago neto',
                na: 'N/D',
                fundAgreement: 'Financiar acuerdo',
                requestRelease: 'Solicitar liberación',
                refund: 'Reembolsar',
                ownerActionsRestricted: 'Las acciones del propietario están restringidas. El pago avanza solo después de la liberación del propietario, tu solicitud de retiro y el procesamiento del administrador.',
                payoutSetupRequired: 'Se requiere configurar la cuenta de pago antes de que el administrador procese la transferencia.',
                withdrawalRequestedOn: 'Retiro solicitado el {{date}}.',
                requestWithdrawal: 'Solicitar retiro',
                confirmReleaseTitle: 'Confirmar solicitud de liberación',
                confirmReleaseDescription: 'Esto envía el pago para confirmación y procesamiento por parte del administrador. Los fondos no se pagan al colaborador de forma instantánea.',
                confirmRefundTitle: 'Reembolsar fondos en garantía',
                confirmRefundDescription: 'Los fondos retenidos en garantía se marcarán como reembolsados y este acuerdo se cancelará.',
                toast: {
                    notEligibleForFunding: 'El acuerdo no es elegible para financiación en este momento.',
                    fundingInitialized: 'Financiación iniciada.',
                    initializeFundingFailed: 'No se pudo iniciar la financiación',
                    releaseRequested: 'Solicitud de liberación enviada. Se requiere confirmación del administrador antes del pago.',
                    requestReleaseFailed: 'No se pudo solicitar la liberación',
                    escrowRefundProcessed: 'Reembolso de garantía procesado.',
                    processRefundFailed: 'No se pudo procesar el reembolso',
                    withdrawalRequested: 'Solicitud de retiro enviada. El administrador ya puede procesar tu pago.',
                    requestWithdrawalFailed: 'No se pudo solicitar el retiro',
                },
            },
            compensationPanel: {
                compensation: 'Compensación',
                notCreated: 'No creado',
                noAgreement: 'Sin acuerdo',
                agreement: 'Acuerdo',
                escrow: 'Depósito en garantía',
                payout: 'Pago',
                pendingAgreement: 'Acuerdo pendiente',
                percentageRevenueShare: '{{percentage}}% de participación en ingresos',
                pendingAmount: 'Monto pendiente',
                createAgreement: 'Crear acuerdo',
                viewAgreement: 'Ver acuerdo',
                flowHint: {
                    noAgreement: 'Aún no se ha creado un acuerdo para este colaborador.',
                    completed: 'Acuerdo completado y pago procesado.',
                    payoutFailed: 'El pago falló. Se requiere reintento del administrador.',
                    releaseRequested: 'Liberación solicitada. Esperando procesamiento del pago por el administrador.',
                    escrowSyncing: 'Se recibió el pago. El registro de garantía se está sincronizando.',
                    escrowHeld: 'Los fondos están retenidos en garantía y listos para solicitar liberación.',
                    cancelledRefunded: 'El acuerdo fue cancelado y la garantía fue reembolsada.',
                    awaitingFunding: 'Esperando financiación para mover este acuerdo a garantía.',
                },
            },
            header: {
                defaultShareTitle: 'Proyecto de VocalCentric',
                defaultShareText: 'Mira este proyecto en VocalCentric.',
                projectLinkCopied: 'Enlace del proyecto copiado.',
                unableToShareProjectLink: 'No se pudo compartir el enlace del proyecto.',
                projectArtAlt: 'Arte del proyecto',
                global: 'Global',
                positionsRequested: '{{count}} plazas solicitadas',
                shareProject: 'Compartir proyecto',
                editProject: 'Editar proyecto',
                tags: {
                    roles: {title: 'Roles', description: 'Requisitos del rol'},
                    applications: {title: 'Solicitudes', description: 'Solicitudes del proyecto'},
                    members: {title: 'Miembros', description: 'Colaboradores aceptados'},
                    budget: {title: 'Presupuesto', description: 'Presupuesto del proyecto'},
                    invites: {title: 'Invitaciones', description: 'Gestionar invitaciones del proyecto'},
                    agreements: {title: 'Acuerdos', description: 'Seguimiento de compensación'},
                },
            },
            members: {
                breadcrumbTitle: 'Miembros',
                title: 'Miembros',
                subtitle: 'Revisa colaboradores aceptados que están activos en este proyecto.',
                unpaidCollaboration: 'Colaboración no pagada',
                pendingAmount: 'Monto pendiente',
                compensationAgreementCreated: 'Acuerdo de compensación creado.',
                createAgreementFailed: 'No se pudo crear el acuerdo',
                empty: 'No hay colaboradores aceptados activos en este proyecto.',
                assignedCollaborator: 'Colaborador asignado',
                joined: 'Se unió',
                agreement: 'Acuerdo',
                manage: 'Gestionar',
                createAgreement: 'Crear acuerdo',
                noAgreementAssigned: 'No hay acuerdo asignado',
                noAgreement: 'Sin acuerdo',
            },
            applications: {
                breadcrumbTitle: 'Solicitudes',
                title: 'Solicitudes',
                subtitle: 'Revisa solicitudes entrantes y enfócate en la etapa que necesitas.',
                paidHint: 'Los colaboradores aceptados se pueden financiar desde la pantalla de Miembros.',
                statusUpdated: 'Solicitud {{status}}.',
                updateFailed: 'No se pudo actualizar la solicitud',
                loadDetailsFailed: 'No se pudieron cargar los detalles de la solicitud',
                empty: 'Aún no hay solicitudes para este proyecto.',
                noMatchFilter: 'No se encontraron solicitudes {{status}} para este filtro.',
                noNote: 'Sin nota adjunta.',
                shortlist: 'Preseleccionar solicitud',
                accept: 'Aceptar solicitud',
                reject: 'Rechazar solicitud',
                viewDetails: 'Ver detalles de la solicitud',
                applicant: 'Solicitante',
                applicantProfile: 'Perfil del solicitante',
                closeModalAria: 'Cerrar modal de solicitud',
                filters: {
                    all: 'Todas las solicitudes',
                    pending: 'Pendiente',
                    shortlisted: 'Preseleccionada',
                    accepted: 'Aceptada',
                    rejected: 'Rechazada',
                    withdrawn: 'Retirada',
                },
            },
            applicationDetail: {
                breadcrumbTitle: 'Detalle de solicitud',
                notFound: 'No se encontró la solicitud del proyecto.',
                snapshotTitle: 'Resumen de solicitud',
                backToApplications: 'Volver a solicitudes',
            },
            overview: {
                breadcrumbTitle: 'Resumen',
                collaborationRolesLabel: 'Roles de colaboración',
                applyToCollaborate: 'Postular para colaborar',
                applyToCollaborateSubtitle: 'Elige el rol que encaja con tus habilidades y envía tu solicitud.',
                ownerManagementLabel: 'Gestión del propietario',
                roleManagement: 'Gestión de roles',
                roleManagementSubtitle: 'Crea y administra roles de colaboración para este proyecto.',
                addRole: 'Agregar rol',
                inviteOnly: 'Solo por invitación',
                inviteOnlyHint: 'Este rol solo acepta solicitudes mediante invitación directa del propietario.',
                openSlots: '{{count}} vacantes',
                overrunDriver: 'Principal causante de sobrecosto',
                inviteParticipants: 'Invitar participantes',
                editRole: 'Editar rol',
                deleteRole: 'Eliminar rol',
                selected: 'Seleccionado',
                apply: 'Postular',
                projectSnapshot: 'Resumen del proyecto',
                owner: 'Propietario',
                visibility: 'Visibilidad',
                applicationAccess: 'Acceso de solicitudes',
                projectType: 'Tipo de proyecto',
                currentOverrun: 'Sobrecosto actual: {{amount}}',
                workspaceBridge: 'Puente de espacio de trabajo',
                workspaceBridgeSubtitle: 'Vincula este proyecto a un espacio de coro y sincroniza miembros aceptados.',
                syncFundedRequirementPrefix: 'La sincronización de miembros está disponible cuando todos los acuerdos pagados estén marcados como',
                funded: 'financiados',
                syncFundedRequirementSuffix: '.',
                useExistingChoir: 'Usar coro existente',
                createChoirFromProject: 'Crear coro desde el proyecto',
                useProjectTitleAsChoirName: 'Usar el título del proyecto como nombre del coro',
                choirName: 'Nombre del coro',
                enterChoirName: 'Ingresa el nombre del coro',
                createAndLinkChoir: 'Crear y vincular coro',
                choirWorkspace: 'Espacio del coro',
                selectDirectedChoir: 'Selecciona un coro que diriges',
                linkChoir: 'Vincular coro',
                membersToSync: 'Miembros para sincronizar',
                noActiveMembers: 'No hay miembros activos para sincronizar todavía.',
                contributor: 'Colaborador',
                selectAll: 'Seleccionar todo',
                clear: 'Limpiar',
                syncSeatsHint: 'Asientos disponibles: {{available}} • Miembros seleccionados: {{selected}}',
                syncSeatsExceededHint: 'Los miembros seleccionados superan los asientos disponibles ({{selected}} seleccionados, {{available}} disponibles). Reduce la selección o actualiza los asientos.',
                syncSelectedMembers: 'Sincronizar miembros seleccionados',
                linkedChoirWorkspace: 'Espacio de coro vinculado: {{choir}}',
                syncedMembers: 'Miembros sincronizados: {{count}}',
                linkedNoSyncedYet: 'Vinculado correctamente. Aún no se han sincronizado miembros.',
                noExtraNotesYet: 'Aún no hay notas adicionales.',
                viewerState: {
                    label: 'Estado del visitante',
                    memberTitle: 'Ya formas parte de este proyecto',
                    memberBody: 'Actualmente eres colaborador activo en este proyecto.',
                    applicationSubmittedTitle: 'Solicitud enviada',
                    applicationSubmittedBody: 'Tu solicitud está en revisión. El propietario te actualizará pronto.',
                    inviteAccessTitle: 'Acceso por invitación concedido',
                    inviteAccessBody: 'Puedes ver y postular a roles habilitados por invitación.',
                    inviteAccessPrivateBody: 'Puedes acceder a este proyecto privado mediante tu invitación.',
                    limitedAccessTitle: 'Acceso limitado',
                    limitedAccessBody: 'Este proyecto es privado. Necesitas invitación para postular a roles.',
                },
                unavailable: {
                    alreadyMember: 'Ya estás asignado a este proyecto.',
                    alreadyApplied: 'Ya enviaste una solicitud para este proyecto.',
                    inviteRequired: 'Este rol es solo por invitación. Solicita un enlace al propietario.',
                    notAccepting: 'Las solicitudes no están disponibles porque este proyecto está {{status}}.',
                    roleUnavailable: 'Este rol no está disponible para solicitudes en este momento.',
                },
                toast: {
                    invalidReelLink: 'Ingresa un enlace de reel válido antes de cargar.',
                    reelNoPlayableMedia: 'Este reel no tiene un medio reproducible.',
                    resolveReelFailed: 'No se pudo cargar el medio del reel en este momento.',
                    chooseRoleBeforeApply: 'Elige un rol antes de enviar tu solicitud.',
                    applicationSent: 'Solicitud enviada correctamente.',
                    submitApplicationFailed: 'No se pudo enviar tu solicitud.',
                    selectChoirToLink: 'Selecciona un coro para vincular.',
                    choirLinked: 'Coro vinculado al espacio del proyecto.',
                    linkChoirFailed: 'No se pudo vincular el espacio del coro.',
                    enterChoirName: 'Ingresa un nombre de coro antes de crear.',
                    resolveCreatedChoirFailed: 'No se pudo resolver el coro recién creado.',
                    choirCreatedAndLinked: 'Coro creado y vinculado correctamente.',
                    createAndLinkFailed: 'No se pudo crear y vincular el espacio del coro.',
                    linkBeforeSync: 'Vincula un espacio de coro antes de sincronizar miembros.',
                    selectMembersToSync: 'Selecciona al menos un miembro para sincronizar.',
                    notEnoughSeatsForSelection: 'Los miembros seleccionados superan los asientos disponibles del coro. Reduce la selección o actualiza los asientos.',
                    membersSynced: 'Miembros sincronizados correctamente.',
                    membersSyncedCount: '{{count}} miembros sincronizados correctamente.',
                    syncChoirFailed: 'No se pudieron sincronizar miembros con el espacio del coro.',
                    chooseRoleBeforeAdd: 'Elige un tipo de rol antes de guardar.',
                    roleAdded: 'Rol agregado correctamente.',
                    roleUpdated: 'Rol actualizado correctamente.',
                    addRoleFailed: 'No se pudo guardar el rol.',
                    roleDeleted: 'Rol eliminado correctamente.',
                    deleteRoleFailed: 'No se pudo eliminar el rol.',
                    enterInviteEmail: 'Ingresa un correo válido del invitado.',
                },
                applyModal: {
                    title: 'Postular para {{role}}',
                    description: 'Comparte el contexto que ayude al propietario a decidir rápidamente.',
                    openCount: '{{count}} vacantes',
                    messageLabel: 'Mensaje',
                    messagePlaceholder: 'Preséntate, tu disponibilidad y por qué encajas en este rol.',
                    portfolioLabel: 'Enlace de portafolio',
                    portfolioPlaceholder: 'Spotify, YouTube, sitio web, EPK',
                    auditionMediaSource: 'Fuente de media de audición',
                    auditionSource: {
                        external: 'URL externa',
                        upload: 'Carga de VocalCentric',
                        reel: 'URL de Reel de VocalCentric',
                    },
                    auditionLinkLabel: 'Enlace de audición',
                    auditionLinkPlaceholder: 'Drive, YouTube, Dropbox',
                    uploadReady: 'Carga lista. El propietario podrá previsualizar este medio en la revisión.',
                    uploadHint: 'Sube un clip de audición. VC proporcionará manifiestos HLS/DASH.',
                    reelUrlLabel: 'URL del reel',
                    reelUrlPlaceholder: 'https://.../reel/<reel-id>',
                    loadReel: 'Cargar reel',
                    loading: 'Cargando...',
                    reelLinked: 'Reel vinculado correctamente. El propietario podrá previsualizar este medio en línea.',
                    socialMediaLabel: 'Enlace de red social',
                    socialMediaPlaceholder: 'Instagram, TikTok, X, Facebook',
                    submitApplication: 'Enviar solicitud',
                    submitting: 'Enviando...',
                    applicationsUnavailable: 'Solicitudes no disponibles',
                    close: 'Cerrar',
                },
                addRoleModal: {
                    addTitle: 'Agregar rol',
                    editTitle: 'Editar rol',
                    addDescription: 'Agrega un nuevo rol aquí. La gestión de invitaciones está en la pestaña de Invitaciones.',
                    editDescription: 'Actualiza este rol aquí. La gestión de invitaciones está en la pestaña de Invitaciones.',
                    roleType: 'Tipo de rol',
                    selectRole: 'Seleccionar rol',
                    quantity: 'Cantidad',
                    applicationAccess: 'Acceso de solicitudes',
                    accessOpen: 'Abierto',
                    accessInviteOnly: 'Solo por invitación',
                    category: 'Categoría',
                    chooseRoleTypeToDeriveCategory: 'Elige un tipo de rol para derivar la categoría',
                    roleBudget: 'Presupuesto del rol',
                    payment: 'pago',
                    setBudgetForRole: 'Define el presupuesto de {{paymentType}} para este rol.',
                    revenueSharePercentage: 'Porcentaje de reparto de ingresos',
                    revenueSharePlaceholder: '15',
                    fixedBudget: 'Presupuesto fijo',
                    budgetRange: 'Rango de presupuesto',
                    budget: 'Presupuesto',
                    minimumBudget: 'Presupuesto mínimo',
                    maximumBudget: 'Presupuesto máximo',
                    projectedOverrunWarning: 'Advertencia: el compromiso proyectado supera el presupuesto por {{amount}}.',
                    projectedCommitmentAfterSave: 'Compromiso proyectado tras guardar: {{projected}} de {{budget}}.',
                    roleNotes: 'Notas del rol',
                    roleNotesPlaceholder: 'Expectativas de audición, requisitos de estilo, equipo y disponibilidad.',
                    saveChanges: 'Guardar cambios',
                    saveRole: 'Guardar rol',
                },
                inviteModal: {
                    title: 'Invitar a {{role}}',
                    description: 'Envía una invitación directa por correo para este rol solo por invitación.',
                    openCount: '{{count}} vacantes',
                    inviteeEmail: 'Correo del invitado',
                    inviteeEmailPlaceholder: 'nombre@ejemplo.com',
                },
                deleteModal: {
                    title: 'Eliminar rol',
                    description: 'Quita {{role}} de este proyecto. Solo funciona si el rol no tiene plazas ocupadas.',
                    deleteRole: 'Eliminar rol',
                },
            },
            invites: {
                breadcrumbTitle: 'Invitaciones',
                title: 'Invitaciones',
                subtitle: 'Haz seguimiento de invitaciones pendientes de rol y gestiona el alcance del propietario.',
                revoked: 'Invitación revocada.',
                resent: 'Invitación reenviada.',
                updateFailed: 'No se pudo actualizar la invitación',
                chooseRoleAndEmail: 'Elige un rol e ingresa un correo.',
                addRoleFirst: 'Agrega este rol al proyecto antes de invitar colaboradores.',
                sent: 'Invitación enviada correctamente.',
                sendFailed: 'No se pudo enviar la invitación',
                sendInvite: 'Enviar invitación',
                sendNewTitle: 'Enviar nueva invitación',
                sendNewDescription: 'Elige un rol y envía una invitación directa por correo.',
                chooseRole: 'Elegir rol',
                emailPlaceholder: 'creador@ejemplo.com',
                noMatchFilters: 'Ninguna invitación coincide con los filtros actuales.',
                empty: 'Aún no se han enviado invitaciones de rol para este proyecto.',
                resend: 'Reenviar invitación',
                revoke: 'Revocar invitación',
                invitee: 'Invitado',
                filters: {
                    all: 'Todas las invitaciones',
                    pending: 'Pendiente',
                    applied: 'Aplicada',
                    revoked: 'Revocada',
                },
            },
        },
    },
    choir: {
        belongTo: 'Pertenezco',
        belongToDescription: 'Coros de los que formas parte',
        canJoin: 'Coros a los que puedes unirte',
        canJoinDescription: 'Coros a los que puedes unirte',
        managedByYou: 'Gestionados por ti',
        managedByYouDescription: 'Coros que estás gestionando',
        headerSubtitle: 'Mira los coros de los que formas parte y los que gestionas',
        createChoir: 'Crear coro',
        emptyStart: '¿Qué esperas? Puedes iniciar lo tuyo y liderar el show.',
        createAChoir: 'Crear un coro',
        becomeDirector: 'Ser director',
        emptySeenAll: 'Has recorrido mucho, ya lo has visto todo',
        join: 'Unirse',
        noJoinedChoirYet: 'Aún no te has unido a ningún coro',
        joinAChoir: 'Unirse a un coro',
        requestToJoin: 'Solicitar unirte al coro',
        publicPage: {
            feedTab: 'Feed',
            setlistsTab: 'Setlists',
            resourcesTab: 'Recursos',
            joinTab: 'Unirse',
            feedTitle: 'Feed público',
            setlistsTitle: 'Setlists públicos',
            resourcesTitle: 'Recursos públicos',
            joinTitle: 'Únete a este coro',
            joinSubtitle: 'Crea una cuenta o inicia sesión para solicitar acceso.',
            noPublicPosts: 'Aún no hay publicaciones públicas.',
            noPublicSetlists: 'Aún no hay setlists públicos.',
            noPublicResources: 'Aún no hay recursos públicos.',
            signUpToJoin: 'Regístrate para solicitar acceso',
            signInToJoin: '¿Ya tienes cuenta? Inicia sesión',
            joinClosed: 'Este coro no acepta solicitudes para unirse ahora.',
            resourceFrom: 'De {{name}}',
            publicProfileLoadFailed: 'No se pudo cargar esta página del coro.',
            feedLoadFailed: 'No se pudo cargar el feed público.',
            setlistsLoadFailed: 'No se pudieron cargar los setlists públicos.',
            postTopic: 'Publicar tema',
            postTopicPlaceholder: 'Comparte un tema sobre este coro',
            postTopicFailed: 'No se pudo publicar tu tema. Vuelve a intentarlo.',
            newUpdates: '{{count}} actualización(es) nueva(s)',
            follow: 'Seguir',
            following: 'Siguiendo',
            followersCount: '{{count}} seguidor(es)',
            followed: 'Coro seguido.',
            unfollowed: 'Dejaste de seguir el coro.',
            followFailed: 'No se pudo actualizar el seguimiento del coro.',
        },
        claimPage: {
            eyebrow: 'Directorio de coros',
            title: 'Reclamar este coro',
            description: 'Conecta {{name}} con el coro interno que administras. Un administrador de VocalCentric revisará tus pruebas antes de cambiar nada.',
            unavailable: 'Este coro público no está disponible o ya no se puede reclamar.',
            signInTitle: 'Inicia sesión para reclamar este coro',
            signInDescription: 'Elige el coro interno que administras y aporta pruebas de que representas a este coro.',
            signIn: 'Iniciar sesión',
            signUp: 'Crear una cuenta',
            noChoirs: 'Crea primero un coro interno y vuelve aquí para enviar una reclamación.',
            createChoir: 'Crear un coro',
            choirLabel: 'Tu coro interno',
            proofUrlLabel: 'URL de prueba (opcional)',
            proofNoteLabel: 'Nota de prueba (opcional)',
            proofHint: 'Incluye una URL o una nota. Las reclamaciones se revisan manualmente.',
            submit: 'Enviar reclamación para revisión',
            submitting: 'Enviando reclamación...',
            submitFailed: 'No se pudo enviar esta reclamación.',
            submittedTitle: 'Reclamación enviada',
            submittedDescription: 'Tu reclamación está pendiente de revisión. La página del directorio redirigirá a tu coro interno tras la aprobación.',
        },
        planBadge: {
            premium: 'Premium',
            free: 'Gratis',
        },
        paywall: {
            upgradeRequiredTitle: 'Actualización de coro requerida',
            upgradeRequiredBody: 'Actualiza este coro para continuar.',
            rehearsalLimitReached: 'Los coros gratuitos pueden crear hasta {{limit}} ensayos. Actualiza este coro para agregar más.',
            setlistLimitReached: 'Los coros gratuitos pueden crear hasta {{limit}} setlists. Actualiza este coro para agregar más.',
            memberLimitReached: 'Los coros gratuitos pueden tener hasta {{limit}} miembros. Actualiza este coro para agregar más miembros.',
            privateSetlistsRequireUpgrade: 'Los setlists de coros gratuitos son públicos. Actualiza este coro para hacer setlists privados.',
            profileVisibilityRequiresUpgrade: 'Los perfiles de coros gratuitos deben permanecer públicos en la pantalla para unirse al coro. Actualiza este coro para ocultar el perfil.',
            rehearsalResourcesExpired: 'Los recursos gratuitos de ensayo del coro están disponibles durante {{days}} días. Actualiza este coro para seguir usando letras, armonías personalizadas, diapositivas y herramientas de práctica.',
            harmonyVisibilityRequiresUpgrade: 'Las armonías personalizadas de coros gratuitos son públicas. Actualiza este coro para usar armonías privadas o solo para el coro.',
            rehearsalLimitTitle: 'Límite de ensayos alcanzado ({{current}} de {{limit}})',
            setlistLimitTitle: 'Límite de setlists alcanzado ({{current}} de {{limit}})',
            memberLimitTitle: 'Límite de miembros alcanzado ({{current}} de {{limit}})',
            privateSetlistsTitle: 'Los setlists privados requieren actualización',
            rehearsalResourcesExpiredTitle: 'Acceso a recursos expirado',
            profileVisibilityTitle: 'Visibilidad del perfil bloqueada',
            harmonyVisibilityTitle: 'Visibilidad de armonías bloqueada',
        },
        guide: {
            eyebrow: 'Guía de coros',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            join: {
                title: 'Únete a un coro',
                body: 'Elige un coro y envía tu solicitud para empezar a participar.',
            },
            create: {
                title: 'Crea un coro',
                body: 'Crea primero un coro y luego abre ensayos para iniciar el flujo semanal.',
            },
        },
        rehearsalGuide: {
            eyebrow: 'Guía de ensayos',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            create: {
                title: 'Crea tu primer ensayo',
                body: 'Inicia un ensayo para que tu coro pase de la configuración a una sesión real de trabajo.',
            },
        },
        setlistsGuide: {
            eyebrow: 'Guía de setlists',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            create: {
                title: 'Crea tu primer setlist',
                body: 'Crea un setlist del coro para agrupar canciones antes de organizar el calendario más amplio.',
            },
            rehearsal: {
                title: 'Crea un ensayo desde tu setlist',
                body: 'Convierte ese setlist en un ensayo real para que las canciones entren en una sesión activa del coro.',
            },
        },
        scheduleGuide: {
            eyebrow: 'Guía de horario',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            serviceDays: {
                title: 'Configura tus días de servicio',
                body: 'Agrega primero los días de servicio para que VocalCentric pueda crear un horario útil para el coro.',
            },
            create: {
                title: 'Crea tu primer horario',
                body: 'Crea el primer horario para que los miembros vean asignaciones y próximos servicios.',
            },
        },
        membersGuide: {
            eyebrow: 'Guía de miembros',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            invite: {
                title: 'Invita a tu primer miembro',
                body: 'Invita a una persona para que el coro pase de la configuración a un equipo activo.',
            },
        },
        rehearsalSongsGuide: {
            eyebrow: 'Guía de canciones del ensayo',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            add_song: {
                title: 'Añade canciones a este ensayo',
                body: 'Agrega primero canciones al ensayo para que tu coro tenga una lista real sobre la que trabajar.',
            },
            open: {
                title: 'Abre una canción del ensayo',
                body: 'Abre la primera canción para que el coro pase de la planificación al ensayo real.',
            },
        },
        rehearsalRunthroughGuide: {
            eyebrow: 'Guía del recorrido de ensayo',
            resume: 'Continuar guía',
            notNow: 'Ahora no',
            progress: 'Paso {{completed}} de {{total}}',
            add_lyrics: {
                title: 'Añade la letra de esta canción',
                body: 'Sube o pega primero la letra para que los miembros ensayen con contenido estructurado.',
            },
            upload_reference_audio: {
                title: 'Sube el audio de referencia',
                body: 'Añade una referencia de audio adecuada para el coro para que todos ensayen con la versión correcta.',
            },
            add_custom_harmony: {
                title: 'Añade una armonía personalizada',
                body: 'Crea las partes de armonía del coro para que los cantantes practiquen con el arreglo real.',
            },
            review_submission: {
                title: 'Revisa una práctica enviada',
                body: 'Abre una práctica enviada por un miembro y deja indicaciones para cerrar el ciclo del ensayo.',
            },
            open_practise: {
                title: 'Abre la práctica de esta canción',
                body: 'Entra en la pestaña de práctica para empezar a grabar tu parte sobre el arreglo del coro.',
            },
            record_practice_section: {
                title: 'Graba tu primera sección',
                body: 'Graba una sección para iniciar una práctica real en lugar de solo explorar la canción.',
            },
            submit_practice: {
                title: 'Envía tu práctica',
                body: 'Envía tu primera toma para que el director la revise y el flujo de ensayo quede completo.',
            },
        },
        management: {
            detailHeader: {
                rehearsalsTitle: 'Ensayos',
                rehearsalsDescription: 'Cada sábado',
                setlistsTitle: 'Setlists',
                setlistsDescription: 'Setlists del coro',
                setlistsExtra: 'Setlists',
                scheduleTitle: 'Horario',
                scheduleDescription: 'Horario del coro por período',
                scheduleExtra: 'Horario',
                membersTitle: 'Miembros',
                membersExtra: 'Miembros',
                feedsTitle: 'Actividad',
                feedsExtra: 'Actividad',
                integrateTitle: 'Integraciones',
                integrateDescription: 'Integraciones',
            },
            edit: {
                title: 'Editar coro',
            },
            rehearsals: {
                title: 'Ensayos del coro',
                createRehearsal: 'Crear ensayo',
                deleteRehearsal: 'Eliminar ensayo',
                empty: 'No has creado ensayos para este coro',
                noPermission: 'No tienes permiso para crear un ensayo',
                toast: {
                    deleted: 'Ensayo del coro eliminado',
                    deleteFailed: 'No se pudo eliminar el ensayo del coro',
                    choirIdRequired: 'Se requiere el ID del coro',
                },
            },
            createRehearsal: {
                title: 'Crear ensayo',
                manualMode: 'Modo manual',
                fromSetlist: 'Desde setlist',
                rehearsalTitle: 'Título del ensayo',
                rehearsalTitleOptional: 'Título del ensayo (opcional)',
                shortDescription: 'Descripción breve',
                shortDescriptionOptional: 'Descripción breve (opcional)',
                pasteSetlistLink: 'Pegar enlace del setlist',
                pasteSetlistLinkPlaceholder: 'Pega aquí el enlace del setlist',
                usingSetlist: 'Usando setlist {{kind}}',
                choirSetlistKind: 'del coro',
                personalSetlistKind: 'personal',
                addSongsPrompt: 'Agrega canciones al ensayo.',
                searchSongsPlaceholder: 'Buscar canciones para agregar al ensayo',
                removeSong: 'Quitar',
                songsInSetlist: 'Canciones del setlist',
                notAvailable: '—',
                external: 'Externo',
                internal: 'Interno',
                addSelectedSong: 'Agregar canción',
                additionalResourcesOptional: 'Recursos adicionales (opcional)',
                additionalResourcesPrompt: '¿Quieres agregar recursos adicionales?',
                uploadResources: 'Haz clic para subir recursos de aprendizaje desde tu computadora o teléfono',
                date: 'Fecha',
                from: 'Desde',
                fromOptional: 'Desde (opcional)',
                to: 'Hasta',
                toOptional: 'Hasta (opcional)',
                virtual: 'Virtual',
                physical: 'Presencial',
                setReminder: 'Configurar recordatorio',
                setReminderOptional: 'Configurar recordatorio (opcional)',
                selectReminderTime: 'Seleccionar hora del recordatorio',
                createButton: 'Crear ensayo',
                reminders: {
                    oneHour: '1 hora antes',
                    twoHours: '2 horas antes',
                    threeHours: '3 horas antes',
                    fourHours: '4 horas antes',
                    fiveHours: '5 horas antes',
                    sixHours: '6 horas antes',
                    twelveHours: '12 horas antes',
                    twentyFourHours: '24 horas antes',
                },
                toast: {
                    fillRequired: 'Completa todos los campos obligatorios',
                    created: 'Ensayo creado correctamente',
                    createFailed: 'Error al crear el ensayo',
                    choirSetlistNotFound: 'No se encontró el setlist del coro',
                    loadChoirSetlistFailed: 'No se pudo cargar el setlist del coro',
                    setlistNotFound: 'No se encontró el setlist',
                    fetchSetlistFailed: 'No se pudo obtener el setlist',
                },
            },
            setlists: {
                title: 'Setlists del coro',
                newChoirSetlist: 'Nuevo setlist del coro',
                empty: 'Aún no hay setlists del coro.',
                copyLink: 'Copiar enlace',
                createRehearsalFromSetlist: 'Crear ensayo desde este setlist',
                delete: 'Eliminar',
                linked: 'Vinculado',
                sharedBy: 'Compartido por {{name}}',
                songCount: '{{count}} canción(es)',
                updatedDate: 'Actualizado: {{date}}',
                searchPlaceholder: 'Buscar por setlist, canción o metadatos',
                searchEmpty: 'No hay setlists del coro que coincidan con tu búsqueda.',
                searchFailed: 'No se pudieron buscar los setlists del coro',
                loadFailed: 'No se pudieron cargar los setlists del coro',
                linkCopied: '¡Enlace copiado al portapapeles!',
                deleted: 'Setlist del coro eliminado',
                deleteFailed: 'No se pudo eliminar el setlist',
                createModal: {
                    title: 'Crear setlist del coro',
                    description: 'Empieza con un nombre. Luego podrás agregar canciones y convertirlo en un ensayo.',
                    nameLabel: 'Nombre del setlist',
                    namePlaceholder: 'Setlist del ensayo del domingo',
                    confirm: 'Crear setlist',
                    creating: 'Creando...',
                    toast: {
                        created: 'Setlist del coro creado',
                        createFailed: 'No se pudo crear el setlist del coro',
                    },
                },
                manageModal: {
                    title: 'Gestionar "{{name}}"',
                    description: 'Revisa las canciones de esta setlist del coro, agrega nuevas y quita las que haga falta.',
                    viewOnlyDescription: 'Revisa las canciones de esta setlist del coro.',
                    viewOnlyNotice: 'Solo directores y moderadores del coro pueden editar esta setlist.',
                    addSongs: 'Agregar canciones',
                    shareLink: 'Enlace de setlist',
                },
            },
            rehearsalSongs: {
                resourcesTitle: 'Recursos de aprendizaje',
                resourcesDescription: 'Partituras, documentos y audio para este repertorio.',
                addResources: 'Añadir recursos',
                closeResourceUpload: 'Listo',
                resourceType: 'Tipo de recurso',
                documentResource: 'Documento',
                scoreResource: 'Partitura',
                resourceLabel: 'Etiqueta del recurso (opcional)',
                resourceLabelPlaceholder: 'p. ej., guía de calentamiento',
                uploadDocuments: 'Subir partituras o documentos',
                uploadMusicXml: 'Subir partitura MusicXML',
                musicXmlDescription: 'Admite MusicXML, XML o MXL',
                uploadMidiOptional: 'Subir MIDI (opcional)',
                uploadDryRun: 'Subir audio',
                dryRunAudio: 'Audio',
                previewResource: 'Vista previa del recurso',
                playResource: 'Reproducir audio',
                practiceDryRun: 'Practicar {{name}}',
                openLyrics: 'Abrir la letra de {{title}}',
                openPractice: 'Abrir la práctica de {{title}}',
                openPracticeReview: 'Abrir la revisión de práctica de {{title}}',
                editDryRun: 'Editar {{name}}',
                dryRunLyrics: 'Letra del ensayo',
                dryRunLyricsPlaceholder: 'Añade letra o notas para este ensayo...',
                listenEntireAudio: 'Escuchar todo el audio',
                listenSegment: 'Escuchar un segmento',
                segmentStart: 'Inicio (segundos)',
                segmentEnd: 'Fin (segundos)',
                invalidListenSegment: 'El final debe ser posterior al inicio.',
                deleteResource: 'Eliminar {{name}}',
                deleteResourceConfirm: '¿Eliminar {{name}} de este ensayo?',
                playYouTubeReference: 'Reproducir {{title}} en YouTube',
                youtubePlayer: 'Reproductor de YouTube',
                viewListenAudit: 'Ver auditoría de escucha',
                listenAudit: 'Auditoría de escucha',
                listenAuditSummary: '{{listeners}} oyente(s) • {{listens}} escucha(s)',
                listenAuditDescription: 'Consulta quién ha escuchado este ensayo.',
                loadingListenAudit: 'Cargando auditoría de escucha...',
                listenAuditLoadFailed: 'No se pudo cargar la auditoría de escucha.',
                noListens: 'Todavía no hay escuchas registradas.',
                nudgeChoir: 'Recordar al coro',
                nudgingChoir: 'Enviando recordatorio...',
                nudgeSent: 'Recordatorio enviado a {{count}} miembro(s) del coro.',
                nudgeFailed: 'No se pudo enviar el recordatorio.',
                audioPlaybackUnavailable: 'La reproducción de audio no está disponible en este momento.',
                openInNewTab: 'Abrir en una pestaña nueva',
                noResources: 'Todavía no se han añadido recursos de aprendizaje.',
                setlistResource: 'Recurso de lista',
                resourceOpenFailed: 'No se pudo abrir este recurso.',
                addSetlists: 'Añadir listas',
                addSetlistsDescription: 'Adjunta canciones y recursos de listas del coro.',
                addSelectedSetlists: 'Añadir listas seleccionadas',
                addingSetlists: 'Añadiendo listas...',
                setlistsLoadFailed: 'No se pudieron cargar las listas.',
                setlistsAdded: 'Listas añadidas al ensayo',
                setlistsAddFailed: 'No se pudieron añadir las listas.',
                noSetlistsAvailable: 'Todas las listas disponibles ya están adjuntas.',
                additionalSongs: 'Canciones adicionales',
                expandSetlist: 'Expandir {{name}}',
                collapseSetlist: 'Contraer {{name}}',
                songsInSetlist: '{{count}} canciones',
                noSongsInSetlist: 'No hay canciones en esta lista.',
                savingResources: 'Guardando recursos...',
                resourcesSaved: 'Recursos del ensayo actualizados',
                resourcesSaveFailed: 'No se pudieron actualizar los recursos',
                title: 'Canciones del ensayo',
                addSong: 'Agregar canción',
                addToRehearsal: 'Añadir al ensayo',
                startRehearsal: 'Iniciar ensayo',
                startingRehearsal: 'Iniciando ensayo',
                deleteConfirm: '¿Eliminar esta canción del ensayo?',
                moveSongUp: 'Mover canción arriba',
                moveSongDown: 'Mover canción abajo',
                songActions: 'Acciones de {{title}}',
                currentSongSettings: 'Tonalidad: {{key}} • Objetivo: {{target}}',
                noKeySet: 'Sin definir',
                entireSong: 'Canción completa',
                openCustomHarmonies: 'Armonías personalizadas',
                songSettings: 'Ajustes de la canción',
                songSettingsDescription: 'Configura los detalles del ensayo para {{title}}.',
                songKey: 'Tonalidad',
                songLabel: 'Etiqueta del ensayo',
                songLabelPlaceholder: 'p. ej., Repetición u Ofrenda',
                listenTarget: 'Objetivo de escucha',
                youtubeReference: 'Referencia de YouTube',
                deleteSong: 'Eliminar canción',
                savingSettings: 'Guardando ajustes...',
                settingsNoChanges: 'No se cambiaron los ajustes.',
                settingsSaved: 'Ajustes de la canción actualizados.',
                settingsPartiallySaved: 'No se pudieron actualizar algunos ajustes.',
                settingsSaveFailed: 'No se pudieron actualizar los ajustes.',
                toast: {
                    removed: 'Canción eliminada del ensayo',
                    removeFailed: 'No se pudo eliminar la canción',
                    choirIdRequired: 'Se requiere el ID del coro',
                    reorderFailed: 'No se pudieron reordenar las canciones del ensayo',
                },
            },
            members: {
                title: 'Miembros {{seatCount}} de {{maxSeatCount}}',
                addSeats: 'Agregar cupos',
                manageSharedSeats: 'Compartir cupos',
                redeemSharedSeats: 'Canjear código de cupos',
                addMember: 'Agregar miembro',
                addMembersPage: 'Agregar miembros',
                searchPlaceholder: 'Buscar miembros',
                searchEmpty: 'No hay miembros que coincidan con tu búsqueda.',
                actions: 'Acciones',
                tabs: {
                    all: {
                        title: 'Todos',
                        description: 'Miembros actuales del coro',
                    },
                    invite: {
                        title: 'Invitados',
                        description: 'Miembros invitados al coro',
                    },
                    requests: {
                        title: 'Solicitudes',
                        description: 'Solicitudes para unirse al coro',
                    },
                },
                empty: {
                    members: 'Aún no hay miembros en tu coro, ¿por qué no invitas a más personas? 🙂',
                    invitations: 'No hay invitaciones pendientes por ahora, ¿por qué no invitas a más personas? 🙂',
                    requests: 'No hay solicitudes pendientes por ahora, ¿por qué no invitas a más personas? 🙂',
                    inviteCta: 'Invitar a un nuevo miembro',
                },
                invitations: {
                    fetchFailed: 'No se pudieron cargar las invitaciones',
                    deleted: 'Invitación eliminada',
                    deleteFailed: 'No se pudo eliminar la invitación',
                    resent: 'Invitación reenviada',
                    resendFailed: 'No se pudo reenviar la invitación',
                },
                badges: {
                    awarded: 'Insignia otorgada correctamente',
                    awardButton: 'Otorgar insignia',
                    confirmation: '¿Seguro que deseas otorgar a este usuario la insignia {{type}}?',
                    typeLabel: 'Insignia {{type}}',
                },
            },
            integrations: {
                title: 'Herramientas',
                connect: 'Conectar',
                platforms: {
                    whatsapp: {
                        name: 'WhatsApp',
                        description: 'Aplicación de mensajería popular para mensajes y grupos.',
                        toast: 'Conectar WhatsApp',
                    },
                    calendar: {
                        name: 'Calendario',
                        description: 'Conecta tu calendario para sincronizar eventos y recordatorios.',
                        toast: 'Conectar calendario',
                    },
                    telegram: {
                        name: 'Telegram',
                        description: 'Aplicación de mensajería para canales y grupos.',
                        toast: 'Conectar Telegram',
                    },
                },
            },
            feeds: {
                loadFailed: 'Error al cargar la actividad del coro:',
                emptyTitle: 'Aún no hay actividad',
                emptyDescription: 'Tu grupo está tranquilo por ahora, ¡anímalos a participar!',
                startPractising: 'Empezar a practicar',
                loadMore: 'Cargar más publicaciones',
                newUpdates: '{{count}} actualización(es) nueva(s)',
                log: {
                    normalizedFeeds: 'Actividad normalizada:',
                },
                comment: {
                    placeholder: 'Escribe un comentario',
                    post: 'Publicar',
                    logPost: 'Publicando comentario',
                },
                composer: {
                    placeholder: 'Comparte una actualización con tu coro',
                    internal: 'Solo miembros',
                    public: 'Solo público',
                    both: 'Miembros y público',
                    post: 'Publicar actualización',
                },
                mentions: {
                    loading: 'Cargando personas...',
                    empty: 'No hay nadie disponible para mencionar',
                },
                references: {
                    loading: 'Cargando referencias...',
                    empty: 'No se encontraron setlists ni ensayos',
                },
                engagement: {
                    like: 'Me gusta',
                    likeWithCount: 'Me gusta ({{count}})',
                    comment: 'Comentar',
                    noComments: 'Aún no hay comentarios.',
                    loadingComments: 'Cargando comentarios...',
                    loadingReplies: 'Cargando respuestas...',
                    viewReplies: 'Ver respuestas ({{count}})',
                    viewMoreComments: 'Ver más comentarios',
                    viewMoreReplies: 'Ver más respuestas',
                    hideReplies: 'Ocultar respuestas',
                    reply: 'Responder',
                    replyPlaceholder: 'Escribe una respuesta',
                    posting: 'Publicando...',
                    signInToEngage: 'Inicia sesión para dar me gusta o comentar.',
                    loadCommentsFailed: 'No se pudieron cargar los comentarios.',
                    postFailed: 'No se pudo publicar el comentario.',
                    updateLikeFailed: 'No se pudo actualizar el me gusta.',
                    deleteFeed: 'Eliminar elemento del feed',
                    editFeed: 'Editar elemento del feed',
                    feedActions: 'Acciones del feed',
                    report: 'Reportar',
                    editFeedPrompt: 'Edita este elemento del feed',
                    editCommentPrompt: 'Edita este comentario',
                    reportFeedConfirm: '¿Reportar este elemento a los moderadores del coro?',
                    reportCommentConfirm: '¿Reportar este comentario a los moderadores del coro?',
                    reportReasonPrompt: 'Selecciona el motivo que mejor describa el problema.',
                    reportReason: {
                        spam: 'Spam',
                        abuse: 'Contenido abusivo',
                        harassment: 'Acoso',
                        other: 'Otro',
                    },
                    submitReport: 'Enviar reporte',
                    submittingReport: 'Enviando...',
                    reported: 'Reporte enviado.',
                    alreadyReported: 'Reportado',
                    reportFailed: 'No se pudo enviar el reporte.',
                    updated: 'Actualizado.',
                    updateFailed: 'No se pudieron guardar los cambios.',
                    deleteFeedConfirm: '¿Eliminar este elemento del feed?',
                    deleteCommentConfirm: '¿Eliminar este comentario?',
                    deleted: 'Eliminado',
                    deleteFailed: 'No se pudo eliminar.',
                },
                moderation: {
                    openQueue: 'Revisar reportes',
                    title: 'Reportes del feed',
                    description: 'Revisa publicaciones y comentarios reportados de este coro.',
                    pending: 'Pendientes',
                    resolved: 'Resueltos',
                    dismissed: 'Descartados',
                    empty: 'No hay reportes en esta cola.',
                    feed: 'Publicación',
                    comment: 'Comentario',
                    author: 'Autor: {{email}}',
                    reporter: 'Reportado por: {{email}}',
                    view: 'Ver en el feed',
                    remove: 'Eliminar contenido',
                    resolve: 'Resolver',
                    dismiss: 'Descartar',
                    removeConfirm: '¿Eliminar este contenido y resolver todos sus reportes?',
                    removed: 'Contenido eliminado y reportes resueltos.',
                    updated: 'Reporte actualizado.',
                    loadFailed: 'No se pudieron cargar los reportes.',
                    updateFailed: 'No se pudo actualizar el reporte.',
                    removeFailed: 'No se pudo eliminar el contenido reportado.',
                    previous: 'Anterior',
                    next: 'Siguiente',
                },
                card: {
                    welcome: '👋 ¡Bienvenido al coro Refinery!',
                    practiceSubmitted: '🎤 {{name}} acaba de enviar una práctica de “{{song}}”',
                    practiceApproved: '✅ La práctica de {{name}} fue aprobada para “{{song}}”',
                    practiceNeedsImprovement: '❗ La práctica de {{name}} para “{{song}}” necesita mejoras',
                    rehearsalActivity: '📝 {{name}} creó un ensayo para “{{song}}”',
                    defaultUpdate: '{{name}} publicó una actualización',
                    unknownTypeLog: 'Tipo de actividad desconocido: {{type}}',
                    pinned: 'Fijado',
                },
            },
            schedule: {
                title: 'Horario del coro',
                document: 'documento',
                manageServiceTypes: 'Gestionar tipos de servicio',
                manageServiceTypesAria: 'Crear y gestionar tipos de servicio',
                setServiceDays: 'Configurar días de servicio',
                createSchedule: 'Crear horario',
                reshuffleAssignments: 'Reorganizar asignaciones del horario',
                reshuffleUnavailable: 'La reorganización no está disponible hasta que exista un horario',
                shareSchedule: 'Compartir horario',
                shareUnavailable: 'Compartir no está disponible hasta que exista un horario',
                deleteSchedule: 'Eliminar horario',
                deleteUnavailable: 'Eliminar no está disponible hasta que exista un horario',
                noServiceDays: 'Aún no se definieron días de servicio.',
                noScheduleYet: 'Aún no se creó un horario',
                getStarted: 'Comienza agregando el primer horario para este coro.',
                addSinger: 'Agregar cantante',
                replaceSinger: 'Reemplazar cantante',
                chooseReplacementFor: 'Elige un reemplazo para',
                chooseSingerFor: 'Elige un cantante para',
                leadSection: 'la sección líder',
                deleteService: 'Eliminar servicio',
                deleteServiceDescription: '¿Eliminar {{service}} del horario actual? Solo se elimina esta instancia programada y se conserva el tipo de servicio.',
                thisService: 'este servicio',
                deleting: 'Eliminando...',
                removeSingerPrompt: '¿Quitar a {{singer}} de {{part}}?',
                reshufflePrompt: '¿Reorganizar todas las asignaciones actuales usando los servicios existentes y {{count}} cantante(s) por parte?',
                deleteSchedulePrompt: '¿Eliminar el horario actual del coro? Esto eliminará semanas, servicios, líderes y asignaciones BGV generadas para este horario.',
                toast: {
                    downloadPdfFailed: 'No se pudo descargar el PDF del horario. Inténtalo de nuevo.',
                    publicLinkReady: 'Enlace público del horario listo',
                    publicLinkFailed: 'No se pudo generar el enlace público del horario',
                    scheduleDeleted: 'Horario eliminado',
                    deleteScheduleFailed: 'No se pudo eliminar el horario',
                    reshuffled: 'Horario reorganizado',
                    reshuffleFailed: 'No se pudo reorganizar el horario',
                    serviceTypeUpdated: 'Tipo de servicio actualizado',
                    serviceTypeUpdateFailed: 'No se pudo actualizar el tipo de servicio',
                    serviceDeleted: 'Servicio eliminado',
                    serviceDeleteFailed: 'No se pudo eliminar el servicio',
                    serviceAdded: 'Servicio agregado',
                    serviceAddFailed: 'No se pudo agregar el servicio',
                    scheduleUpdated: 'Horario actualizado',
                    assignmentUpdateFailed: 'No se pudo actualizar la asignación',
                    singerRemoved: 'Cantante eliminado',
                    singerRemoveFailed: 'No se pudo eliminar al cantante',
                },
                components: {
                    lead: 'Líder',
                    noLeadAssigned: 'No hay líder asignado.',
                    assignLead: 'Asignar líder',
                    assignLeadComingSoon: 'Asignar líder (próximamente)',
                    noSingerAssigned: 'No hay cantante asignado.',
                    addVoiceSectionSinger: 'Agregar {{section}}',
                    addVoiceSectionSingerComingSoon: 'Agregar {{section}} (próximamente)',
                    replaceSinger: 'Reemplazar cantante',
                    replaceSingerComingSoon: 'Reemplazar cantante (próximamente)',
                    removeSinger: 'Quitar cantante',
                    removeSingerComingSoon: 'Quitar cantante (próximamente)',
                    unassignedSinger: 'Cantante sin asignar',
                    assigned: 'Asignados',
                    open: 'Pendientes',
                    total: 'Total',
                    sopranoShort: 'S',
                    altoShort: 'A',
                    tenorShort: 'T',
                    bassShort: 'B',
                    changeServiceTypeTooltip: 'Cambiar tipo de servicio de este bloque',
                    deleteScheduledServiceTooltip: 'Eliminar este servicio programado',
                    addServiceToWeek: 'Agregar servicio a esta semana',
                },
                modals: {
                    serviceType: 'Tipo de servicio',
                    onlyChoirServiceTypes: 'Aquí solo están disponibles los tipos de servicio creados para este coro.',
                    noChoirServiceTypes: 'No hay tipos de servicio específicos del coro.',
                    customName: 'Nombre personalizado',
                    customNamePlaceholder: 'p. ej. Servicio especial improvisado',
                    customNameHint: 'Elige un tipo de servicio existente o ingresa un nombre único.',
                    serviceDateTime: 'Fecha y hora del servicio',
                    selectExistingServiceType: 'Seleccionar tipo de servicio existente',
                    saveChanges: 'Guardar cambios',
                    saving: 'Guardando...',
                    adding: 'Agregando...',
                    addService: {
                        title: 'Agregar servicio',
                        description: 'Agregar un servicio a esta semana.',
                        descriptionWithWeek: 'Agregar un servicio a {{week}} ({{start}} – {{end}}).',
                        action: 'Agregar servicio',
                    },
                    updateServiceType: {
                        title: 'Cambiar tipo de servicio',
                        description: 'Actualizar el tipo de servicio para este servicio programado.',
                    },
                    recurrence: {
                        weekly: 'Semanal los {{day}}',
                        biweekly: 'Quincenal los {{day}}',
                        monthlyNthWeekday: 'Mensual el {{ordinal}} {{day}}',
                        monthlyDayOfMonth: 'Mensual el día {{day}}',
                        annual: 'Anual el {{month}} {{day}}',
                        oneTime: 'Una sola vez el {{date}}',
                        none: 'Sin recurrencia configurada',
                    },
                    noEligibleSingers: 'No hay cantantes disponibles para esta sección.',
                    saveSinger: 'Guardar cantante',
                },
            },
        },
    },
    community: {
        breadcrumbBase: 'Comunidad',
        challenges: 'Retos',
        challengesDescription: 'Crea, descubre y únete a campañas de retos.',
        vocalPerformances: 'Presentaciones vocales',
        vocalPerformancesDescription: 'Colección de presentaciones vocales de varios artistas.',
        reels: 'Reels',
        reelsDescription: 'Colección de videos cortos de presentaciones vocales.',
        welcomeTitle: 'Bienvenido a la Comunidad',
        welcomeSubtitle: 'Encuentra tu preferencia en diferentes colores',
        searchChallenges: 'Buscar retos',
        noChallengesFound: 'No se encontraron retos.',
        challengeTitleLabel: 'Título del reto',
        entriesLabel: 'N.º de participaciones',
        rewardLabel: 'Premio del reto',
        challengeLinkCopied: 'Enlace del reto copiado al portapapeles',
        unableToShareChallenge: 'No se pudo compartir el reto en este momento',
        challengeLeaderboard: {
            breadcrumb: 'Clasificación del reto',
            breadcrumbNamed: '{{title}} > Clasificación',
            title: 'Clasificación',
            subtitle: 'Las mejores entradas se ordenan por puntaje ponderado de moderadores, con likes como desempate.',
            empty: 'Aún no hay datos de clasificación.',
            entryAlt: 'entrada',
            anonymous: 'Anónimo',
            noCaption: 'Sin descripción',
            scoreLabel: 'Puntaje:',
            votesLikes: '{{votes}} votos · {{likes}} me gusta',
        },
        challengeEditor: {
            createTitle: 'Crear reto',
            editTitle: 'Editar reto',
            createSubtitle: 'Configura un nuevo reto para la comunidad.',
            editSubtitle: 'Actualiza metadatos y calendario del reto.',
            ownerOnly: 'Solo el creador del reto puede editarlo.',
            form: {
                titleLabel: 'Título',
                titlePlaceholder: 'Título del reto',
                rewardTypeLabel: 'Tipo de premio',
                rewardTypeCash: 'Dinero',
                rewardTypePrize: 'Premio',
                startDateLabel: 'Fecha de inicio',
                endDateLabel: 'Fecha de fin',
                rewardAmountLabel: 'Monto del premio',
                rewardAmountCashPlaceholder: '100',
                rewardAmountPrizePlaceholder: '0',
                rewardCurrencyLabel: 'Moneda del premio',
                entryTypeLabel: 'Tipo de entrada',
                entryTypeOpen: 'Abierto',
                entryTypeInviteOnly: 'Solo por invitación',
                participationTypeLabel: 'Tipo de participación',
                participationTypeIndividual: 'Individual',
                participationTypeChoir: 'Coro',
                maxParticipantsLabel: 'Máximo de participantes',
                maxParticipantsPlaceholder: 'Sin límite',
                minXpLabel: 'XP mínimo',
                maxXpLabel: 'XP máximo',
                xpPlaceholder: 'Opcional',
                descriptionLabel: 'Descripción',
                descriptionPlaceholder: 'Describe el reto',
                rewardDescriptionLabel: 'Descripción del premio',
                rewardDescriptionPlaceholder: 'Detalles opcionales del premio',
                rulesLabel: 'Reglas y lineamientos',
                rulesPlaceholder: 'Reglas del reto',
            },
            uploads: {
                promoVideoLabel: 'Subir video promocional',
                promoVideoHint: 'Obligatorio. La miniatura puede generarse automáticamente desde este video.',
                thumbnailLabel: 'Subir miniatura del reto',
                thumbnailHint: 'Opcional. Si se omite, usaremos la miniatura del video promocional.',
                thumbnailPreview: 'Vista previa de miniatura',
                thumbnailAlt: 'Miniatura del reto',
            },
            actions: {
                saving: 'Guardando...',
                updateChallenge: 'Actualizar reto',
                createChallenge: 'Crear reto',
            },
            toasts: {
                updated: 'Reto actualizado correctamente.',
                created: 'Reto creado correctamente.',
                saveFailed: 'No se pudo guardar el reto.',
            },
        },
        challengeComments: {
            title: 'Comentarios de la comunidad',
            empty: 'Aún no hay comentarios de la comunidad.',
            you: 'Tú',
            avatarAlt: 'avatar',
            reply: 'Responder',
            loading: 'Cargando...',
            hideReplies: 'Ocultar respuestas',
            viewReplies: 'Ver respuestas{{suffix}}',
            replyPlaceholder: 'Escribe una respuesta...',
            commentPlaceholder: 'Agregar un comentario...',
            send: 'Enviar',
        },
        challengeReviewsModal: {
            title: 'Reseñas y comentarios',
            communityMember: 'Miembro de la comunidad',
            avatarAlt: 'avatar',
            moderatorReviewBadge: 'Reseña de moderador',
            noPreviewVideo: 'Sin video de vista previa',
            moderatorReviews: 'Reseñas de moderadores',
            hide: 'Ocultar',
            show: 'Mostrar',
            emptyModeratorReviews: 'Aún no hay reseñas de moderadores',
            voteAndReview: 'Votación y reseña de moderador (feedback del jurado)',
            scoreLabel: 'Puntaje {{score}}%',
            reviewInputPlaceholder: 'Escribe una reseña de moderador...',
            vote: 'Votar',
            voted: 'Votado',
            voting: 'Votando...',
        },
        reelsComments: {
            title: 'Comentarios',
            empty: 'Aún no hay comentarios',
            avatarAlt: 'avatar',
            loading: 'Cargando...',
            hideReplies: 'Ocultar respuestas',
            viewReplies: 'Ver respuestas ({{count}})',
            reply: 'Responder',
            replyingTo: 'Respondiendo a @{{username}}...',
            commentPlaceholder: 'Agregar un comentario...',
            send: 'Enviar',
            follow: 'Seguir',
            following: 'Siguiendo',
            profileFutureFeatures: 'Seguir, Ver perfil (funciones futuras)',
            fetchMoreFailed: 'No se pudieron cargar más comentarios:',
            fetchFailed: 'No se pudieron cargar los comentarios:',
            likeUpdateFailed: 'No se pudo actualizar el estado del like:',
            fetchRepliesFailed: 'No se pudieron cargar las respuestas:',
            replyPostFailed: 'No se pudo publicar la respuesta:',
            commentPostFailed: 'No se pudo publicar el comentario:',
        },
        challengeDetails: {
            title: 'Detalles del reto',
            notFound: 'Reto no encontrado.',
            reward: 'Premio',
            entries: 'Entradas',
            duration: 'Duración',
            challengeTitle: 'Reto - {{title}}',
            startsIn: 'Este reto comenzará en:',
            upcomingDescription: 'Este reto comenzará en {{days}} día(s). Mientras tanto, invita a tus amigos a participar.',
            upcomingAlt: 'Reto próximo',
            mascotAlt: 'Mascota del reto',
            noCaption: 'Sin descripción',
            noDescription: 'No se proporcionó descripción.',
            noEntriesYet: 'Aún no hay entradas.',
            noRulesSpecified: 'El creador del reto no especificó reglas.',
            noReferenceVideo: 'No se proporcionó video de referencia.',
            noReviewComment: 'Sin comentario de reseña',
            noReviewsAvailable: 'No hay reseñas disponibles.',
            noModeratorsAssigned: 'Aún no hay moderadores asignados.',
            noDisqualifiedEntries: 'No hay entradas descalificadas.',
            noModerationLogs: 'Aún no hay actividad de moderación.',
            noReasonProvided: 'No se proporcionó motivo',
            noDetails: 'Sin detalles',
            unknown: 'Desconocido',
            notResolved: 'No resuelto',
            prize: 'Premio',
            challengeMeta: 'Metadatos del reto',
            creator: 'Creador: {{creator}}',
            entriesCount: 'Entradas: {{count}}',
            moderatorsCount: 'Moderadores: {{count}}',
            moderatorWeight: 'Peso del moderador: {{weight}}%',
            moderatorWeightRow: '{{email}} · Peso {{weight}}%',
            resolvedEmail: 'Correo resuelto: {{email}}',
            challengeWindow: 'Ventana del reto: {{start}} - {{end}}',
            informationTitle: 'Información del reto',
            referenceVideo: 'Video de referencia',
            openReferenceMedia: 'Abrir media de referencia',
            engagementRules: 'Reglas de participación',
            shareYourChallenge: 'Comparte tu reto',
            shareToGetEntries: 'Comparte el reto para comenzar a recibir entradas.',
            submitEntryTitle: 'Enviar entrada',
            submitEntrySubtitle: 'Sube tu interpretación del reto y envíala a la clasificación.',
            uploadEntryVideo: 'Subir video de entrada al reto',
            captionOptional: 'Descripción (opcional)',
            captionPlaceholder: 'Cuéntale a la gente sobre tu entrada',
            moderators: 'Moderadores',
            moderator: 'Moderador',
            moderatorReviews: 'Reseñas de moderadores',
            moderatorReviewComment: 'Comentario de reseña del moderador',
            entryReviews: 'Reseñas de la entrada',
            voteScore: 'Puntaje de voto: {{score}}%',
            optionalReviewComment: 'Comentario de reseña opcional',
            makeReviewPublic: 'Hacer pública la reseña',
            disqualifiedEntries: 'Entradas descalificadas',
            moderationActivity: 'Actividad de moderación',
            activity: 'actividad',
            upcomingChallenge: 'Reto próximo',
            expressInterestHint: 'Expresa interés para mantenerte al tanto y mostrar intención de participar.',
            interestAlreadyExpressed: 'Interés ya expresado.',
            interestedUsers: 'Usuarios interesados: {{count}}',
            likes: 'Me gusta',
            likesCount: '{{count}} me gusta',
            showLess: 'Mostrar menos',
            showMore: '... más',
            entryDisqualified: 'Esta entrada está descalificada.',
            viewReviewsAndComments: 'Ver reseñas y comentarios',
            assignModeratorsSubtitle: 'Asigna y gestiona co-jueces para este reto.',
            inviteParticipants: 'Invitar participantes',
            inviteParticipantsSubtitle: 'Invita personas por correo o coros por ID.',
            inviteUserEmail: 'Correo del participante',
            inviteChoirId: 'ID del coro',
            enterUsernameOrEmail: 'Ingresa usuario o correo',
            alreadyVotedOnEntry: 'Ya votaste esta entrada.',
            anonymous: 'Anónimo',
            communityMember: 'Miembro de la comunidad',
            public: 'pública',
            private: 'privada',
            scorePrefix: 'Puntaje {{score}}',
            shareJoinText: 'Únete a este reto: {{title}}',
            you: 'Tú',
            actions: {
                submitting: 'Enviando...',
                expressInterest: 'Expresar interés',
                interestExpressed: 'Interés expresado',
                enterChallenge: 'Entrar al reto',
                shareChallenge: 'Compartir reto',
                vote: 'Votar',
                voted: 'Votado',
                editChallenge: 'Editar reto',
                manageModerators: 'Gestionar moderadores',
                leaderboard: 'Clasificación',
                share: 'Compartir',
                resolve: 'Resolver',
                assigning: 'Asignando...',
                assignModerator: 'Asignar moderador',
                inviting: 'Invitando...',
                inviteUser: 'Invitar usuario',
                inviteChoir: 'Invitar coro',
                remove: 'Eliminar',
                submitEntry: 'Enviar entrada',
                submitVote: 'Enviar voto',
                disqualify: 'Descalificar',
                loadReviews: 'Cargar reseñas',
                submitReview: 'Enviar reseña',
            },
            countdown: {
                days: 'Días',
                hours: 'Hrs',
                minutes: 'Min',
                seconds: 'Seg',
            },
            aria: {
                openLeaderboard: 'Abrir clasificación',
                openChallengeInformation: 'Abrir información del reto',
                shareChallenge: 'Compartir reto',
                copyChallengeLink: 'Copiar enlace del reto',
                voteOnEntry: 'Votar entrada',
                alreadyVotedOnEntry: 'Ya votaste esta entrada',
                likes: 'Me gusta',
                viewReviewsAndComments: 'Ver reseñas y comentarios',
                previousEntry: 'Entrada anterior',
                nextEntry: 'Siguiente entrada',
                submitChallengeEntry: 'Enviar entrada al reto',
            },
            prompts: {
                disqualifyReason: 'Proporciona el motivo de descalificación (mínimo 5 caracteres):',
            },
            toasts: {
                entrySubmitted: 'Entrada al reto enviada correctamente.',
                entrySubmitFailed: 'No se pudo enviar la entrada del reto.',
                interestExpressed: 'Interés expresado correctamente.',
                interestFailed: 'No se pudo expresar interés.',
                userNotFound: 'No se encontró un usuario para el nombre proporcionado.',
                userLookupFailed: 'No se pudo encontrar usuario por nombre.',
                resolveModeratorFirst: 'Primero resuelve un correo válido de moderador.',
                moderatorAssigned: 'Moderador asignado correctamente.',
                assignModeratorFailed: 'No se pudo asignar al moderador.',
                moderatorRemoved: 'Moderador eliminado correctamente.',
                removeModeratorFailed: 'No se pudo eliminar al moderador.',
                inviteCreated: 'Invitación del reto creada correctamente.',
                inviteFailed: 'No se pudo crear la invitación del reto.',
                enterInviteTarget: 'Ingresa un destinatario válido primero.',
                voteSubmitted: 'Voto enviado correctamente.',
                voteFailed: 'No se pudo enviar el voto.',
                disqualified: 'Entrada descalificada correctamente.',
                disqualifyFailed: 'No se pudo descalificar la entrada.',
                reviewTooShort: 'El comentario de reseña debe tener al menos 3 caracteres.',
                reviewSubmitted: 'Reseña de entrada enviada.',
                reviewFailed: 'No se pudo enviar la reseña.',
                linkCopied: 'Enlace del reto copiado al portapapeles.',
                shareFailed: 'No se pudo compartir el reto en este momento.',
                copyFailed: 'No se pudo copiar el enlace del reto.',
                likeUpdateFailed: 'No se pudo actualizar el like en este momento.',
            },
            entryAlt: 'entrada',
            entryAvatarAlt: 'avatar de entrada',
            entryByActor: 'Entrada #{{entryId}}{{actorPart}}',
            byActor: 'por {{actor}}',
            moderatorSharePrompt: 'Comparte este reto para conseguir más entradas.',
        },
        contribution: {
            breadcrumb: 'Contribuciones > {{title}}',
            unknownTitle: 'Título desconocido',
            filters: {
                all: 'Todos',
                searchByUsername: 'Buscar por nombre de usuario del colaborador',
                updating: 'Actualizando',
            },
            empty: {
                needHelp: 'Aún no hay contribuciones para esta parte. ¿Necesitas ayuda para resolverla?',
                requestHelp: 'Solicitar ayuda para esta parte',
                beFirst: 'Aún no hay contribuciones para esta parte. ¡Sé el primero en contribuir!',
                submitContribution: 'Enviar tu contribución',
            },
            pagination: {
                prev: 'Anterior',
                next: 'Siguiente',
                pageOf: 'Página {{page}} de {{total}}',
            },
            error: {
                generic: 'Algo salió mal',
            },
        },
        requests: {
            title: 'Solicitudes',
            searchBySongTitle: 'Buscar por título de canción',
            loadMore: 'Cargar más',
            filters: {
                all: 'Todos',
            },
            empty: {
                alt: 'Sin solicitudes',
                description: 'No se encontraron solicitudes para tus filtros.',
                prompt: '¿Quieres pedir una parte a la comunidad?',
                cta: 'Solicitar una contribución',
            },
            error: {
                alt: 'Error',
                loadFailed: 'No se pudieron cargar las solicitudes',
            },
        },
        requestDetail: {
            comingSoon: 'Los detalles de la solicitud estarán disponibles pronto.',
            error: {
                generic: 'Algo salió mal',
            },
        },
        reelDetails: {
            title: 'Detalles del reel',
            invalidId: 'ID de reel no válido. Usa un enlace de reel con formato UUID.',
        },
        reelsFeed: {
            swipeUp: 'Desliza hacia arriba',
            clipboardUnsupported: 'La API del portapapeles no está disponible',
            linkShared: '¡Enlace compartido correctamente!',
            linkShareFailed: 'No se pudo compartir el enlace',
            linkCopied: '¡Enlace copiado al portapapeles!',
            linkCopyFailed: 'No se pudo copiar el enlace',
        },
    },
    marketplace: {
        loadSongsFailed: 'No se pudieron cargar las canciones del marketplace',
        noListings: 'No hay publicaciones disponibles en este momento.',
        goBack: 'Volver',
        title: 'Título',
        artist: 'Artista',
        access: 'Acceso',
        price: 'Precio',
        duration: 'Duración',
        action: 'Acción',
        accessPremium: 'Premium',
        accessMasterOnly: 'Solo master',
        accessStems: 'Stems',
        premiumPreview: 'Premium / Vista previa',
        buyRent: 'Comprar/Alquilar',
        orders: {
            loadFailed: 'No se pudieron cargar los pedidos del marketplace',
            empty: 'Aún no tienes pedidos en el marketplace.',
            browseMarketplace: 'Explorar marketplace',
            title: 'Mis pedidos',
            subtitle: 'Revisa la actividad de checkout, el estado de pago y enlaces directos a las canciones desbloqueadas.',
            columns: {
                order: 'Pedido',
                status: 'Estado',
                amount: 'Monto',
                date: 'Fecha',
            },
            unavailable: 'No disponible',
            viewOrder: 'Ver pedido',
        },
        purchases: {
            loadFailed: 'No se pudieron cargar las compras del marketplace',
            empty: 'Aún no tienes compras activas en el marketplace.',
            browseMarketplace: 'Explorar marketplace',
            title: 'Mis compras',
            subtitle: 'Canciones que ya desbloqueaste por compra directa, alquiler o checkout completado.',
            paid: 'Pagado',
            owned: 'Comprado',
            rental: 'Alquiler',
            masterOnly: 'Solo master',
            stemsIncluded: 'Stems incluidos',
            unavailable: 'No disponible',
            openSong: 'Abrir canción',
        },
        orderDetail: {
            loadFailed: 'No se pudo cargar el pedido del marketplace',
            notFound: 'Pedido de marketplace no encontrado',
            marketplaceOrder: 'Pedido de marketplace',
            backToOrders: 'Volver a pedidos',
            openSong: 'Abrir canción',
            status: 'Estado',
            entitlement: 'Acceso:',
            expires: 'Expira:',
            payment: 'Pago',
            provider: 'Proveedor:',
            reference: 'Referencia:',
            accessScope: 'Alcance de acceso',
            orderSuffix: 'pedido',
            detailsTitle: 'Detalles del pedido',
            detailsSubtitle: 'Información de referencia para esta transacción del marketplace.',
            orderType: 'Tipo de pedido',
            created: 'Creado',
            updated: 'Actualizado',
            song: 'Canción',
        },
        orderModal: {
            referenceCopied: 'Referencia copiada al portapapeles',
            copyPaymentReferenceAria: 'Copiar referencia de pago',
            copyReference: 'Copiar referencia',
        },
        listings: {
            loadFailed: 'No se pudieron cargar las publicaciones del marketplace',
            updated: 'Publicación del marketplace actualizada.',
            updateFailed: 'No se pudo actualizar la publicación del marketplace',
            loadOrdersFailed: 'No se pudieron cargar los pedidos de la publicación',
            listingForfeited: 'Publicación renunciada.',
            appealSubmitted: 'Apelación enviada.',
            reportResponseFailed: 'No se pudo enviar la respuesta del reporte',
            empty: 'Aún no has creado canciones de comunidad aptas para marketplace.',
            title: 'Mis publicaciones',
            subtitle: 'Gestiona visibilidad, precios y flujo de pedidos del marketplace para tus canciones.',
            table: {
                listing: 'Publicación',
                revenue: 'Ingresos',
            },
            stats: {
                activeListings: 'Publicaciones activas',
                stillDraft: '{{count}} aún en borrador',
                premiumEnabled: 'Premium habilitado',
                premiumHint: 'Publicaciones que permiten desbloqueo por suscripción',
                revenue: 'Ingresos',
                zeroUsd: 'USD 0.00',
                revenueHint: 'Ingresos directos del marketplace registrados',
                loadedOrders: 'Pedidos cargados',
                loadedOrdersHint: 'Pedidos del vendedor vistos en esta sesión',
            },
            buySummary: 'Compra {{price}}',
            rentSummary: 'Alquiler {{price}}{{duration}}',
            notConfigured: 'No configurado',
            listed: 'Publicado',
            processingHint: 'El procesamiento en segundo plano sigue en curso. La publicación se habilitará cuando termine.',
            noneYet: 'Aún nada',
            editListing: 'Editar publicación',
            viewOrders: 'Ver pedidos',
            health: {
                processing: 'Procesando',
                ready: 'Listo',
                reported: 'Reportado',
                draft: 'Borrador',
                needsAccessPath: 'Necesita ruta de acceso',
                premiumOnly: 'Solo premium',
                missingRentalDays: 'Faltan días de alquiler',
                missingBuyPrice: 'Falta precio de compra',
                missingRentPrice: 'Falta precio de alquiler',
            },
            editor: {
                title: 'Editar publicación',
                byline: '{{title}} por {{artist}}',
                processingHint: 'Esta canción aún se está procesando en segundo plano. La publicación permanecerá deshabilitada hasta que el empaquetado termine.',
                songReport: 'Reporte de canción',
                reportedForReview: 'Reportada para revisión',
                lastReported: 'Último reporte {{date}}',
                open: 'abierto',
                adminRequestedExplanation: 'El administrador solicitó una explicación para esta publicación. Puedes enviar una apelación o renunciar a la publicación.',
                explanationPlaceholder: 'Explica por qué esta publicación debe seguir disponible',
                submitting: 'Enviando...',
                submitAppeal: 'Enviar apelación',
                forfeitListing: 'Renunciar a la publicación',
                creatorResponseStatus: 'Estado de respuesta del creador: {{status}}',
                listSong: 'Listar canción',
                premiumAccess: 'Acceso premium',
                enableSale: 'Habilitar venta',
                salePricePlaceholder: 'Precio de venta en unidades menores',
                enableRent: 'Habilitar alquiler',
                rentPricePlaceholder: 'Precio de alquiler en unidades menores',
                rentalDurationPlaceholder: 'Duración del alquiler en días',
                accessScope: 'Alcance de acceso',
                currency: 'Moneda',
                saving: 'Guardando...',
                saveListing: 'Guardar publicación',
            },
            sellerOrders: {
                title: 'Pedidos del vendedor',
                fallbackSubtitle: 'Pedidos de la publicación del marketplace',
                orders: 'Pedidos',
                paidRevenue: 'Ingresos cobrados',
                listedScope: 'Alcance publicado',
                noneYet: 'Aún nada',
                empty: 'Aún no hay pedidos del marketplace para esta publicación.',
            },
        },
        earnings: {
            loadFailed: 'No se pudieron cargar las ganancias del marketplace',
            unavailable: 'Las ganancias del marketplace no están disponibles en este momento.',
            title: 'Ganancias',
            subtitle: 'Ingresos brutos del marketplace y regalías para tus publicaciones de canciones de comunidad.',
            reportingWindow: 'Ventana de reporte',
            chart: {
                listings: 'Publicaciones',
                active: 'Activas',
                premium: 'Premium',
                paidSongs: 'Canciones pagadas',
                orders: 'Pedidos',
                royalties: 'Regalías',
                series: {
                    listingHealth: 'Salud de publicaciones',
                    marketplaceActivity: 'Actividad del marketplace',
                    royaltyEvents: 'Eventos de regalías',
                },
            },
            filters: {
                allTime: 'Todo el tiempo',
                start: 'Inicio',
                now: 'Ahora',
                from: 'Desde',
                to: 'Hasta',
                apply: 'Aplicar',
                reset: 'Restablecer',
            },
            cards: {
                totalEarnings: {
                    title: 'Ganancias totales',
                    multiMarketValue: '{{count}} mercados',
                    singleCurrencyNote: 'Ingresos brutos del marketplace',
                    multiCurrencyNote: 'Ingresos directos entre monedas',
                },
                creatorRoyalty: {
                    title: 'Regalías del creador',
                    multiLedgerValue: '{{count}} libros',
                    singleCurrencyNote: 'Tu parte de regalías',
                    multiCurrencyNote: 'Parte del creador entre monedas',
                },
                totalTracks: {
                    title: 'Pistas totales',
                    note: '{{count}} publicaciones activas',
                },
                totalEngagement: {
                    title: 'Interacción total',
                    note: '{{orders}} pedidos • {{events}} eventos de regalías',
                },
                projectContribution: {
                    title: 'Contribución de proyecto',
                    pendingValue: '{{count}} pendientes',
                    noPendingValue: 'Sin pagos pendientes',
                    pendingNote: 'Pagos pendientes de contribuciones de proyecto',
                    noPendingNote: 'No hay pagos de contribución de proyecto esperando retiro/procesamiento admin',
                },
            },
            analytics: {
                title: 'Analítica general',
                subtitle: 'Actividad del marketplace, salud de publicaciones y cobertura de regalías en la ventana seleccionada.',
            },
            topSongs: {
                title: 'Canciones con mayores ganancias',
                subtitle: 'Líderes de ingresos brutos del marketplace en la ventana seleccionada.',
                empty: 'Aún no hay canciones con ganancias.',
                goToListings: 'Ir a mis publicaciones',
            },
            table: {
                revenue: 'Ingresos',
                orders: 'Pedidos',
                openSong: 'Abrir {{song}}',
            },
            royalty: {
                title: 'Desglose de regalías del creador',
                subtitle: 'Ingresos del creador por eventos liquidados de regalías de canciones de comunidad en la ventana seleccionada.',
                emptyTitle: 'Aún no hay eventos de regalías',
                emptyDescription: 'Las entradas de regalías aparecerán aquí cuando los pedidos pagados se liquiden en el libro de regalías.',
                table: {
                    currency: 'Moneda',
                    royalty: 'Regalía',
                    events: 'Eventos',
                    eventsCount: '{{count}} eventos',
                },
            },
            coverage: {
                title: 'Cobertura',
                description: 'Los totales de regalías ya incluyen eventos liquidados de venta y alquiler. Las regalías por reproducciones aparecerán en este mismo libro cuando haya eventos de stream.',
            },
        },
        checkout: {
            successTitle: 'Pago recibido',
            successDescription: 'Estamos verificando tu orden del marketplace y actualizando el acceso.',
            pendingTitle: 'Pago pendiente',
            pendingDescription: 'La devolución de pago llegó a VocalCentric. Estamos esperando el estado final de la orden.',
            failureTitle: 'Checkout no completado',
            failureDescription: 'El flujo de pago no se completó. Puedes reintentar desde la canción o revisar tu historial de órdenes.',
            loadStatusFailed: 'No se pudo cargar el estado del checkout',
            canceledReason: 'Cerraste el flujo de pago antes de completarlo.',
            accessExpires: 'El acceso expira',
            viewOrders: 'Ver pedidos',
            viewPurchases: 'Ver compras',
        },
        songDetail: {
            listingDetail: 'Detalle de publicación',
            notFound: 'Canción de marketplace no encontrada',
            loadFailed: 'No se pudo cargar la canción del marketplace',
            checkoutInitialized: 'Checkout inicializado',
            checkoutFailed: 'No se pudo iniciar el checkout',
            songReported: 'Canción reportada',
            reportFailed: 'No se pudo reportar la canción',
            marketplaceSong: 'Canción del marketplace',
            premiumEligible: 'Apto para premium',
            reported: 'Reportado',
            report: 'Reportar',
            information: 'Información',
            licensing: 'Licencia',
            total: 'Total',
            openInPlayer: 'Abrir en reproductor',
            previewInPlayer: 'Previsualizar en reproductor',
            openPlayer: 'Abrir reproductor',
            upgrade: 'Mejorar plan',
            rentNow: 'Alquilar ahora',
            buyNow: 'Comprar ahora',
            unlisted: 'Esta canción no está listada actualmente en el marketplace.',
            purchase: 'Compra',
            multitracks: 'Pistas múltiples',
            masterRental: 'Alquiler master',
            daysAccess: '{{days}} días de acceso',
            timedAccess: 'Acceso temporal',
            masterTrack: 'Pista master',
            fullMasterPreview: 'Vista previa master completa',
            masterBuy: 'Compra master',
            masterStemsBuy: 'Compra master + stems',
            permanentAccess: 'Acceso permanente',
            permanentFullAccess: 'Acceso completo permanente',
            masterOnly: 'Solo master',
            masterStems: 'Master + stems',
            included: 'Incluido',
            includedWithPremium: 'Incluido con Premium',
            alreadyUnlocked: 'Ya desbloqueado',
            premiumUnlockHint: 'Usuarios premium desbloquean esta publicación automáticamente.',
            usageTerms: 'Términos de uso',
            notes: 'Notas',
            marketplaceAccess: 'Acceso marketplace',
            unlocked: 'Desbloqueado',
            previewOnly: 'Solo vista previa',
            accessExpiresOn: 'El acceso expira el {{date}}.',
            noTags: 'Aún no se agregaron etiquetas.',
            timed: 'Temporal',
            rentalAccess: 'Acceso de alquiler {{days}}',
            permanentLicenseAccess: 'Acceso de licencia permanente',
            masterPlaybackOnly: 'Solo reproducción master',
            masterStemsAccess: 'Acceso master + stems',
            premiumInclusionAvailable: 'Inclusión premium disponible',
            premiumInclusionDisabled: 'Inclusión premium desactivada',
            sharedPlayerPreviewFlow: 'Flujo de vista previa en reproductor compartido',
            artworkAlt: 'Portada de {{song}}',
            metadata: {
                published: 'Publicado',
                songTitle: 'Título de canción',
                artistName: 'Nombre del artista',
                creator: 'Creador',
            },
            stems: {
                readyInSharedPlayer: 'Listo en reproductor compartido',
                lockedUntilAccess: 'Bloqueado hasta que se conceda acceso',
                masterOnlyNotice: 'Esta publicación es solo master. Se puede desbloquear la pista principal, pero los stems permanecen ocultos.',
                noneAvailable: 'Aún no hay pistas múltiples adicionales en esta publicación.',
            },
            reasons: {
                creator: 'Creaste esta canción, por lo que la reproducción en marketplace ya está desbloqueada en tu cuenta.',
                entitlement: 'Ya desbloqueaste esta canción. Ábrela en el reproductor compartido o revisa tu historial.',
                premium: 'Incluida en tu plan premium porque el creador habilitó acceso premium.',
                purchaseRequired: 'Puedes previsualizar el master ahora, luego alquilar o comprar para desbloquear todo.',
                unlisted: 'Esta canción no está listada actualmente para acceso en marketplace.',
                default: 'Los detalles de acceso al marketplace están disponibles abajo.',
            },
        },
    },
    notifications: {
        title: 'Notificaciones',
        subtitle: 'Gestiona tus notificaciones y mantente al tanto de las actualizaciones importantes.',
        markAllAsRead: 'Marcar todo como leído',
        empty: 'Aún no hay notificaciones',
        timeAgo: 'hace {{time}}',
    },
    requestSongs: {
        title: 'Solicitudes de canciones',
        subtitle: 'Vota por canciones que te gustaría ver en la plataforma',
        addSongRequest: 'Agregar solicitud de canción',
        searchPlaceholder: 'Buscar canciones (p. ej. "Way Maker by Sinach")',
        songTitle: 'Título de la canción',
        enterSongTitle: 'Ingresa el título de la canción',
        artistName: 'Nombre del artista',
        enterArtistName: 'Ingresa el nombre del artista',
        albumName: 'Nombre del álbum',
        enterAlbumName: 'Ingresa el nombre del álbum',
        mediaLink: 'Enlace multimedia',
        mediaLinkPlaceholder: 'Preferiblemente Spotify, Apple Music, AudioMac, Youtube',
        thumbnailLink: 'Enlace de miniatura',
        thumbnailLinkPlaceholder: 'Arte o portada de la canción',
        save: 'Guardar',
        cancel: 'Cancelar',
        songRequestCreated: 'Solicitud de canción creada',
        songRequestFailed: 'Falló la solicitud de canción',
        tableTitle: 'Título',
        tableGenres: 'Géneros',
        tableVotes: 'Votos',
        tableActions: 'Acciones',
        songVotedSuccessfully: 'Canción votada correctamente',
        songVotingFailed: 'Falló la votación de la canción',
        notSpecified: 'No especificado',
        voted: 'Votado',
        vote: 'Votar',
        iconAlt: 'icono',
    },
    requestRole: {
        title: 'Solicitud de rol',
        subtitle: 'Selecciona tu rol preferido para quedar preseleccionado.',
        applyWhitelisted: 'Solicitar ser autorizado',
        applyDirector: 'Solicitar ser director',
        fillToApply: 'Completa el formulario para aplicar.',
        noApplicationFound: 'No se encontró ninguna solicitud',
        goBack: 'Volver',
        goToDashboard: 'Ir al panel',
        reApply: 'Volver a solicitar',
        uploadHelp: 'Sube un video mostrando tus habilidades y nivel de competencia (enseñar/tocar/cantar). La duración debe ser de 2 a 5 minutos. Esto se usará para evaluar tu capacidad vocal.',
        socialMediaPlaceholder: 'Ingresa perfil de red social *',
        socialMediaHandle: 'Usuario de red social',
        reasonPlaceholder: '¿Por qué solicitas este rol? *',
        reason: 'Motivo',
        websiteLink: 'Enlace del sitio web',
        websiteLinkOptional: 'Enlace del sitio web (opcional)',
        apply: 'Aplicar',
        cancel: 'Cancelar',
        whitelistSubmitted: 'Solicitud de autorización enviada correctamente',
        directorSubmitted: 'Solicitud de director enviada correctamente',
        status: {
            director: {
                approved: 'Ya fuiste aprobado para ser Director',
                pending: 'Tu solicitud para ser Director sigue pendiente',
                rejected: 'Tu solicitud para ser Director fue rechazada',
            },
            whitelisted: {
                approved: 'Ya fuiste aprobado para estar autorizado',
                pending: 'Tu solicitud para estar autorizado sigue pendiente',
                rejected: 'Tu solicitud para estar autorizado fue rechazada',
            },
            joinChoir: {
                approved: 'Tu solicitud para unirte al coro fue aprobada',
                pending: 'Tu solicitud para unirte al coro sigue pendiente',
                rejected: 'Tu solicitud para unirte al coro fue rechazada',
            },
        },
    },
    rehearsal: {
        all: 'Todo',
        allDescription: 'Todas las canciones de ensayo personal',
        rehearsed: 'Ensayadas',
        rehearsedDescription: 'Canciones ensayadas',
        new: 'Nuevas',
        newDescription: 'Nuevas canciones en ensayos',
        startRehearsal: 'Iniciar ensayo',
        startingRehearsal: 'Iniciando ensayo',
        tableTitle: 'Título',
        tableAlbum: 'Álbum',
        tableGenre: 'Género',
        tableVotes: 'Votos',
        tableDuration: 'Duración',
        tableAction: 'Acción',
        empty: 'No se encontraron ensayos para ti, ¡crea uno ahora!',
        loading: 'Cargando...',
        searchToAdd: 'Busca música, artista y álbum para agregar al ensayo',
        generateShareLink: 'Generar enlace para compartir',
        chat: {
            noMessages: 'No hay mensajes de chat',
            typeMessage: 'Escribe un mensaje',
            avatarAlt: 'avatar',
            participantFallback: 'John Doe',
            participants: '{{count}} participantes',
        },
        scoreSheet: 'Partitura',
        songSlides: {
            selectSlide: 'Seleccionar diapositiva',
        },
        songMeta: {
            artist: 'Artista',
            writer: 'Autor',
            label: 'Sello',
            theme: 'Tema',
            genre: 'Género',
            album: 'Álbum',
            bpm: 'BPM',
            timeSig: 'Compás',
            duration: 'Duración',
            key: 'Tonalidad',
            originalKey: 'Tonalidad original',
            rehearsalKey: 'Tonalidad de ensayo',
            publicDomain: 'Dominio público',
            gospel: 'Góspel',
            na: '__',
            rehearsedBy: 'Ensayado por',
            votes: '{{count}} votos',
            coverArtAlt: 'Portada de {{title}}',
        },
        tabs: {
            lyrics: 'Letra',
            lyricsDescription: 'Letra de esta canción',
            slides: 'Diapositivas',
            slidesDescription: 'Diapositivas de esta canción',
            practice: 'Practicar',
            practiceDescription: 'Practica esta canción',
            customHarmonies: 'Armonías personalizadas',
            customHarmoniesDescription: 'Lista de armonías personalizadas para este ensayo coral',
            reviewPractice: 'Revisar práctica',
            reviewPracticeDescription: 'Revisiones de práctica del ensayo coral',
            practise: 'Practicar',
            practiseDescription: 'Práctica del ensayo coral',
            addAnotherFile: 'Agregar otro archivo',
            noSlides: 'No hay diapositivas disponibles',
            addSlidesToStart: 'Agrega diapositivas a esta canción para comenzar',
        },
    },
    rehearsalPractice: {
        subtitle: 'Selecciona una sección, inspecciona la toma, revisa la nota de coaching y avanza a la siguiente frase sin perder tu lugar.',
        personalRehearsal: 'Ensayo Personal',
        sectionFeedback: 'Comentarios de sección',
        closeFeedback: 'Cerrar comentarios',
        previousSection: 'Sección anterior',
        nextSection: 'Siguiente sección',
        takePreview: 'Vista previa de toma',
        lock: 'Bloqueo',
        submitted: 'enviado',
        countIn: 'conteo',
        playbackOnly: 'Solo reproducción',
        stopClickPreview: 'Detener metrónomo de prueba',
        previewClick: 'Probar metrónomo',
        click: 'Click',
        singAlongGuide: 'Cantar con la pista guía',
        recordWithoutGuide: 'Grabar sin pista guía',
        singAlongEnabled: 'Cantar junto activado',
        singAlongDisabled: 'Cantar junto desactivado',
        pauseTake: 'Pausar toma',
        playTake: 'Reproducir toma',
        viewFeedback: 'Ver comentarios',
        stopRecording: 'Detener grabación',
        cancelCountIn: 'Cancelar conteo',
        recordTake: 'Grabar toma',
        discardTake: 'Descartar toma',
        submitForAiReview: 'Enviar para revisión de IA',
        recommendedNextStep: 'Siguiente paso recomendado',
        retryRecording: 'Reintentar grabación',
        aiNoteTitle: 'Nota de IA',
        aiNoteFallback: 'Graba una toma de esta sección para recibir comentarios específicos de tu coach de VocalCentric.',
        overallScore: 'Puntuación general',
        performanceBreakdown: 'Desglose de rendimiento',
        performanceBreakdownSubtitle: 'Ábrelo para comparar el resumen de métricas y el análisis radar en un solo lugar.',
        nextStepRetryFocus: 'Repite esta toma enfocándote en {{metric}}. {{description}}',
        nextStepDefault: 'Graba o vuelve a grabar esta sección y luego revisa la nota actualizada antes de pasar a la siguiente frase.',
        scoreSummary: {
            strongPass: 'Muy buen resultado',
            gettingCloser: 'Vas acercándote',
            needsAnotherTake: 'Necesita otra toma',
        },
        status: {
            reviewed: 'Revisado',
            submitted: 'Enviado',
            needsWork: 'Necesita trabajo',
            retry: 'Reintentar',
            awaitingReview: 'Pendiente de revisión',
            notStarted: 'Sin comenzar',
        },
        sectionNavigator: {
            practiceProgress: 'Progreso de práctica',
            title: 'Navegador de secciones',
            subtitle: 'Salta a cualquier sección, revisa su estado y abre comentarios sin salir de la cuadrícula.',
            reviewed: 'Revisado',
            pending: 'Pendiente',
            needsWork: 'Necesita trabajo',
            vocal: 'Voz',
        },
        metrics: {
            pitch: {
                label: 'Tono',
                description: 'Ajusta mejor cada nota al tono objetivo.',
            },
            rhythm: {
                label: 'Ritmo',
                description: 'Mejora tu sincronía con el pulso.',
            },
            energy: {
                label: 'Energía',
                description: 'Controla de forma más uniforme volumen y respiración.',
            },
            chroma: {
                label: 'Croma',
                description: 'Mantén estable el centro tonal durante la frase.',
            },
            swass: {
                label: 'SWASS',
                description: 'Trabaja la claridad y consistencia del timbre vocal.',
            },
            zcr: {
                label: 'ZCR',
                description: 'Suaviza ataques ruidosos y dureza en consonantes.',
            },
        },
    },
    choirRehearse: {
        common: {
            loading: 'Cargando...',
            goBack: 'Volver',
        },
        unsavedLeavePrompt: 'Tienes cambios de armonías sin guardar. ¿Seguro que quieres salir de esta página?',
        sectionKeySaved: 'Tonalidad de la sección actualizada',
        sectionKeySaveFailed: 'No se pudo actualizar la tonalidad',
        selectedHarmonyResource: 'Arreglo seleccionado para el ensayo',
        openHarmonyResource: 'Abrir arreglo',
        harmonyResourceOpenFailed: 'No se pudo abrir el arreglo seleccionado.',
        dryRun: {
            title: 'Práctica de ensayo completo', backToRehearsal: 'Volver al ensayo', audioNotFound: 'No se encontró este audio.', lyrics: 'Letra y notas',
            practiceLoadFailed: 'No se pudieron cargar las prácticas.', microphoneFailed: 'El micrófono no está disponible.', practiceSubmitted: 'Práctica enviada', practiceSubmitFailed: 'No se pudo enviar la práctica.',
            submissions: 'Envíos de práctica', submissionProgress: '{{submitted}} de {{total}} miembros enviaron', searchMembers: 'Buscar miembros', filterAll: 'Todos', filterSubmitted: 'Enviados', filterPending: 'Pendientes',
            nudgeAll: 'Recordar a todos', nudge: 'Recordar', nudgeSent: 'Recordatorio enviado a {{count}} miembro(s).', nudgeFailed: 'No se pudo enviar el recordatorio.', pending: 'Envío pendiente', noMatchingMembers: 'Ningún miembro coincide.',
            takes: '{{count}} toma(s)', playbackFailed: 'No se puede reproducir la práctica.', feedbackPlaceholder: 'Comentarios opcionales', needsImprovement: 'Necesita mejorar', approve: 'Aprobar', reviewSaved: 'Revisión guardada', reviewFailed: 'No se pudo guardar la revisión.',
            yourPractice: 'Tu práctica', part: 'Parte del coro', selectPart: 'Selecciona tu parte', startRecording: 'Iniciar grabación', stopRecording: 'Detener grabación', recordAgain: 'Grabar otra toma', discardTake: 'Descartar toma', submit: 'Enviar práctica', resubmit: 'Reenviar práctica', submitting: 'Enviando...',
            status: {pending: 'Esperando revisión', approved: 'Aprobada', needs_improvement: 'Necesita mejorar'},
        },
        metadataEditor: {
            editButton: 'Editar metadatos de la canción',
            title: 'Editar Metadatos de la Canción',
            description: 'Actualiza tonalidad, tempo y compás para este ensayo.',
            tempoRangeError: 'El tempo debe estar entre 40 y 240 BPM.',
            timeSignatureFormatError: 'El compás debe tener un formato válido como 4/4.',
            partialSaveError: 'No se pudieron guardar algunos campos de metadatos. Inténtalo de nuevo.',
            saveSuccess: 'Metadatos de la canción actualizados',
            saveFailure: 'No se pudieron actualizar los metadatos de la canción',
        },
        lyrics: {
            mixed: 'Mixto',
            solfa: 'Solfa',
            solfaMain: 'Solfa principal',
            solfaTenor: 'Solfa tenor',
            solfaAlto: 'Solfa alto',
            solfaSoprano: 'Solfa soprano',
            chordProgression: 'Progresión de acordes',
            rehearsalFallbackTitle: 'Ensayo',
            comingSoon: '¡Próximamente!',
            referenceAudioUpload: 'Subir audio',
            referenceAudioReplace: 'Reemplazar audio',
            referenceAudioRemove: 'Eliminar audio',
            referenceAudioSaving: 'Guardando audio...',
            referenceAudioUploading: 'Subiendo audio {{percent}}%',
            referenceAudioProcessing: 'Procesando audio...',
            referenceAudioSaveSuccess: 'Audio de referencia actualizado para este coro',
            referenceAudioUploadFailed: 'Error al subir el audio de referencia',
            referenceAudioRemoveSuccess: 'Audio de referencia eliminado',
            referenceAudioRemoveFailed: 'Error al eliminar el audio de referencia',
        },
        lyricsEditor: {
            title: 'Editar contenido de canción externa',
            description: 'Añade encabezados de sección y líneas, luego genera secciones estructuradas para guardar este contenido solo para este ensayo.',
            placeholder: 'Añade un encabezado como Verso 1 y luego cada línea debajo.',
            generate: 'Generar secciones estructuradas',
            generated: 'Se generaron {{sectionCount}} sección(es) con {{lineCount}} línea(s).',
            noSections: 'No se encontraron secciones. Añade encabezados como Verso 1 o Coro antes de generar.',
            addCta: 'Agregar letra',
            editCta: 'Editar letra',
            emptyState: 'Aún no se ha agregado letra para esta canción externa.',
            addTarget: 'Agregar {{target}}',
            editTarget: 'Editar {{target}}',
            emptyStateFor: 'Aún no se ha agregado {{target}} para esta canción externa.',
            saveSuccess: 'Letra actualizada para este ensayo',
            saveSuccessFor: '{{target}} actualizado para este ensayo',
            saveFailure: 'No se pudo actualizar la letra',
        },
        lyricsSync: {
            title: 'Sincronizar tiempos de canción externa',
            description: 'Ajusta el audio del ensayo a tus letras estructuradas y reutiliza esos tiempos en la solfa y la progresión de acordes de este ensayo.',
            button: 'Sincronizar tiempos',
            recommended: 'Recomendado',
            recommendedNote: 'Después de ajustar una vez la letra principal, esos tiempos se aplicarán a todas las demás variantes estructuradas de este ensayo.',
            synced: 'Sincronizado',
            save: 'Guardar sincronización',
            saveSuccess: 'Tiempos de letra sincronizados para este ensayo',
            saveFailure: 'No se pudieron sincronizar los tiempos de la letra',
        },
        submissions: {
            goToRehearsal: 'Ir al Ensayo',
            empty: 'Aún no hay envíos',
        },
        practicePage: {
            performanceTab: 'Rendimiento',
            recentPerformance: 'Rendimiento Reciente',
            submitAll: 'Enviar Todo',
            submissionAnalyzing: 'Tu envío se está analizando. Recibirás una notificación en tu panel cuando esté listo.',
            performedVocalLabel: 'Voz Interpretada:',
            alto: 'Alto',
            slideSheetAlt: 'Hoja de diapositivas',
            toasts: {
                noRecordings: 'No hay grabaciones para subir',
                uploadSuccess: 'Grabación subida correctamente',
                uploadError: 'Error al subir grabaciones',
            },
            metrics: {
                accuracyTitle: 'Puntuación de Precisión:',
                accuracyDescription: 'Qué tan bien interpretaste las voces en comparación con la grabación original.',
                pitchTitle: 'Precisión de Tono:',
                pitchDescription: 'Qué tan cerca estuviste del tono de las voces originales.',
                timingTitle: 'Tiempo y Ritmo:',
                timingDescription: 'Tu capacidad para mantener un tiempo y ritmo adecuados durante toda la interpretación.',
                dynamicRangeTitle: 'Rango Dinámico:',
                dynamicRangeDescription: 'Evaluación de tu capacidad para expresar distintos niveles de volumen e intensidad, esencial para captar los matices de las voces originales.',
                noteArticulationTitle: 'Articulación de Notas:',
                noteArticulationDescription: 'Comentarios sobre la claridad y precisión de tus notas. Esto es importante para los melismas o el fraseo.',
                vocalToneTitle: 'Calidad del Tono Vocal:',
                vocalToneDescription: 'Evaluación de tu capacidad para reproducir el tono y timbre característicos de la parte vocal elegida.',
            },
        },
        reviewEntry: {
            userPracticeTab: 'Práctica de {{username}}',
            toasts: {
                correctionSuccess: 'Corrección subida correctamente',
                correctionError: 'Error al subir la corrección',
            },
        },
        songListCard: {
            playAlt: 'reproducir',
            remove: 'Eliminar',
            noHarmoniesForKey: 'No hay armonías disponibles para la tonalidad {{key}}',
            generateHarmonies: 'Generar armonías en {{key}} desde la tonalidad original {{originalKey}}',
            transposeHint: 'Usaremos las partes existentes de {{section}} desde {{originalKey}} y las transpondremos.',
            addHarmonyPart: '+ Agregar Parte de Armonía',
            uploadAllForSection: 'Subir Todas las Partes de Armonía para {{section}}',
            moveUp: 'Mover sección hacia arriba',
            moveDown: 'Mover sección hacia abajo',
            expand: 'Expandir {{section}}',
            collapse: 'Contraer {{section}}',
            reorderFailed: 'No se pudieron reordenar las secciones de armonía. Inténtalo de nuevo.',
            deleteSectionTitle: 'Eliminar Sección',
            deleteSectionDescription: '¿Eliminar toda la sección {{section}} y todas sus partes? Esta acción no se puede deshacer.',
            deleteSectionConfirm: 'Eliminar Sección',
            visibility: {
                private: 'Privado',
                choir_only: 'Solo coro',
                public: 'Público',
                mixed: 'Mixto',
            },
        },
        reuseHarmonies: {
            entryTitle: 'Reutilizar armonías existentes',
            entryDescription: 'Genera las partes que faltan en {{targetKey}} desde otra tonalidad grabada.',
            title: 'Reutilizar armonías existentes',
            description: 'Elige la tonalidad grabada que generará las partes que faltan en {{targetKey}}.',
            targetKey: 'Tonalidad de trabajo',
            selectSource: 'Seleccionar tonalidad de origen',
            coverage: '{{parts}} partes en {{sections}} secciones',
            generate: 'Generar armonías',
            generating: 'Generando...',
            queued: 'Se están generando las armonías en {{targetKey}}',
            alreadyAvailable: 'Todas las armonías de esta tonalidad ya están disponibles',
            failed: 'No se pudieron reutilizar las armonías existentes',
        },
        harmonyLibrary: {
            entryTitle: 'Armonías de la comunidad',
            entryDescription: 'Explora arreglos compartidos por otros cantantes y coros.',
            title: 'Armonías de la comunidad',
            description: 'Previsualiza y agrega un arreglo a las armonías personalizadas de este coro.',
            search: 'Buscar armonías de la comunidad',
            searchAction: 'Buscar',
            retry: 'Intentar cargar de nuevo las armonías de la comunidad',
            empty: 'Aún no hay armonías de la comunidad',
            untitled: 'Arreglo sin título',
            community: 'Comunidad Vocal Centric',
            noKey: 'Sin tonalidad',
            preview: 'Vista previa',
            add: 'Agregar',
            adding: 'Agregando...',
            unlock: 'Desbloquear',
            added: 'Armonía agregada a las armonías personalizadas',
            alreadyAdded: 'Esta armonía ya está en las armonías personalizadas',
            addFailed: 'No se pudo agregar la armonía de la comunidad',
            unlockFailed: 'No se pudo desbloquear esta armonía de la comunidad',
        },
        partRow: {
            midiTag: '• MIDI',
            pickExisting: 'Elegir Existente',
            pickExistingOption: '{{name}} ({{section}}) en {{songKey}} {{midiTag}}',
            pauseAudioTooltip: 'Pausar esta parte de audio',
            playAudioTooltip: 'Reproducir esta parte de audio',
            pauseAudioAria: 'Pausar parte de audio',
            playAudioAria: 'Reproducir parte de audio',
            pauseMidiTooltip: 'Pausar esta parte MIDI',
            playMidiTooltip: 'Reproducir esta parte MIDI',
            pauseMidiAria: 'Pausar parte MIDI',
            playMidiAria: 'Reproducir parte MIDI',
            stopRecordingTooltip: 'Detener la grabación de esta parte de armonía',
            recordNewTakeTooltip: 'Grabar una nueva toma de audio',
            failedStartRecording: 'No se puede acceder al micrófono. Verifica los permisos del navegador y usa HTTPS.',
            stopRecordingAria: 'Detener grabación',
            recordTakeAria: 'Grabar toma de audio',
            uploadTooltip: 'Subir un archivo de audio o MIDI',
            uploadAria: 'Subir archivo',
            convertToMidiTooltip: 'Convertir esta toma de audio a MIDI editable',
            convertToMidiAria: 'Convertir grabación a MIDI',
            undoConvertTooltip: 'Restaurar el audio original antes de la conversión',
            undoConvertAria: 'Deshacer conversión MIDI',
            duplicateMidiTooltip: 'Duplicar este MIDI en otra parte de armonía',
            duplicateMidiAria: 'Duplicar MIDI en otra parte',
            closeMidiEditorTooltip: 'Cerrar el editor MIDI',
            openMidiEditorTooltip: 'Abrir el editor MIDI de piano',
            collapseMidiEditorAria: 'Contraer editor MIDI',
            openMidiEditorAria: 'Abrir editor MIDI',
            removePartTooltip: 'Eliminar esta parte de armonía',
            removePartAria: 'Eliminar parte de armonía',
            renameTooltip: 'Renombrar esta parte de armonía transpuesta',
            renameAria: 'Renombrar {{part}}',
            renameSuccess: 'Parte de armonía renombrada',
            renameFailed: 'No se pudo renombrar la parte de armonía',
            ready: 'Listo',
            beats: 'pulsos',
            bpm: 'BPM',
            clickDuringTake: 'clic durante la toma',
            countInOnly: 'solo conteo',
            clickOff: 'clic apagado',
            loadingWaveform: 'Cargando forma de onda...',
            align: 'Alinear',
            earlier: 'Antes',
            later: 'Después',
            reset: 'Restablecer',
            uploadOrSelectBeforeSave: 'Sube o selecciona un archivo para esta parte antes de guardar.',
            convertingToMidi: 'Convirtiendo audio a melodía MIDI…',
            deletePartTitle: 'Eliminar Parte de Armonía',
            deletePartDescription: '¿Eliminar {{part}} de esta sección? Esta acción no se puede deshacer.',
            deletePartConfirm: 'Eliminar Parte',
            midiEditorTitle: 'Editor MIDI',
            midiEditorDescription: 'Edita y reproduce la parte de armonía con más espacio.',
            closeMidiEditorAria: 'Cerrar editor MIDI',
            saveMidiChangesTitle: '¿Guardar cambios de MIDI?',
            saveMidiChangesDescription: 'Tienes ediciones MIDI sin guardar. Guárdalas antes de cerrar el editor o descártalas.',
            keepEditing: 'Seguir Editando',
            discard: 'Descartar',
            save: 'Guardar',
            recordingSetupTitle: 'Configuración de Grabación',
            recordingSetupSubtitle: 'Configura el clic y el conteo antes de grabar esta parte.',
            closeRecordingSetupAria: 'Cerrar configuración de grabación',
            referenceTrack: 'Pista de Referencia',
            none: 'Ninguno',
            lockTakeToReference: 'Bloquear toma a referencia',
            playReferenceInTake: 'Reproducir referencia en la toma',
            referenceVolume: 'Volumen de Referencia',
            clickMode: {
                off: 'Apagado',
                'count-in-only': 'Solo Conteo',
                'count-in-and-record': 'Conteo + Toma',
            },
            timeSignature: 'Compás',
            tempo: 'Tempo',
            countInLabel: 'Conteo',
            bar: 'compás',
            bars: 'compases',
            countInOption: '{{bars}} {{unit}} ({{beats}} pulsos)',
            preview: 'Vista previa',
            previewClickTrack: 'Previsualizar pista de clic',
            compoundFeelNote: 'Compás compuesto activo. El clic agrupa este compás por pulsos de negra con puntillo para una entrada más natural.',
            referenceModeNote: 'Modo de referencia activo. El tempo y el compás se bloquean a la referencia seleccionada para mantener esta toma sincronizada.',
            startRecording: 'Iniciar Grabación',
            uploadedPercent: '{{percent}}% subido',
            toasts: {
                noClearMelody: 'No se detectó una melodía clara. Prueba con una toma monofónica más limpia.',
                convertedToMidi: 'Grabación convertida a MIDI',
                failedConvertToMidi: 'No se pudo convertir la grabación a MIDI',
                restoredAudio: 'Audio restaurado antes de la conversión MIDI',
                duplicatedMidi: 'MIDI duplicado a {{targetPart}} ({{intervalLabel}})',
                failedDuplicateMidi: 'No se pudo duplicar la parte MIDI',
            },
        },
    },
    setlist: {
        yourSetlists: 'Tus setlists',
        tabs: {
            mine: 'Mi setlist',
            explore: 'Explorar',
        },
        deletedSuccessfully: 'Setlist eliminada correctamente',
        linkCopied: '¡Enlace copiado al portapapeles!',
        songCount: '{{count}} canción(es)',
        updatedDate: 'Actualizado: {{date}}',
        empty: 'Aún no has creado ninguna setlist.',
        sharedToChoir: 'Setlist compartida con el coro',
        explore: {
            title: 'Explorar setlists públicas',
            subtitle: 'Descubre listas de adoración y presentación con recursos prácticos de otros equipos.',
            searchPlaceholder: 'Buscar setlists',
            creatorFallback: 'Creador de VocalCentric',
            free: 'Gratis',
            paid: 'De pago',
            premium: 'Premium',
            mixed: 'Mixto',
            resources: '{{count}} recurso(s)',
            empty: 'No se encontraron setlists públicas.',
            loadFailed: 'No se pudieron cargar las setlists públicas',
            access: {
                all: 'Todo acceso',
                free: 'Gratis',
                paid: 'De pago',
                premium: 'Premium',
                mixed: 'Mixto',
            },
        },
        owned: {
            back: 'Volver a setlists',
            loadFailed: 'No se pudo cargar la setlist',
            notFound: 'No se pudo encontrar esta setlist.',
            personalEyebrow: 'Tu setlist',
            choirEyebrow: 'Setlist del coro',
            share: 'Compartir setlist',
            editDetails: 'Editar detalles',
            setlistName: 'Nombre de la setlist',
            nameRequired: 'Ingresa un nombre de al menos dos caracteres.',
            scheduledFor: 'Programada para',
            editDetailsDescription: 'Actualiza el nombre, la visibilidad, la programación y los datos para compartir.',
            detailsSaved: 'Detalles de la setlist guardados',
            detailsSaveFailed: 'No se pudieron guardar los detalles',
            shareLink: 'Enlace para compartir',
            loadingVideo: 'Cargando video…',
            videoUnavailable: 'No se pudo cargar este video.',
            seekBackward15Seconds: 'Retroceder 15 segundos',
            seekForward15Seconds: 'Avanzar 15 segundos',
            playSetlist: 'Reproducir setlist',
            nowPlaying: 'Reproduciendo ahora',
            listen: 'Escuchar',
            songs: 'Canciones de la setlist',
            addSong: 'Agregar canción',
            addSongDescription: 'Elige una fuente, revisa la canción y agrégala a esta setlist.',
            songRequired: 'Elige una canción y añade su etiqueta.',
            songLabel: 'Etiqueta de la setlist',
            songSources: {
                search: 'Biblioteca',
                youtube: 'YouTube',
                public: 'Dominio público',
            },
            playSong: 'Reproducir canción',
            pauseSong: 'Pausar canción',
            dockPlayer: 'Acoplar reproductor',
            noPlayableMedia: 'Sin video',
            noSongs: 'Aún no se agregaron canciones.',
            deleteSongConfirm: '¿Quitar esta canción de la setlist?',
            listenTarget: 'Objetivo de escucha',
            listenTypes: {
                entire: 'Canción completa',
                segment: 'Segmento',
            },
            listenStart: 'Inicio',
            listenEnd: 'Fin',
            invalidListenSegment: 'Ingresa un segmento de escucha válido.',
            entireTarget: 'Escuchar la canción completa',
            segmentTarget: 'Escuchar de {{start}} a {{end}}',
            prepare: 'Preparar',
            resources: 'Recursos de la setlist',
            resourcesDescription: 'Partituras, documentos, enlaces, stems, audio de referencia y arreglos vocales agrupados para esta setlist.',
            noResources: 'Aún no se agregaron recursos.',
            manageResources: 'Gestionar recursos',
            manageResourcesDescription: 'Crea recursos individuales o arreglos vocales agrupados y controla cómo se comparten.',
            addResource: 'Agregar recurso',
            editResource: 'Editar recurso',
            deleteResource: 'Eliminar recurso',
            deleteResourceConfirm: '¿Eliminar este recurso de la setlist?',
            resourceType: 'Tipo de recurso',
            resourceTypes: {
                document: 'Documento',
                audio: 'Audio',
                stem: 'Stem',
                chart: 'Partitura',
                link: 'Enlace',
                other: 'Otro',
                vocal_arrangement: 'Arreglo vocal',
            },
            arrangementEditorDescription: 'Elige una canción, agrega secciones y sube cada parte vocal por separado.',
            arrangementSong: 'Canción',
            selectArrangementSong: 'Seleccionar una canción',
            arrangementKey: 'Tonalidad',
            arrangementKeyOptional: 'Sin tonalidad seleccionada',
            arrangementSections: 'Secciones del arreglo',
            sectionName: 'Nombre de la sección',
            addSection: 'Agregar sección',
            removeSection: 'Eliminar sección',
            arrangementSectionRequired: 'Agrega al menos una sección al arreglo.',
            arrangementPart: 'Parte vocal',
            selectArrangementPart: 'Seleccionar una parte vocal',
            addPart: 'Agregar parte',
            removePart: 'Eliminar parte',
            arrangementPartRequired: 'Agrega al menos una parte vocal a esta sección.',
            partAudio: 'Subir audio de la parte',
            replacePartAudio: 'Reemplazar audio de la parte',
            arrangementRequired: 'Elige una canción y agrega al menos una sección con un archivo de audio para cada parte.',
            noArrangementParts: 'No hay partes vocales disponibles para reproducir.',
            selectPart: 'Seleccionar {{part}}',
            resourceTitle: 'Título',
            resourceDescription: 'Descripción',
            resourceAccess: 'Acceso',
            premiumAccess: 'Suscriptores Premium',
            resourceUrl: 'URL del recurso',
            uploadResource: 'Subir recurso',
            audioFilesSupported: 'Compatible con MP3, WAV, M4A o AAC',
            documentFilesSupported: 'Compatible con PDF o DOCX',
            resourcePrice: 'Precio',
            resourceCurrency: 'Moneda',
            resourcePublic: 'Mostrar este recurso en la setlist pública',
            resourceRequired: 'Agrega un título y un archivo o URL.',
            resourceSaved: 'Recurso guardado',
            resourceSaveFailed: 'No se pudo guardar el recurso',
            resourceDeleted: 'Recurso eliminado',
            resourceDeleteFailed: 'No se pudo eliminar el recurso',
            resourcePreview: 'Vista previa del recurso',
            audioUnavailable: 'No se pudo cargar este audio.',
            openResourceDescription: 'Este recurso se abre en una nueva pestaña.',
            saving: 'Guardando…',
            listenAudit: 'Auditoría de escucha',
            auditDescription: 'Consulta quién escuchó y qué canciones reciben atención.',
            auditLoadFailed: 'No se pudo cargar la auditoría',
            loadingAudit: 'Cargando auditoría…',
            listeners: 'Oyentes',
            listens: 'Escuchas',
            songsHeard: 'Canciones escuchadas',
            noAudit: 'Aún no se registró actividad de escucha.',
            nudgeMembers: 'Recordar a quienes no han escuchado',
            sendingNudge: 'Enviando recordatorio…',
            nudgeSent: 'Recordatorio enviado a {{count}} miembro(s)',
            nudgeFailed: 'No se pudo enviar el recordatorio',
        },
        public: {
            fallbackTitle: 'Setlist',
            ogDescription: 'Una setlist curada en VocalCentric con {{count}} canciones.',
            copyShareLink: 'Copiar enlace',
            labelPrefix: 'Etiqueta:',
            listenOnSpotify: 'Escuchar en Spotify',
            watchOnYoutube: 'Ver en YouTube',
            listen: 'Escuchar',
            resources: 'Recursos',
            free: 'Gratis',
            paid: 'De pago',
            premium: 'Premium',
            openResource: 'Abrir recurso',
            unlockResource: 'Desbloquear recurso',
            upgradeForPremium: 'Actualizar a Premium',
            resourceCheckoutFailed: 'No se pudo iniciar el pago del recurso',
        },
    },
    transactions: {
        historyTitle: 'Historial de transacciones',
        detailsTitle: 'Detalles de la transacción',
        tableDate: 'Fecha',
        tableOrderNumber: 'Número de orden',
        tablePrice: 'Precio',
        viewDetails: 'Ver detalles',
    },
    profile: {
        aboutTitle: 'Acerca de',
        noSummary: 'Aún no se agregó un resumen del perfil.',
        experience: 'Experiencia',
        years: '{{count}} años',
        notSpecified: 'No especificado',
        availability: 'Disponibilidad',
        availableForProjects: 'Disponible para proyectos',
        notCurrentlyAvailable: 'No disponible actualmente',
        location: 'Ubicación',
        timezone: 'Zona horaria',
        skillsTitle: 'Habilidades',
        addSkill: 'Agregar habilidad',
        noSkills: 'Aún no se agregaron habilidades.',
        editSkill: 'Editar habilidad',
        deleteSkill: 'Eliminar habilidad',
        portfolioTitle: 'Portafolio',
        addItem: 'Agregar elemento',
        noPortfolioItems: 'Aún no hay elementos en el portafolio.',
        previewMedia: 'Vista previa',
        editPortfolioItem: 'Editar elemento del portafolio',
        deletePortfolioItem: 'Eliminar elemento del portafolio',
        previewPortfolioItem: 'Vista previa de {{title}}',
        reviewsTitle: 'Reseñas',
        reviewsSubtitle: 'Calificaciones y señales de confianza de colaboraciones anteriores.',
        rating: 'Calificación',
        reviews: 'Reseñas',
        completed: 'Completado',
        repeatHires: 'Recontrataciones',
        compactReviews: '({{count}} reseñas)',
        uploading: 'Subiendo {{progress}}%',
        uploadAvatar: 'Subir avatar',
        profileAvatar: 'Avatar del perfil',
        defaultHeadline: 'Profesional creativo en VocalCentric.',
        shareProfile: 'Compartir perfil',
        editProfile: 'Editar perfil',
        addPortfolioItem: 'Agregar elemento al portafolio',
        follow: 'Seguir',
        unfollow: 'Dejar de seguir',
        inviteToProject: 'Invitar al proyecto',
        contact: 'Contactar',
        locationUnavailable: 'Ubicación no disponible',
        memberSince: 'Miembro desde {{date}}',
        page: {
            inviteDisabledReason: 'Necesitas al menos un proyecto propio para enviar invitaciones.',
            unavailable: {
                title: 'Perfil no disponible',
                needsInitialization: 'Tu perfil profesional aún no se ha creado. Créalo primero y luego actualiza la visibilidad si es necesario.',
                ineligible: 'Tu cuenta no es elegible para gestionar un perfil profesional.',
                ownerPrivate: 'Tu perfil profesional es privado actualmente. Hazlo público para verlo en esta ruta.',
                viewerPrivateOrMissing: 'Este perfil profesional es privado o no existe.',
            },
            options: {
                profileType: {
                    creative: 'Creativo',
                    owner: 'Propietario del proyecto',
                    both: 'Ambos',
                },
                visibility: {
                    public: 'Público',
                    private: 'Privado',
                },
                skillType: {
                    voice_part: 'Parte vocal',
                    instrument: 'Instrumento',
                    role: 'Rol',
                    specialty: 'Especialidad',
                },
                proficiency: {
                    beginner: 'Principiante',
                    intermediate: 'Intermedio',
                    advanced: 'Avanzado',
                    expert: 'Experto',
                },
                availability: {
                    'true': 'Disponible para proyectos',
                    'false': 'No disponible',
                },
            },
            quickInfo: {
                title: 'Información rápida',
                type: 'Tipo',
                visibility: 'Visibilidad',
                defaultPart: 'Parte predeterminada',
            },
            payout: {
                title: 'Cuentas de pago',
                description: 'Se usan para transferencias de pago de proyectos.',
                loading: 'Cargando cuentas de pago...',
                empty: 'Aún no hay una cuenta de pago configurada.',
                accountFallback: 'Cuenta de pago',
                defaultTag: 'predeterminada',
                noAccountNumber: 'Sin número de cuenta',
                noBankName: 'Sin nombre de banco',
                swiftPrefix: 'SWIFT',
            },
            actions: {
                createProfile: 'Crear perfil',
                makeProfilePublic: 'Hacer perfil público',
                applyForWhitelist: 'Solicitar whitelist',
                add: 'Agregar',
                save: 'Guardar',
                close: 'Cerrar',
                edit: 'Editar',
                remove: 'Quitar',
                delete: 'Eliminar',
                copyEmail: 'Copiar correo',
                openEmailApp: 'Abrir app de correo',
                openMedia: 'Abrir medio',
            },
            share: {
                fallbackText: 'Ver {{title}} en VocalCentric.',
            },
            contact: {
                mailSubject: 'Contacto del perfil de VocalCentric: {{name}}',
                mailBody: 'Hola {{name}},\n\nEncontré tu perfil en VocalCentric y me gustaría conectar.',
            },
            modals: {
                editProfile: {
                    title: 'Editar perfil',
                    description: 'Actualiza los datos de identidad profesional y preferencias de portafolio.',
                    headline: 'Titular',
                    displayNameOverride: 'Nombre visible personalizado',
                    displayNamePlaceholder: 'Cómo debería aparecer tu nombre públicamente',
                    portfolioSummary: 'Resumen del portafolio',
                    summaryPlaceholder: 'Resumen',
                    profileType: 'Tipo de perfil',
                    timezone: 'Zona horaria',
                    selectTimezone: 'Selecciona zona horaria',
                    visibility: 'Visibilidad',
                    availabilityForProjects: 'Disponibilidad para proyectos',
                    city: 'Ciudad',
                    state: 'Estado',
                    country: 'País',
                    selectCountry: 'Selecciona país',
                    experienceYears: 'Experiencia (años)',
                    experiencePlaceholder: 'Años de experiencia',
                    websiteUrl: 'URL del sitio web',
                    instagramUrl: 'URL de Instagram',
                    youtubeUrl: 'URL de YouTube',
                    tiktokUrl: 'URL de TikTok',
                    linkedinUrl: 'URL de LinkedIn',
                    urlPlaceholder: 'https://...',
                    primaryCategory: 'Categoría principal',
                    selectCategory: 'Selecciona categoría',
                    currency: 'Moneda',
                    selectCurrency: 'Selecciona moneda',
                    minRate: 'Tarifa mínima',
                    maxRate: 'Tarifa máxima',
                    numberPlaceholder: '0',
                    rateNotes: 'Notas de tarifa',
                    notesPlaceholder: 'Notas',
                },
                payoutAccount: {
                    editTitle: 'Editar cuenta de pago',
                    addTitle: 'Agregar cuenta de pago',
                    description: 'Agrega los datos de transferencia bancaria usados para pagos.',
                    country: 'País',
                    accountName: 'Nombre de la cuenta',
                    accountNamePlaceholder: 'Nombre del titular',
                    accountNumber: 'Número de cuenta',
                    accountNumberPlaceholder: '0123456789',
                    bankName: 'Nombre del banco',
                    bankNamePlaceholder: 'Nombre del banco',
                    loadingBanks: 'Cargando bancos...',
                    selectBank: 'Selecciona banco',
                    swiftCode: 'Código SWIFT (opcional)',
                    swiftCodePlaceholder: 'Para transferencias internacionales',
                    defaultLabel: 'Establecer como predeterminada',
                    saving: 'Guardando...',
                    save: 'Guardar',
                    toast: {
                        requiredFields: 'País, nombre de cuenta, número de cuenta y nombre del banco son obligatorios.',
                        selectBank: 'Selecciona un banco de la lista.',
                        updated: 'Cuenta de pago actualizada.',
                        added: 'Cuenta de pago agregada.',
                        saveFailed: 'No se pudo guardar la cuenta de pago',
                    },
                },
                skill: {
                    editTitle: 'Editar habilidad',
                    addTitle: 'Agregar habilidad',
                    skillType: 'Tipo de habilidad',
                    skillName: 'Nombre de la habilidad',
                    skillNamePlaceholder: 'Nombre de la habilidad',
                    proficiency: 'Nivel',
                    yearsExperience: 'Años de experiencia',
                    numberPlaceholder: '0',
                    markPrimary: 'Marcar como habilidad principal',
                },
                portfolio: {
                    editTitle: 'Editar elemento del portafolio',
                    addTitle: 'Agregar elemento del portafolio',
                    title: 'Título',
                    projectName: 'Nombre del proyecto',
                    projectNamePlaceholder: 'Nombre del proyecto',
                    rolePerformed: 'Rol desempeñado',
                    rolePlaceholder: 'Rol',
                    category: 'Categoría',
                    mediaUrl: 'URL del medio',
                    thumbnailUrl: 'URL de miniatura',
                    externalUrl: 'URL externa',
                    urlPlaceholder: 'https://...',
                    creditedArtist: 'Artista acreditado',
                    artistNamePlaceholder: 'Nombre del artista',
                    yearCompleted: 'Año de finalización',
                    yearPlaceholder: '2026',
                    featureThisWork: 'Destacar este trabajo',
                    description: 'Descripción',
                    describeWorkPlaceholder: 'Describe este trabajo',
                },
                invite: {
                    title: 'Invitar al proyecto',
                    description: 'Elige uno de tus proyectos y un rol abierto para enviar una invitación.',
                    project: 'Proyecto',
                    selectProject: 'Selecciona proyecto',
                    role: 'Rol',
                    loadingRoles: 'Cargando roles...',
                    selectRole: 'Selecciona rol',
                    noOpenRoles: 'Este proyecto no tiene roles abiertos ahora. Agrega roles o abre más cupos para enviar una invitación.',
                    inviteeEmail: 'Correo del invitado',
                    inviteeEmailPlaceholder: 'user@example.com',
                    sending: 'Enviando...',
                    sendInvite: 'Enviar invitación',
                },
                contact: {
                    title: 'Contacto',
                    description: 'Usa el correo del perfil para contactarlo directamente.',
                    emailPlaceholder: 'user@example.com',
                },
                preview: {
                    title: 'Vista previa del portafolio',
                    externalMediaSource: 'Este elemento apunta a una fuente de medios externa.',
                    noMedia: 'No hay medios previsualizables adjuntos a este elemento del portafolio.',
                },
                deleteSkill: {
                    title: 'Eliminar habilidad',
                    description: '¿Quitar "{{name}}" de tu perfil? Esta acción no se puede deshacer.',
                    thisSkill: 'esta habilidad',
                },
                deletePortfolio: {
                    title: 'Eliminar elemento del portafolio',
                    description: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
                    thisPortfolioItem: 'este elemento del portafolio',
                },
            },
            toast: {
                loadPayoutAccountsFailed: 'No se pudieron cargar las cuentas de pago',
                loadProjectRolesFailed: 'No se pudieron cargar los roles del proyecto',
                profilePublic: 'El perfil ahora es público.',
                updateVisibilityFailed: 'No se pudo actualizar la visibilidad del perfil',
                profileCreated: 'Perfil profesional creado. Ahora puedes completar tus datos.',
                initializeProfileFailed: 'No se pudo inicializar el perfil profesional',
                profileVisibilityUpdated: 'El perfil ahora es {{visibility}}.',
                profileUpdated: 'Perfil actualizado.',
                updateProfileFailed: 'No se pudo actualizar el perfil',
                skillSaved: 'Habilidad guardada.',
                saveSkillFailed: 'No se pudo guardar la habilidad',
                skillRemoved: 'Habilidad eliminada.',
                removeSkillFailed: 'No se pudo eliminar la habilidad',
                portfolioSaved: 'Elemento del portafolio guardado.',
                savePortfolioFailed: 'No se pudo guardar el elemento del portafolio',
                payoutRemoved: 'Cuenta de pago eliminada.',
                removePayoutFailed: 'No se pudo eliminar la cuenta de pago',
                portfolioRemoved: 'Elemento del portafolio eliminado.',
                removePortfolioFailed: 'No se pudo eliminar el elemento del portafolio',
                userContactUnavailable: 'El contacto del usuario no está disponible.',
                noContactEmail: 'No se encontró correo de contacto para este perfil.',
                contactWorkflowFailed: 'No se pudo abrir el flujo de contacto',
                createProjectToInvite: 'Crea un proyecto para enviar invitaciones desde perfiles.',
                userUnavailableForInvite: 'El usuario del perfil no está disponible para invitaciones.',
                noInviteEmail: 'No hay correo de invitación disponible para este perfil.',
                createProjectBeforeInvite: 'Primero crea un proyecto antes de enviar una invitación.',
                prepareInviteFailed: 'No se pudo preparar el flujo de invitación',
                selectProjectRole: 'Selecciona proyecto y rol antes de enviar la invitación.',
                inviteSent: 'Invitación enviada correctamente.',
                sendInviteFailed: 'No se pudo enviar la invitación',
                profileFollowed: 'Perfil seguido.',
                profileUnfollowed: 'Has dejado de seguir el perfil.',
                toggleFollowFailed: 'No se pudo {{action}} el perfil en este momento.',
                emailCopied: 'Correo copiado.',
                copyEmailFailed: 'No se pudo copiar el correo.',
                shareProfileFailed: 'No se puede compartir este perfil en este momento.',
                profileLinkCopied: 'Enlace del perfil copiado.',
                shareProfileLinkFailed: 'No se pudo compartir el enlace del perfil.',
                avatarUpdated: 'Avatar actualizado.',
                coverUpdated: 'Imagen de portada actualizada.',
                updateImageFailed: 'No se pudo actualizar la imagen.',
                uploadImageFailed: 'No se pudo subir la imagen.',
            },
        },
    },
    error: {
        pageNotFound: 'La página que buscas no existe.',
        goHome: 'Ir al inicio',
        goBack: 'Volver',
        emptyDefault: 'No hay nada aquí, vuelve a la página anterior.',
        comingSoon: 'Espera un momento, estamos trabajando en esta función',
        somethingWentWrong: 'Algo salió mal',
        tryAgain: 'Intentar de nuevo',
        loadPageFailed: 'Algo salió mal al cargar esta página.',
        pageUpdateDetected: 'Se detectó una actualización de la página',
        pageRefreshHint: 'Esta pantalla no terminó de cargar. Actualizar suele solucionarlo cuando cambió el código de la app.',
        unexpectedRenderError: 'Un error inesperado impidió renderizar esta pantalla.',
        refreshApp: 'Actualizar app',
    },
    public: {
        layout: {
            gotoDashboard: 'Ir al panel',
            createSetlistsPrompt: '¿Quieres crear tus propias listas de canciones?',
            copyright: '© {{year}} VocalCentric. Todos los derechos reservados.',
            about: 'Acerca de',
            privacy: 'Privacidad',
            terms: 'Términos',
            contact: 'Contacto',
        },
        cookieNotice: {
            label: 'Aviso de cookies',
            message: 'Usamos cookies para mejorar VocalCentric.',
            dismiss: 'Cerrar el aviso de cookies',
        },
        resourceHandoff: {
            fallbackTitle: 'Recurso compartido',
            signInTitle: 'Inicia sesión para abrir este recurso',
            signInDescription: 'Los enlaces de contribuciones están disponibles para miembros de VocalCentric con sesión iniciada.',
            signIn: 'Iniciar sesión para continuar',
            unavailableTitle: 'Recurso no disponible',
            unavailableDescription: 'Este recurso puede estar sin publicar, eliminado o ya no compartido contigo.',
            eyebrow: 'Contribución compartida',
            openApp: 'Abrir en VocalCentric',
            openAppHint: 'Necesitas la aplicación VocalCentric para previsualizar o usar este recurso.',
        },
        communityThreadHandoff: {
            fallbackTitle: 'Hilo de la comunidad',
            signInTitle: 'Inicia sesión para abrir este hilo',
            signInDescription: 'Los enlaces de hilos están disponibles para miembros de VocalCentric con sesión iniciada.',
            signIn: 'Iniciar sesión para continuar',
            unavailableTitle: 'Hilo no disponible',
            unavailableDescription: 'Este hilo puede haberse eliminado o quizá debas unirte primero a su sala.',
            eyebrow: 'Hilo de la comunidad compartido',
            openApp: 'Abrir en VocalCentric',
            openAppHint: 'Necesitas la aplicación VocalCentric para ver y participar en esta conversación.',
        },
        contact: {
            title: 'Contáctanos',
            subtitle: '¿Necesitas ayuda, tienes comentarios o quieres asociarte con VocalCentric? Envíanos un mensaje.',
            intercomTitle: 'Chatea con soporte',
            intercomSubtitle: 'Abre Messenger para iniciar una conversación con el equipo de VocalCentric.',
            openMessenger: 'Abrir chat de soporte',
            intercomFallback: 'El chat de soporte no está disponible ahora. Escríbenos a support@vocalcentric.com.',
            submitted: 'Mensaje recibido. Te responderemos pronto.',
            namePlaceholder: 'Tu nombre',
            emailPlaceholder: 'tu@ejemplo.com',
            subjectPlaceholder: 'Selecciona un asunto…',
            messagePlaceholder: 'Escribe tu mensaje…',
            sending: '...Enviando',
            send: 'Enviar mensaje',
            preferEmail: '¿Prefieres correo? Escríbenos a',
            responseTime: 'Tiempo de respuesta: normalmente entre 24 y 72 horas (días laborables).',
            subject: {
                support: 'Soporte / Ayuda',
                billing: 'Facturación / Suscripción',
                bug: 'Reporte de error',
                feedback: 'Solicitud de función / Comentarios',
                partnership: 'Asociación / Licencias',
                accountDeletion: 'Eliminación de cuenta',
                other: 'Otro',
            },
            error: {
                nameRequired: 'El nombre es obligatorio.',
                emailRequired: 'El correo es obligatorio.',
                invalidEmail: 'Ingresa un correo válido.',
                subjectRequired: 'Selecciona un asunto.',
                messageRequired: 'El mensaje es obligatorio.',
                messageTooShort: 'El mensaje es demasiado corto (mínimo 10 caracteres).',
                unexpected: 'Ocurrió un error inesperado.',
            },
            toast: {
                sent: '¡Mensaje enviado! Te responderemos pronto.',
            },
        },
        waitlist: {
            title: 'Únete a la lista de espera',
            subtitle: 'Obtén acceso anticipado exclusivo y mantente informado sobre nuestro lanzamiento.',
            submitted: '¡Ya estás en la lista de espera!',
            firstName: 'Nombre',
            lastName: 'Apellido',
            phonePlaceholder: 'Ingresa número de teléfono (+212 34567890)',
            emailPlaceholder: 'tu@ejemplo.com',
            loading: '...Cargando',
            getNotified: 'Recibir aviso',
            gotEarlyAccess: '¿Ya tienes acceso anticipado?',
            logIn: 'Iniciar sesión',
            joinedCount: 'Más de ~1.4k+ personas ya se unieron',
            days: 'Días',
            hours: 'Horas',
            minutes: 'Minutos',
            seconds: 'Segundos',
            toast: {
                joined: '¡Gracias por unirte a la lista de espera!',
            },
            error: {
                emailRequired: 'El correo es obligatorio.',
                invalidEmail: 'Ingresa un correo válido.',
                invalidPhone: 'Ingresa un número de teléfono válido.',
                unexpected: 'Ocurrió un error inesperado.',
            },
        },
        invitation: {
            pageTitle: 'Aceptar invitación de coro',
            joinChoir: 'Únete al coro {{name}}',
            confirmJoin: 'Confirma y únete a {{name}} en VocalCentric',
            completeRegistration: 'Completa tu registro para aceptar la invitación',
            firstName: 'Nombre',
            firstNamePlaceholder: 'Ingresa tu nombre',
            lastName: 'Apellido',
            lastNamePlaceholder: 'Ingresa tu apellido',
            username: 'Nombre de usuario',
            usernamePlaceholder: 'Ingresa tu nombre de usuario preferido',
            password: 'Contraseña',
            passwordPlaceholder: 'Crea una contraseña',
            accept: 'Aceptar invitación',
            decline: 'Rechazar',
            accepted: '¡Invitación aceptada correctamente!',
            declined: 'Invitación rechazada correctamente.',
            error: {
                firstNameRequired: 'El nombre es obligatorio',
                lastNameRequired: 'El apellido es obligatorio',
                usernameRequired: 'El nombre de usuario es obligatorio',
                passwordRequired: 'La contraseña es obligatoria',
                invalidEmail: 'Ingresa un correo válido',
                usernameTaken: 'El nombre de usuario ya está en uso',
                failedUsernameCheck: 'No se pudo validar el nombre de usuario',
                failedDecline: 'No se pudo rechazar la invitación',
            },
        },
        schedule: {
            loadFailed: 'No se pudo cargar el horario público',
            missingToken: 'Falta el token del horario',
            unavailable: 'Horario público no disponible',
            couldNotLoad: 'No se pudo cargar este horario.',
            publicChoirSchedule: 'Horario público del coro',
            serviceCount: '{{count}} servicio(s)',
        },
        harmony: {
            mixerView: 'Vista de mezclador',
            mixerViewInfo: '(Recomendado para PC) En la vista de mezclador puedes ajustar el volumen y paneo de pistas individuales para una escucha personalizada.',
            loadingWaveform: 'Cargando forma de onda...',
            mute: 'Silenciar',
            unmute: 'Quitar silencio',
            solo: 'Solo',
            unsolo: 'Quitar solo',
            titleFallback: 'Armonías',
            setlistFallback: 'Setlist',
            ogDescription: 'Un setlist seleccionado en VocalCentric con armonías personalizadas para distintas partes e instrumentos.',
            playPause: 'Reproducir o pausar',
            restart: 'Reiniciar',
        },
        privacy: {
            gotoDashboard: 'Ir al panel',
            policyTitle: 'Política de privacidad de {{companyName}}',
            lastUpdated: 'Última actualización: {{lastUpdated}}',
            intro: 'En {{companyName}}, valoramos tu privacidad y nos comprometemos a proteger tu información personal. Esta Política de privacidad explica cómo recopilamos, usamos y protegemos los datos que compartes con nosotros cuando usas nuestra plataforma, app móvil o servicios relacionados.',
            section1Title: '1. Información que recopilamos',
            section1Intro: 'Podemos recopilar los siguientes tipos de información:',
            personalInfoLabel: 'Información personal',
            personalInfoBody: 'Nombre, correo electrónico, número de teléfono, foto de perfil y otros datos que proporcionas al crear una cuenta.',
            usageDataLabel: 'Datos de uso',
            usageDataBody: 'Información sobre cómo usas nuestra plataforma, incluidas reproducciones, participación en ensayos e interacciones con otros usuarios.',
            mediaFilesLabel: 'Archivos multimedia',
            mediaFilesBody: 'Grabaciones de audio, videos y otro contenido que subes o compartes.',
            deviceInfoLabel: 'Información del dispositivo',
            deviceInfoBody: 'Dirección IP, tipo de navegador, modelo del dispositivo, sistema operativo y versión de la app.',
            cookiesLabel: 'Cookies y datos de seguimiento',
            cookiesBody: 'Para mejorar tu experiencia y recordar preferencias.',
            section2Title: '2. Cómo usamos tu información',
            section2Item1: 'Proveer y mejorar nuestros servicios.',
            section2Item2: 'Facilitar ensayos de coro, reproducción de canciones e interacciones de comunidad.',
            section2Item3: 'Personalizar contenido y recomendaciones.',
            section2Item4: 'Comunicarnos contigo sobre actualizaciones, soporte u ofertas promocionales (con tu consentimiento).',
            section2Item5: 'Garantizar seguridad, protección y cumplimiento de nuestros Términos de servicio.',
            section3Title: '3. Cómo compartimos tu información',
            section3Intro: 'No vendemos tu información personal. Solo podemos compartir tus datos en estos casos:',
            section3ConsentLabel: 'Con tu consentimiento',
            section3ConsentBody: 'Cuando eliges compartir grabaciones o datos de perfil con otros usuarios.',
            section3ProvidersLabel: 'Proveedores de servicio',
            section3ProvidersBody: 'Con terceros que nos ayudan a operar la plataforma (por ejemplo, hosting en la nube o procesadores de pago).',
            section3LegalLabel: 'Obligaciones legales',
            section3LegalBody: 'Cuando lo exige la ley o en respuesta a solicitudes legales válidas.',
            section4Title: '4. Seguridad de datos',
            section4Body: 'Implementamos medidas técnicas, administrativas y físicas para proteger tus datos del acceso, uso o divulgación no autorizados. Sin embargo, ningún método de transmisión por internet o almacenamiento electrónico es 100% seguro.',
            section5Title: '5. Tus derechos',
            section5Intro: 'Según tu ubicación, puedes tener derecho a:',
            section5Item1: 'Acceder, actualizar o eliminar tu información personal.',
            section5Item2: 'Restringir u oponerte al procesamiento de tus datos.',
            section5Item3: 'Solicitar una copia de los datos que tenemos sobre ti.',
            section5ContactIntro: 'Para ejercer estos derechos, contáctanos en',
            section6Title: '6. Retención de datos',
            section6Body: 'Conservamos tus datos personales solo el tiempo necesario para brindar nuestros servicios y cumplir los fines descritos en esta política, salvo que la ley exija un período mayor.',
            section7Title: '7. Privacidad de menores',
            section7Body: '{{companyName}} no está dirigido a menores de 13 años (o la edad mínima legal en tu país). No recopilamos intencionalmente información personal de menores sin consentimiento parental.',
            section8Title: '8. Cambios en esta política',
            section8Body: 'Podemos actualizar esta Política de privacidad ocasionalmente. Si hacemos cambios significativos, te avisaremos por correo electrónico o notificación en la app.',
            section9Title: '9. Contáctanos',
            emailLabel: 'Correo:',
            websiteLabel: 'Sitio web:',
            rightsReserved: '© {{year}} VocalCentric. Todos los derechos reservados.',
            navAbout: 'Acerca de',
            navPrivacy: 'Privacidad',
            navTerms: 'Términos',
            navContact: 'Contacto',
        },
        accountDeletion: {
            title: 'Eliminación de cuenta de Google',
            subtitle: 'Esta página explica cómo eliminar tu cuenta de VocalCentric (incluyendo cuentas con Google Sign‑In), qué se elimina y cómo contactarnos.',
            signedInAs: 'Has iniciado sesión como',
            instantDeleteHint: 'Puedes eliminar tu cuenta al instante desde aquí.',
            deleting: 'Eliminando…',
            deleteNow: 'Eliminar mi cuenta ahora',
            submitted: 'Tu solicitud fue enviada. Te enviaremos un correo cuando se complete la eliminación.',
            howToRequest: 'Cómo solicitar la eliminación',
            howToRequestItems: {
                inAppOrForm: 'Usa la opción dentro de la app (Cuenta → Configuración → Eliminar cuenta), o envía el formulario de abajo.',
                verifyOwnership: 'Verificaremos la titularidad mediante tu correo electrónico o sesión activa en la app.',
                deleteAfterVerification: 'Una vez verificado, eliminaremos permanentemente tu cuenta y datos personales, salvo los registros mínimos que debamos conservar por prevención de fraude, seguridad u obligaciones legales.',
            },
            whatWillBeDeleted: 'Qué se eliminará',
            deletedItems: {
                profile: 'Perfil de cuenta (nombre, correo, nombre de usuario y avatar).',
                submissions: 'Envíos de práctica, metadatos de participación en ensayos y publicaciones de la comunidad vinculadas a tu identidad (el contenido puede anonimizarse si eliminarlo rompe conversaciones).',
                history: 'Historial de reproducción, preferencias y asociaciones de dispositivos.',
            },
            retentionLabel: 'Retención:',
            retentionBody: 'Podemos conservar registros mínimos o financieros cuando la ley lo exija, y mantener analítica agregada/anónima que no permita identificarte.',
            googleUsers: 'Usuarios de Google Sign‑In',
            googleUsersBody: 'Si te registraste con Google, eliminar tu cuenta de VocalCentric no elimina tu cuenta de Google. Solo revocamos el acceso de nuestra app y eliminamos tus datos en VocalCentric. También puedes revisar o quitar el acceso de VocalCentric desde tu Cuenta de Google → Seguridad → Acceso de terceros.',
            emailPlaceholder: 'tu@ejemplo.com',
            reasonPlaceholder: 'Opcional: cuéntanos por qué te vas (nos ayuda a mejorar)',
            confirmLabel: 'Confirmo que soy dueño de este correo y deseo eliminar permanentemente mi cuenta de VocalCentric y los datos relacionados.',
            submitting: 'Enviando…',
            submitRequest: 'Enviar solicitud de eliminación',
            needHelp: '¿Necesitas ayuda? Escribe a',
            toast: {
                requestReceived: 'Hemos recibido tu solicitud de eliminación de cuenta.',
                deleted: 'Tu cuenta se eliminó correctamente.',
            },
            error: {
                emailRequired: 'El correo es obligatorio.',
                invalidEmail: 'Ingresa un correo válido.',
                confirmRequired: 'Debes confirmar titularidad e intención de eliminar.',
                unexpected: 'Ocurrió un error inesperado.',
                unableDeleteNow: 'No se puede eliminar la cuenta en este momento.',
            },
        },
    },
    uploads: {
        communityUpload: 'Carga comunitaria',
        title: 'Sube una canción al marketplace',
        subtitle: 'Este flujo replica la configuración interna de canciones, pero envía el contenido al pipeline comunitario del marketplace para creadores autorizados.',
        duplicateTitle: 'Ya enviaste una canción comunitaria con este título',
        steps: {
            information: 'Información',
            vocals: 'Voces',
            lyrics: 'Letra',
            sync: 'Sincronizar',
            files: 'Archivos',
        },
        actions: {
            previous: 'Anterior',
            next: 'Siguiente',
            preview: 'Vista previa',
        },
        toast: {
            submitted: 'Canción comunitaria enviada correctamente',
            submitFailed: 'Falló el envío de la canción',
        },
        submission: {
            saved: 'Envío guardado',
            sentForProcessing: '{{title}} fue enviada para procesamiento en marketplace.',
            processingNote: 'Tu canción se creó correctamente. El empaquetado de audio y la preparación del marketplace continúan en segundo plano, por lo que las vistas previas o controles de listado pueden tardar un poco.',
            goToListings: 'Ir a mis publicaciones',
            uploadAnother: 'Subir otra canción',
            id: 'ID de envío: {{id}}',
        },
        stepOne: {
            songOwnershipType: 'Tipo de propiedad de la canción',
            original: 'Original',
            cover: 'Cover',
            songTitle: 'Título de la canción',
            artistName: 'Nombre del artista',
            writers: 'Compositores',
            album: 'Álbum',
            genre: 'Género',
            label: 'Sello',
            themeLabel: 'Tema',
            chooseTheme: 'Elige un tema',
            theme: {
                praise: 'Alabanza',
                worship: 'Adoración',
                thanksgiving: 'Acción de gracias',
                prayer: 'Oración',
                adoration: 'Adoración',
                faith: 'Fe',
                healing: 'Sanidad',
                salvation: 'Salvación',
                grace: 'Gracia',
                mercy: 'Misericordia',
            },
            bpm: 'BPM',
            timeSignature: 'Compás',
            chooseTimeSignature: 'Elige un compás',
            durationSeconds: 'Duración (segundos)',
            duration: 'Duración',
            key: 'Tonalidad',
            chooseKey: 'Elige una tonalidad',
            year: 'Año',
            tags: 'Etiquetas',
            tagPlaceholder: 'Escribe una etiqueta y presiona espacio o coma',
        },
        stepTwo: {
            whichStem: '¿Qué stem estás subiendo?',
            uploadStem: 'Subir {{stem}}',
            uploadHint: 'Haz clic para subir tu stem pregrabado desde tu computadora o teléfono',
        },
        stepThree: {
            tabs: {
                lyrics: 'Letra',
                mainSolfa: 'Solfa principal',
                tenorSolfa: 'Solfa tenor',
                altoSolfa: 'Solfa alto',
                sopranoSolfa: 'Solfa soprano',
            },
            optionalNote: 'La letra es opcional para canciones comunitarias. Agrega secciones si quieres seleccionar vista previa por secciones, o déjalo vacío y usa un intervalo personalizado en el siguiente paso.',
            startTyping: 'Comienza a escribir {{target}}...',
            uploadMainStemHint: 'Sube primero el stem principal para previsualizar la forma de onda mientras estructuras la letra.',
        },
        stepFour: {
            previewWindow: 'Ventana de vista previa',
            previewDescription: 'Elige qué escucharán primero los compradores. Si tu canción tiene secciones, puedes usar una directamente. Si no, define un intervalo personalizado.',
            previewSource: 'Fuente de vista previa',
            customInterval: 'Intervalo personalizado',
            previewStart: 'Inicio de vista previa',
            previewEnd: 'Fin de vista previa',
            defaultStart: '00:00',
            defaultEnd: '00:20',
            useCurrent: 'Usar actual',
            noLyricsNote: 'La letra es opcional para canciones comunitarias. Si la omites, solo define el intervalo de vista previa arriba.',
            adjusting: 'Ajustando',
            selectLineToSync: 'Selecciona una línea para comenzar la sincronización',
            uploadMainStemToSync: 'Sube el stem principal para alinear los tiempos con la forma de onda.',
        },
        stepFive: {
            imageUploadFailed: 'Error al subir imagen',
            title: 'Sube arte y archivos de soporte',
            subtitle: 'Estos recursos visuales se usarán en la tarjeta del marketplace y en la vista de detalle de la canción.',
            artistImage: 'Imagen del artista',
            uploadArtistImage: 'Haz clic para subir imagen del artista',
            coverArt: 'Arte de portada',
            uploadCoverArt: 'Haz clic para subir portada',
        },
        document: {
            title: 'Subir partitura o documento de soporte',
            description: 'Se admiten PDF y DOCX (máx. 20MB)',
            timeout: 'La subida del documento excedió el tiempo de espera',
            failed: 'Falló la subida del documento',
        },
        preview: {
            customInterval: 'Intervalo personalizado',
            song: 'Canción',
            album: 'Álbum',
            genre: 'Género',
            theme: 'Tema',
            duration: 'Duración',
            stemCount: 'Cantidad de stems',
            previewWindow: 'Ventana de vista previa',
            lyrics: 'Letra',
            sectionsCount: '{{count}} sección(es)',
            optionalNone: 'Opcional, sin contenido',
            previewSource: 'Fuente de vista previa',
            uploadedStems: 'Stems cargados',
            noStems: 'No hay stems cargados',
            submitting: 'Enviando...',
            submit: 'Enviar',
        },
    },
    exercises: {
        actions: {
            backToExercises: 'Volver a ejercicios',
            backToSkill: 'Volver a la habilidad',
            continue: 'Continuar',
            continueWithoutMic: 'Continuar sin micrófono',
            exit: 'Salir',
            gotIt: 'Entendido',
            keepPracticing: 'Seguir practicando',
            listenBack: 'Escuchar de nuevo',
            locked: 'Bloqueado',
            pausePlayback: 'Pausar reproducción',
            play: 'Reproducir',
            playAgain: 'Reproducir de nuevo',
            playExample: 'Reproducir ejemplo',
            practice: 'Practicar {{title}}',
            replay: 'Repetir',
            retry: 'Reintentar',
            saving: 'Guardando...',
            skipStep: 'Omitir paso',
            start: 'Iniciar',
            startBreathCheck: 'Iniciar revisión de respiración',
            startPlan: 'Iniciar plan',
            startPulse: 'Iniciar pulso',
            startRecording: 'Iniciar grabación',
            startTimer: 'Iniciar temporizador',
            stopExample: 'Detener ejemplo',
            tryAgain: 'Intentar de nuevo',
            viewPath: 'Ver sección',
        },
        status: {
            comingSoon: 'Próximamente',
            complete: 'Completo',
            counting: 'Contando...',
            endlessPractice: 'Práctica infinita',
            loadingPianoSamples: 'Cargando muestras de piano...',
            listening: 'Escuchando...',
            noDrillsYet: 'Aún no hay ejercicios',
            recording: 'Grabando...',
            recordingSaved: 'Grabación guardada',
            running: 'En curso...',
        },
        units: {
            bpmPulse: '{{bpm}} BPM · cuenta el pulso',
            drillCount: '{{count}} ejercicio',
            drillCount_other: '{{count}} ejercicios',
            drills: 'Ejercicios',
            min: '{{count}} min.',
            secondEcho: 'Eco de {{count}} segundos',
            skillsDrills: '{{skills}} habilidades - {{drills}} ejercicios',
            stars: 'Estrellas',
            stepCount: '{{count}} pasos',
            steps: 'Pasos',
            stepOfTotal: 'Paso {{step}} de {{total}}',
            unitsDrills: '{{units}} unidades - {{drills}} ejercicios',
        },
        skillTree: {
            benefits: {
                default: 'Un juego breve de práctica de VocalCentric.',
                warmupFoundation: 'Entra en el canto con un breve reinicio vocal antes de un trabajo más intenso.',
                breathControl: 'Desarrolla un flujo de aire más estable para que las frases se sientan más calmadas y controladas.',
                pitchAccuracy: 'Afina la coincidencia de tono y haz que tu oído reaccione más rápido.',
                noteRecognition: 'Desarrolla memoria rápida de nombres de notas con rondas ágiles y sin presión.',
                keyboardNotes: 'Encuentra notas directamente en un teclado estilo piano.',
                intervalBasics: 'Aprende la distancia entre notas con ejercicios de nombrar y emparejar.',
                theoryTerms: 'Convierte vocabulario musical común en memoria rápida y segura.',
                earTrainingBasics: 'Escucha, compara e identifica referencias breves de notas e intervalos.',
            },
            directGames: {
                scaleChoices: {title: 'Opciones de escalas', tag: 'Escalas', purpose: 'Escucha un patrón de escala y luego elige la respuesta.'},
                modeChoices: {title: 'Opciones de modos', tag: 'Modos', purpose: 'Escucha un patrón de modo y luego elige la respuesta.'},
                listenAndChoose: {title: 'Escucha y elige', tag: 'Oído', purpose: 'Escucha una nota y luego elige la respuesta.'},
                hearAndPlay: {title: 'Escucha y toca', tag: 'Teclas', purpose: 'Escucha una nota y luego encuéntrala en el teclado.'},
                hearChords: {title: 'Escuchar acordes', tag: 'Oído', purpose: 'Escucha un acorde y luego nombra su cualidad.'},
                findNotesOnKeys: {title: 'Encontrar notas en teclas', tag: 'Teclas', purpose: 'Toca las notas objetivo directamente en el teclado.'},
                hearIntervals: {title: 'Escuchar intervalos', tag: 'Oído', purpose: 'Escucha dos notas y luego nombra el intervalo.'},
                noteNameSprint: {title: 'Sprint de nombres de notas', tag: 'Notas', purpose: 'Responde rápidamente a indicaciones de nombres de notas.'},
                theoryQuickfire: {title: 'Teoría rápida', tag: 'Teoría', purpose: 'Practica vocabulario musical básico.'},
            },
            empty: 'Aún no hay habilidades de ejercicios disponibles.',
            error: 'No pudimos cargar los ejercicios en este momento.',
            fallbackModuleDescription: 'Ejercicios breves de afinación, ritmo, teoría y entrenamiento auditivo.',
            fallbackModuleTitle: 'Habilidades básicas',
            games: 'Juegos',
            gamesDescription: 'Entra en práctica infinita sin cambiar el progreso del curso.',
            headings: {
                browseLibrary: 'Secciones del curso',
                choosePath: 'Curso de teoría musical',
                continuePractice: 'Continuar práctica',
                recommendedPractice: 'Práctica recomendada',
            },
            libraryDescription: 'Abre una sección para ver sus cuatro unidades en diamante.',
            loading: 'Cargando tu curso de teoría musical...',
            moduleAudience: {
                course: 'Completa estas cuatro unidades como una sección del curso.',
                default: 'Elige esto cuando quieras una ruta de práctica enfocada.',
                musicianship: 'Elige esto cuando quieras juegos musicales rápidos y repetibles.',
                voice: 'Elige esto antes de cantar o ensayar.',
            },
            moduleBenefit: {
                course: 'Desarrolla teoría con lecciones breves, comprobaciones y ejercicios jugables.',
                default: 'Elige un conjunto enfocado de ejercicios breves de VocalCentric.',
                musicianship: 'Entrena notas, intervalos, ritmo e instinto auditivo con juegos rápidos.',
                voice: 'Calienta, controla la respiración y afina el tono antes del ensayo.',
            },
            moreStartedSkills: 'Más habilidades iniciadas que vale la pena terminar después.',
            progress: 'Progreso',
            progressCleared: '{{cleared}}/{{total}} completados',
            prompts: {
                dailyPlan: 'Plan de hoy: {{label}}.',
                dailyPlanFallback: 'El plan de hoy se ajusta a tu progreso reciente en ejercicios.',
                finishNext: 'Termina el siguiente ejercicio mientras está fresco.',
                replaySkill: 'Repite esta habilidad para mejorar velocidad, precisión y confianza.',
                startFocused: 'Comienza con un ejercicio enfocado que desarrolle instinto musical útil.',
            },
            quickGame: {
                buildKeyboard: 'Desarrolla memoria del teclado.',
                ear: 'Oído',
                keys: 'Teclas',
                notes: 'Notas',
                practice: 'Practicar',
                replayImprove: 'Repite para mejorar.',
                runFocused: 'Haz un ejercicio breve y enfocado.',
                speed: 'Velocidad',
                theory: 'Teoría',
                trainListening: 'Entrena el instinto auditivo.',
                practiceMusicIdeas: 'Practica ideas musicales básicas.',
            },
            viewAll: 'Ver todo {{title}}',
            showFewer: 'Mostrar menos {{title}}',
        },
        skillDetail: {
            exerciseNumber: 'Ejercicio {{number}}',
            fallbackDescription: 'Una práctica rápida para agudizar el instinto musical.',
            loadError: 'No pudimos cargar esta habilidad.',
            loading: 'Cargando habilidad...',
            missing: 'Habilidad no encontrada.',
            shortFocused: 'Breve y enfocado.',
            skill: 'Habilidad',
        },
        runner: {
            empty: 'Aún no hay pasos reproducibles para esta habilidad.',
            fallbackPrompt: 'Escucha, elige y confía en tu oído.',
            messages: {
                patternSeen: 'Patrón visto.',
                readyNext: 'Listo para el siguiente paso.',
                referenceHeard: 'Referencia escuchada. Continúa.',
                resetComplete: 'Reinicio completo.',
                skippedForWeb: 'Omitido en web.',
            },
            result: {
                complete: 'Serie completa',
                earnedStars: 'Ganaste {{count}} estrellas en esta ronda.',
                fallback: 'Sigue adelante y tu próxima ronda se sentirá más fluida.',
                niceRun: 'Buena ronda',
                savedLocally: 'Tu resultado se guardó localmente por ahora. Intenta esta serie de nuevo cuando tu conexión esté estable.',
                youFinished: 'Terminaste {{title}}.',
            },
        },
        generated: {
            chooseBest: 'Elige la mejor respuesta.',
            chooseHeard: 'Elige lo que escuchaste',
            namePattern: 'Nombra la {{label}}',
            recallTerm: 'Recuerda el término',
            scale: 'escala',
            mode: 'modo',
            tapNote: 'Toca {{note}}.',
            whatTermMean: '¿Qué significa {{term}}?',
            whichNote: '¿Qué nota escuchaste?',
            whichPattern: '¿Qué {{label}} escuchaste?',
        },
        steps: {
            animation: {
                watchPulse: 'Observa el pulso durante {{count}} tiempos.',
            },
            audioReference: {
                chooseHeard: 'Toca reproducir, escucha con atención y elige lo que escuchaste.',
                fallbackCopy: 'Toca reproducir y escucha el color antes de continuar.',
                heading: 'Escucha la referencia',
                noSource: 'Esta referencia aún no incluye una fuente de audio reproducible en web.',
                pianoUnavailable: 'La reproducción de piano no está disponible en este navegador.',
                samplesLoading: 'Las muestras de piano todavía se están cargando.',
                playFailed: 'No pudimos reproducir esta referencia.',
            },
            meter: {
                breathSkipped: 'Guía de respiración omitida.',
                countPulse: 'Pulso fijado.',
                exhale: 'Exhala',
                followCue: 'Sigue la indicación y mantén una exhalación suave.',
                inhaleSeconds: 'Inhala {{count}}s',
                holdSeconds: 'Sostén {{count}}s',
                keepAirflow: 'Mantén estable el flujo de aire.',
                listeningLevel: 'Escuchando tu nivel de respiración.',
                micFeedback: 'La retroalimentación del micrófono mide la estabilidad de la exhalación.',
                micNeeded: 'Se necesita permiso de micrófono para la retroalimentación de respiración.',
                micUnavailable: 'La entrada de micrófono no está disponible en este navegador.',
                phase: 'Fase',
                phaseReady: 'Listo',
                phaseInhale: 'Inhala',
                phaseHold: 'Sostén',
                phaseExhale: 'Exhala',
                smoothExhale: 'La respiración osciló. Prueba una exhalación más suave.',
                steadyAirflow: 'Ese flujo de aire se mantuvo estable.',
                liveFeedbackUnavailable: 'La retroalimentación de respiración en vivo no está disponible en este navegador.',
            },
            multipleChoice: {
                chooseBest: 'Elige la mejor respuesta.',
                close: 'Casi. Inténtalo una vez más.',
                correct: 'Correcto.',
            },
            pairs: {
                answer: 'Empareja la respuesta',
                complete: 'Pares completos. Un poco más limpio la próxima vez.',
                perfect: 'Pares perfectos.',
                prompt: 'Toca una indicación',
            },
            piano: {
                missed: 'Esa nota no alcanzó el objetivo.',
                playHeard: 'Toca en el teclado lo que escuchaste.',
                right: 'Esa nota es correcta.',
                tapTarget: 'Toca {{note}}.',
                targetNote: 'la nota objetivo',
                unavailable: 'La reproducción de piano no está disponible en este navegador.',
                useReference: 'Usa la tecla marcada {{note}} como referencia de octava.',
            },
            record: {
                challenge: {
                    echoMelody: 'Repite la melodía',
                    holdSteady: 'Mantén {{note}} estable',
                    singBack: 'Cántalo de vuelta',
                },
                coaching: {
                    melody: 'Mantén ligereza y deja que las notas se conecten suavemente.',
                    steady: 'Canta ligero y mantén el tono estable.',
                },
                guide: {
                    close: 'Estás cerca de la melodía.',
                    focus: 'Concéntrate en la forma, no en el volumen.',
                    listening: 'Escuchando tu voz...',
                    moveToward: 'Mantén suavidad y acércate a la melodía.',
                },
                labels: {
                    flow: 'Escucha → Canta → Revisa',
                    melodyNotes: 'Notas de la melodía: {{notes}}',
                },
                messages: {
                    capturedNoTarget: 'Grabación capturada. Este paso necesita una nota objetivo clara antes de que web pueda evaluarlo.',
                    detectFailed: 'No pude detectar una afinación objetivo estable. Intenta una toma más.',
                    drifted: 'Escuché la afinación, pero se desvió de la melodía.',
                    matched: 'Eso coincidió con la forma de la melodía.',
                },
                errors: {
                    micNeeded: 'Se necesita permiso de micrófono para este paso.',
                    playbackUnavailable: 'La reproducción de referencia no está disponible en este navegador.',
                    recordingUnavailable: 'La grabación no está disponible en este navegador.',
                },
            },
            text: {
                fallback: 'Toma esta indicación y continúa.',
            },
            timer: {
                reset: 'Respira, reinicia y vuelve con claridad.',
            },
            unsupported: {
                body: 'Puedes mantener la ronda en marcha.',
                title: 'Este paso de ejercicio aún no está disponible en web.',
            },
        },
        controls: {
            accidentals: 'Alteraciones',
            accidentalsDescription: 'Agrega sostenidos a las opciones de notas.',
            alphabet: 'Alfabeto',
            challenge: 'Desafío',
            difficulty: 'Dificultad',
            difficulty_auto: 'Auto',
            difficulty_easy: 'Fácil',
            difficulty_expert: 'Experto',
            difficulty_hard: 'Difícil',
            difficulty_normal: 'Normal',
            gameSettings: 'Ajustes del juego',
            mixed: 'Mixto',
            notation: 'Notación',
            pad: 'Bordón {{note}}',
            solfege: 'Solfeo',
            tonic: 'Tónica {{note}}',
        },
    },
    training: {
        eyebrow: 'Formación escolar y coral', title: 'Escuelas', subtitle: 'Organiza cursos, clases, tareas, progreso y sesiones en vivo con o sin coro.', choirEyebrow: 'Desarrollo del coro', choirTitle: 'Formación', choirDescription: 'Asigna a miembros seleccionados ejercicios, tareas, comentarios y sesiones en vivo.', choirTab: 'Formación', choirTabDescription: 'Cursos y desarrollo de miembros', workspaces: 'Escuelas', myCohorts: 'Mis clases', courses: 'Cursos', courseDescription: 'Planes reutilizables que pueden asociarse a varias clases.', curriculum: 'Plan de estudios', curriculumDescription: 'Crea un programa ordenado con ejercicios configurados y materiales.', cohorts: 'Clases', cohortsDescription: 'Crea grupos con fechas y asocia cada clase a uno o más cursos.', mappedCourses: 'Cursos asociados', courseClassMappingDescription: 'Las clases pertenecen a la Escuela y pueden usar varios cursos.', classCurriculumDescription: 'Plan de todos los cursos asociados a esta clase.', assignments: 'Tareas', sessions: 'Sesiones', progress: 'Progreso', staff: 'Equipo', students: 'Estudiantes', submissions: 'Entregas', submissionsDescription: 'Revisa cada intento y deja comentarios útiles.', exerciseAssignment: 'Tarea de ejercicio', exerciseAssignmentDescription: 'Completa el ejercicio configurado. Puedes enviar hasta {{count}} intentos.', learningMaterials: 'Materiales de aprendizaje', myAttempts: 'Mis intentos', attemptNumber: 'Intento {{count}}', previewTitle: 'Vista previa del ejercicio', pendingReviews: 'Revisiones pendientes', upcomingSessions: 'Próximas sesiones', pendingInvitations: 'Invitaciones pendientes', workspaceSettings: 'Configuración de la Escuela', courseSettings: 'Configuración del curso', cohortSettings: 'Configuración de la clase', cohortStaff: 'Equipo de la clase', assignmentSettings: 'Configuración de la tarea',
        actions: {
            accept: 'Aceptar', addCourse: 'Añadir curso', addCurriculum: 'Añadir al plan', addStudents: 'Añadir estudiantes', applyInstructor: 'Solicitar crear una Escuela', approve: 'Aprobar', archiveCohort: 'Archivar clase', archiveCourse: 'Archivar curso', archiveWorkspace: 'Archivar Escuela', assignStaff: 'Asignar equipo', back: 'Volver', backToCohort: 'Volver a la clase', backToTeaching: 'Volver a Escuelas', cancel: 'Cancelar sesión', checkIn: 'Registrar asistencia', createCohort: 'Crear clase', createCourse: 'Crear curso', decline: 'Rechazar', edit: 'Editar', editCurriculum: 'Editar elemento', endSession: 'Finalizar sesión', enroll: 'Inscribir usuarios', inviteNewStudent: 'Invitar estudiante nuevo', inviteStaff: 'Invitar al equipo', join: 'Unirse', lowerHand: 'Bajar la mano', manageClasses: 'Gestionar clases', manageTraining: 'Gestionar formación', moveDown: 'Bajar', moveUp: 'Subir', needsImprovement: 'Necesita mejorar', newCohort: 'Nueva clase', newCourse: 'Nuevo curso', newWorkspace: 'Nueva Escuela', open: 'Abrir', openChoir: 'Abrir coro', openCourse: 'Abrir curso', openSchool: 'Abrir Escuela', preview: 'Vista previa', publishAssignment: 'Publicar tarea', raiseHand: 'Levantar la mano', remove: 'Eliminar', resend: 'Reenviar', revoke: 'Revocar', scheduleSession: 'Programar sesión', send: 'Enviar mensaje', sendInvite: 'Enviar invitación', share: 'Compartir', start: 'Iniciar', startAssignment: 'Comenzar tarea', submit: 'Enviar', submitApplication: 'Enviar solicitud',
        },
        fields: {
            assignmentSource: 'Origen de la tarea', assignmentTitle: 'Título de la tarea', attemptsAllowed: 'Intentos permitidos', audioResponse: 'Respuesta de audio (opcional)', choirMembers: 'Elegir miembros del coro', choirPart: 'Cuerda del coro', cohortTitle: 'Nombre de la clase', course: 'Curso', courseTitle: 'Título del curso', description: 'Descripción', dueAt: 'Fecha límite', email: 'Correo', ends: 'Finaliza', enrollmentMode: 'Inscripción', exerciseTemplate: 'Plantilla de ejercicio', feedback: 'Comentarios', instructions: 'Instrucciones', itemType: 'Tipo de elemento', level: 'Nivel', locationMode: 'Ubicación', materialUrl: 'URL del material', passStars: 'Estrellas para aprobar', responseNote: 'Tu respuesta', role: 'Rol', sessionTitle: 'Título de la sesión', starts: 'Comienza', status: 'Estado', studentEmails: 'Correos de estudiantes', title: 'Título', verifiedScore: 'Puntuación verificada', verifiedStars: 'Estrellas verificadas', workspaceName: 'Nombre de la Escuela',
        },
        roles: {owner: 'Propietario', instructor: 'Instructor', assistant: 'Asistente', learner: 'Estudiante'}, statuses: {active: 'Activo', archived: 'Archivado', closed: 'Cerrado', completed: 'Completado', draft: 'Borrador', enrolling: 'Inscripciones abiertas', published: 'Publicado'}, enrollmentModes: {invite: 'Solo invitación', open: 'Inscripción abierta'}, itemTypes: {exercise: 'Ejercicio', material: 'Material didáctico'}, assignmentSources: {curriculum: 'Plan del curso', adhoc: 'Ejercicio puntual configurado'}, locationModes: {virtual: 'Virtual', physical: 'Presencial', hybrid: 'Híbrida'}, units: {assignments: 'tareas', attempts: 'intentos', cohorts: 'cohortes', curriculumItems: 'elementos', learners: 'estudiantes', pending: 'pendientes', submissions: 'entregas'},
        placeholders: {choirPart: 'p. ej., soprano', emails: 'Separa correos con comas o espacios', level: 'p. ej., Principiante', optionalCurriculumTitle: 'Opcional: usa el título del plan'},
        empty: {
            assignmentsTitle: 'Aún no hay tareas', assignmentsDescription: 'Las tareas publicadas aparecerán aquí.', attemptsTitle: 'Aún no hay intentos', attemptsDescription: 'Comienza la tarea cuando estés listo.', choirTrainingTitle: 'La formación no está configurada', choirTrainingDescription: 'Un director o moderador puede crear la Escuela del coro.', classCurriculumDescription: 'Asocia a esta clase un curso con plan.', cohortsTitle: 'Aún no hay clases', cohortsDescription: 'Tus clases activas aparecerán aquí.', courseCohortsDescription: 'Asocia este curso desde una clase de la Escuela.', coursesTitle: 'Aún no hay cursos', coursesDescription: 'Crea cursos reutilizables y asócialos a una o más clases.', curriculumTitle: 'El plan está vacío', curriculumDescription: 'Añade el primer ejercicio o material.', invitationsDescription: 'No hay invitaciones pendientes.', noCourses: 'No hay cursos asociados', noDescription: 'No se proporcionó descripción.', noInstructions: 'No hay instrucciones adicionales.', progressTitle: 'No hay progreso para mostrar', progressDescription: 'Inscribe estudiantes y publica una tarea.', sessionsTitle: 'No hay sesiones programadas', sessionsDescription: 'Las sesiones próximas y en vivo aparecerán aquí.', submissionsTitle: 'Aún no hay entregas', submissionsDescription: 'Los intentos de estudiantes aparecerán aquí.', workspacesTitle: 'Aún no hay Escuela', workspacesDescription: 'Crea una Escuela para tus estudiantes, academia o estudio.',
        },
        errors: {
            archiveCohort: 'No se pudo archivar la clase.', archiveCourse: 'No se pudo archivar el curso.', archiveWorkspace: 'No se pudo archivar la Escuela.', assignStaff: 'No se pudo asignar al miembro del equipo.', attendance: 'No se pudo registrar la asistencia.', createAssignment: 'No se pudo publicar la tarea.', createCohort: 'No se pudo crear la clase.', createCourse: 'No se pudo crear el curso.', createSession: 'No se pudo programar la sesión.', createWorkspace: 'No se pudo crear la Escuela.', endSession: 'No se pudo finalizar la sesión.', enroll: 'No se pudo inscribir a los estudiantes.', instructorApplication: 'No se pudo enviar la solicitud de instructor.', invalidInvitation: 'Este enlace de invitación no es válido.', invitation: 'No se pudo responder a la invitación.', invite: 'No se pudo enviar la invitación.', inviteFirst: 'Invita a estos estudiantes antes de inscribirlos:', load: 'No se pudieron cargar las Escuelas.', loadAssignment: 'No se pudo cargar la tarea.', loadChoirTraining: 'No se pudo cargar la formación del coro.', loadCohort: 'No se pudo cargar la clase.', loadCourse: 'No se pudo cargar el curso.', loadSession: 'No se pudo cargar la sesión.', loadWorkspace: 'No se pudo cargar la Escuela.', mapCourse: 'No se pudieron actualizar los cursos de la clase.', preview: 'No se pudo generar la vista previa.', removeCurriculum: 'No se pudo eliminar el elemento.', removeStaff: 'No se pudo eliminar al miembro del equipo.', reorder: 'No se pudo reordenar el plan.', resendInvitation: 'No se pudo reenviar la invitación.', review: 'No se pudo guardar la revisión.', revokeInvitation: 'No se pudo revocar la invitación.', saveCurriculum: 'No se pudo guardar el elemento.', saveWorkspace: 'No se pudo guardar la Escuela.', startSession: 'No se pudo iniciar la sesión.', submit: 'No se pudo enviar la tarea.', updateAssignment: 'No se pudo actualizar la tarea.', updateCohort: 'No se pudo actualizar la clase.', updateCourse: 'No se pudo actualizar el curso.', updateEnrollment: 'No se pudo actualizar la inscripción.', updateSession: 'No se pudo actualizar la sesión.', updateStaff: 'No se pudo actualizar al miembro del equipo.',
        },
        confirm: {archiveAssignment: '¿Archivar esta tarea? Se conservarán las entregas existentes.', archiveCohort: '¿Archivar esta clase?', archiveCourse: '¿Archivar este curso?', archiveWorkspace: '¿Archivar esta Escuela?', cancelSession: '¿Cancelar esta sesión?', endSession: '¿Finalizar esta sesión en vivo?', removeCourseFromClass: '¿Eliminar este curso de la clase?', removeCurriculum: '¿Eliminar este elemento del plan?', removeStaff: '¿Eliminar a este miembro de la clase?', removeStudent: '¿Eliminar a este estudiante de la clase?'},
        attendanceStatuses: {present: 'Presente', late: 'Tarde', absent: 'Ausente', excused: 'Justificado'},
        classroom: {attendance: 'Asistencia', cancelledDescription: 'Esta sesión fue cancelada.', cancelledTitle: 'Sesión cancelada', chat: 'Chat de clase', chatFailed: 'No se pudo enviar el mensaje.', checkedIn: 'Asistencia registrada', clearContext: 'Borrar contexto compartido', completedDescription: 'Esta sesión ha finalizado.', completedTitle: 'Sesión completada', context: 'Contexto de clase', contextFailed: 'No se pudo compartir el contexto.', handRaiseFailed: 'No se pudo actualizar la mano levantada.', joinFailed: 'No se pudo entrar al aula.', joinMedia: 'Unirse con audio y video', joiningMedia: 'Entrando…', leaveMedia: 'Salir del audio y video', enableAudio: 'Activar audio', listenOnly: 'Estás en modo de escucha. El instructor controla quién puede publicar audio y video.', liveRoom: 'Aula en vivo', mediaJoinFailed: 'No se pudo entrar a la sala de audio y video.', mediaPresenceFailed: 'Entraste a la sala, pero no se pudo actualizar la asistencia.', mediaReady: 'Únete cuando estés listo. Se solicita acceso al micrófono cuando hablas; la cámara está disponible para los instructores.', mediaRenewFailed: 'No se pudo renovar el acceso multimedia del aula.', message: 'Mensaje', muteMicrophone: 'Silenciar micrófono', noContext: 'No hay tareas ni materiales compartidos.', noMessages: 'Aún no hay mensajes.', notCheckedIn: 'Sin registrar', participants: 'Participantes', physicalSession: 'Esta es una sesión presencial. El chat, la asistencia y el contexto compartido siguen disponibles.', present: 'Presente', selfCheckInDescription: 'Registra tu asistencia a esta sesión de clase.', turnCameraOff: 'Apagar cámara', turnCameraOn: 'Encender cámara', unmuteMicrophone: 'Activar micrófono', waitingInstructor: 'Inicia la sesión cuando estés listo. Se notificará a los estudiantes inscritos.', waitingLearner: 'Tu instructor aún no ha iniciado la sesión. Esta página se actualizará automáticamente.', waitingTitle: 'Esperando el inicio de la sesión', you: 'Tú', joinStates: {idle: 'Esperando para entrar', joined: 'Conectado a los controles del aula', joining: 'Entrando al aula'}, mediaStates: {idle: 'Medios sin conectar', joined: 'Audio y video conectados', joining: 'Conectando audio y video', reconnecting: 'Reconectando audio y video'}},
        instructorApplication: {title: 'Solicitud de instructor certificado', description: 'Las Escuelas independientes requieren aprobación. Sube un video breve de enseñanza o actuación y explica tu experiencia.', pending: 'Tu solicitud está pendiente de revisión.', rejected: 'La solicitud anterior no fue aprobada. Actualiza las pruebas y vuelve a enviarla.', video: 'Video de enseñanza o actuación', reason: '¿Por qué deberías recibir aprobación?'},
        invitation: {eyebrow: 'Invitación de enseñanza', title: 'Únete a este espacio de enseñanza', description: 'Acepta para unirte como miembro del equipo o estudiante. La invitación es de un solo uso y está vinculada a tu cuenta.'},
        openEnrollment: {title: 'Únete a esta cohorte', description: 'Inscríbete para recibir tareas, comentarios y sesiones programadas.', unavailable: 'Esta cohorte no acepta tu inscripción. Pide una invitación al instructor.'},
    },
    vocalContributions: {
        title: 'Contribuciones vocales',
        addVocal: 'Agregar vocal',
        tags: {
            popular: 'Popular',
            popularDescription: 'Álbumes más populares',
            new: 'Nuevo',
            newDescription: 'Recién agregado',
        },
        table: {
            title: 'Título',
            dateCreated: 'Fecha de creación',
            plays: 'Reproducciones',
            votes: 'Votos',
            vocal: 'Vocal',
            actions: 'Acciones',
        },
        actions: {
            editEntry: 'Editar entrada',
            delete: 'Eliminar',
        },
        toast: {
            addedToRehearsals: 'Canción agregada a ensayos',
        },
    },
};

export default es;
